export const translationEn = {
  aiProgressNotes: {
    activities: {
      0: 'viewed',
      1: 'created',
      2: 'edited',
      3: 'deleted',
    },
    activitiesDetails: {
      0: 'We viewed an existing {{technique}}',
      1: 'We created a new {{technique}}',
      2: 'We edited an existing {{technique}}',
      3: 'We deleted an existing {{technique}}',
    },
    alternativeDetails: {
      0: 'We reviewed previously documented {{technique}}',
      1: 'We identified and documented a new {{technique}}',
      2: 'We edited a previously documented {{technique}}',
      3: 'We deleted a previously documented {{technique}}',
    },
    weUsed: 'We used the',
    abcModels: {
      technique: 'ABC Model technique',
      title: 'ABC Model',
      b: 'for the thought "{{b}}"',
      a: 'in the situation "{{a}}"',
      emotions: 'with the emotion of {{emotion}} with strength {{strength}}',
      feelings: 'with body sensations of "{{feeling}}"',
      behaviors: 'and the following behavior: "{{behavior}}"',
    },
    behaviorExperiments: {
      technique: 'Behavior Experiment technique',
      typeVariants: ['Active experiment', 'Observational experiment'],
      title: 'Behavior Experiment',
      hypothesisA: 'for the thought (Hyptothesis A) "{{hypothesisA}}"',
      hypothesisB:
        'with an alternative thought (Hyptothesis B) "{{hypothesisB}}"',
      safetyBehaviors: 'and with safety behaviors "{{safetyBehaviors}}"',
      purpose: 'The purpose of the {{type}} was to "{{purpose}}".',
      experiment: 'The experiment itself was "{{experiment}}"',
      time: 'with date, time or duration "{{time}}"',
      place: 'with a place "{{place}}"',
      people: 'with people "{{people}}"',
      resources: 'with resources "{{resources}}"',
      survey: 'with a survey "{{survey}}"',
      followUpExperimentsIdeas:
        'Here are some follow-up experiments ideas: "{{followUpExperimentsIdeas}}"',
    },
    downwardArrows: {
      technique: 'Downward Arrow technique',
      title: 'Downward Arrow',
      startingThought:
        'for the automatic (superficial level) thought "{{startingThought}}"',
      intermediateThought:
        'with an underlying assumption (life rule) "{{intermediateThought}}"',
      deepBelief: 'with a core belief "{{deepBelief}}"',
    },
    exposures: {
      techniques: [
        'Exposure technique',
        'Exposure with Response Prevention technique',
      ],
      titles: ['Exposure', 'Exposure with Response Prevention'],
      titlesHierarchy: [
        'Exposure Hierarchy',
        'Exposure with Response Prevention Hierarchy',
      ],
      fear: 'for the fear or worry "{{fear}}"',
      obsession: 'for the obsession "{{obsession}}"',
      safetyBehaviorsToAvoid:
        'with compulsions (safety behaviors) to avoid "{{safetyBehaviorsToAvoid}}"',
      situationsHierarchy:
        'with situations or stimulus hierarchy: "{{hierarchy}}"',
      lastExpositionSituationTitle:
        'The situation last exposure was made in was "{{title}}"',
      lastExpositionDuration:
        'Last exposure duration was "{{lastExpositionDuration}}"',
      maxSudStrength:
        'Maximum reaction strength (SUD) was "{{maxSudStrength}}"',
      finishSudStrength:
        'final reaction strength (SUD) was "{{finishSudStrength}}"',
      lastExposureNotes: 'Last exposure notes: "{{lastExposureNotes}}"',
    },
    supportingCycles: {
      technique: 'Vicious Cycle (Maintenance Process) technique',
      title: 'Vicious Cycle',
      name: ' named "{{name}}"',
      forThoughts: 'with thoughts, actions or facts: "{{thoughts}}"',
    },
    portalCards: {
      resource: 'portalCards',
      technique: 'a coping card',
      frontSide: 'with the front side: "{{frontSide}}"',
      backSide: 'and the back side: "{{backSide}}"',
    },
    thoughts: {
      technique: 'Dysfunctional Thought Test technique',
      title: 'Dysfunctional Thought Test',
      activatingEvent:
        'The negative thought appeared as a result of the activating event "{{activatingEvent}}"',
      behaviors: 'and the following behavior: "{{behaviors}}"',
      emotions: 'with the emotion of "{{emotion}}" with strength {{strength}}',
      feelings: 'with body sensations of "{{feeling}}"',
      automaticThought: 'for the automatic thought "{{automaticThought}}"',
      thoughtFor:
        'The fact or evidence supporting the negative thought was "{{thoughtFor}}"',
      thoughtsForAlternativeThought:
        'which could have an alternative explanation "{{thoughtsForAlternativeThought}}"',
      thoughtsAgainst:
        'The facts and evidence against the automatic negative thought were "{{thoughtsAgainst}}"',
      cognitiveDistortions:
        'The cognitive distortions for the thought were "{{cognitiveDistortions}}"',
      realisticThoughts:
        'The discovered realistic thoughts were "{{realisticThoughts}}"',
    },
    worryTrees: {
      technique: 'Worry Tree technique',
      title: 'Worry Tree',
      worryAbout: 'for the worrying thought "{{worryAbout}}"',
      options: 'with options "{{options}}"',
      plan: 'with plan "{{plan}}"',
      immediateAction: 'with immediate actions "{{immediateAction}}"',
    },
  },
  alarmPermissionsModal: {
    settingText: 'Open Alarm Permission Settings',
    text: 'You have denied or removed Exact Alarm Permissions for CopingCard.',
    text1:
      'Exact Alarm Permissions are required for us to be able to schedule time-based notifications for you.',
    title: 'Exact Alarm Permissions Disabled!',
  },
  anxietyScreen: {
    dynamics: 'Trends',
    gad7Info:
      'GAD-7 (General Anxiety Disorder-7) is used for rapid screening for the presence of a clinically significant anxiety disorder (one of the four most common anxiety disorders - Generalized Anxiety Disorder, Panic Disorder, Social Phobia and PostTraumatic Stress Disorder), especially in outpatient settings.',
    level: 'Anxiety Level',
    newTest: 'Take a New Assessment',
  },
  auth: {
    notAuthorized: 'You do not have permissions to get this information',
    tokenError: 'Token Verification Error',
  },
  backgroundHeadlessNotification: {
    channelName: 'Background geofencing for location based reminders',
    text: 'Tap to launch CopingCard App',
    title: 'CopingCard Geofencing Notifications are on',
  },
  backgroundLocationAuthorizationAlert: {
    cancelButton: 'Cancel',
    instructions:
      "You have used geolocation notifications for your cards, but you have not provided the required permissions to the location service of your phone. You must enable 'Always' in location services to receive geolocation notifications, or turn off location notifications for cards to not receive this notification.",
    settingsButton: 'Settings',
    titleWhenNotEnabled: 'Location services not enabled',
    titleWhenOff: 'Location services OFF',
  },
  backgroundNotificatoinsPermissionsRationale: {
    message:
      'CopingCard uses your location to deliver location-based coping-card reminders when you enter or leave places you choose — in the background, even when the app is closed or not in use. It is used only for the reminders you set up and is never shared for advertising. Please enable {backgroundPermissionOptionLabel} location access.',
    negativeAction: 'Cancel',
    positiveAction: 'Change to {backgroundPermissionOptionLabel}',
    title: `Allow {applicationName} to access this device location in the background?`,
  },
  autoResetSettingsModal: {
    okButton: 'OK, open settings',
    text: 'Android may pause this app and remove its permissions if it is not opened for a while, which stops your location and time reminders. To keep them reliable, turn off "Pause app activity if unused" in the app settings.',
    title: 'Keep Reminders Working',
  },
  batterySettingsModal: {
    okButton: 'OK, open settings',
    text: 'To ensure notifications are delivered, please disable battery optimization for the app.',
    title: 'Restrictions Detected',
  },
  // P021 (2026-09-19, founder ruling D-g) — the transfer emails and push the API sends. Server-side copy:
  // rendered with the recipient's `lng`, never shown in-app.
  transferNotify: {
    clientEmailSubject: 'Your practice would like to transfer you to another therapist',
    clientEmailGreeting: 'Hi {{name}},',
    clientEmailBody:
      '{{practice}} has asked to transfer your care to {{newTherapist}}. Nothing changes until you approve it.',
    clientEmailAction: 'Open the app to review and approve or decline the request',
    clientEmailWhere: 'In the CopingCard app the request is waiting under Settings → Data Sharing with Therapists.',
    clientPushTitle: 'A transfer request awaits your approval',
    clientPushBody: '{{practice}} would like to transfer your care to {{newTherapist}}. Open Data Sharing to answer.',
    requesterEmailSubject: 'Your client approved the transfer',
    requesterEmailBody:
      '{{client}} approved the transfer to {{newTherapist}}. The client now appears on their Clients page.',
    signature: 'Best regards, the CopingCard team',
  },
  // Q-ru-2 B (2026-10-24) — the invitation e-mail's subject, in the language of the form that sent it (the body is rendered there
  // too). Server-side copy: `sendInvite` takes it from the request's translator.
  inviteMail: {
    subject: 'CopingCard Invitation',
  },
  // E34 · the homework notifier (block 1d, 2026-09-28) — the push and the e-mail the API sends the CLIENT
  // about an assignment. Server-side copy, rendered in the client's `lng`, never shown in-app. It names the
  // therapist and the assignment's title and NOTHING clinical beyond the title (the board's rule).
  homeworkNotify: {
    assigned: {
      title: 'New homework',
      body: '{{therapist}} gave you: “{{title}}”.',
    },
    amended: {
      title: 'Your homework changed',
      body: '{{therapist}} updated “{{title}}”.',
    },
    cancelled: {
      title: 'Homework withdrawn',
      body: '{{therapist}} withdrew “{{title}}” — there is nothing to do.',
    },
    manual: {
      title: 'A homework reminder',
      body: '{{therapist}} reminds you: “{{title}}” is waiting for you.',
    },
    due: {
      title: 'Homework due now',
      body: '“{{title}}” is due now. Open it when you can.',
    },
    overdue: {
      title: 'Homework still waiting',
      body: '“{{title}}” was due two days ago. Do it when you can, or skip it and say why.',
    },
    // block 4 — the founder's Q-e34-12 A: a therapist's reply on the thread names the therapist and the
    // assignment, NEVER the comment text
    commentReply: {
      title: 'A reply on your homework',
      body: '{{therapist}} replied on “{{title}}”.',
    },
    // the founder's Q-b1d-1′ A (2026-09-28): ONE e-mail per client whose app cannot show homework yet
    appUpdate: {
      title: 'Update CopingCard to see your homework',
      body: '{{therapist}} gave you homework in CopingCard. Your version of the app cannot show it yet — update the app and you will find it under Tools → Homework.',
      appStore: 'Update on the App Store (iPhone)',
      googlePlay: 'Update on Google Play (Android)',
    },
    yourTherapist: 'Your therapist',
    emailGreeting: 'Hi {{name}},',
    emailGreetingNoName: 'Hi,',
    emailAction: 'Open it in CopingCard',
    emailWhere: 'In the CopingCard app it is under Tools → Homework.',
    signature: 'Best regards, the CopingCard team',
  },
  // F-199 · the Worry Tree / Vicious Cycle picture, drawn by our API from the text the person typed
  diagram: {
    alt: 'Your diagram',
    unavailable:
      'We could not draw the picture right now. Here is what it says, so nothing is lost:',
  },
  be: {
    tokenNotFound: 'Invite code not found',
    tokenNotValid: 'Invite code not valid',
    noPermissions: 'You do not have permissions to do this action',
    // F-199 · diagramImage refusals; none names the text that was sent
    diagram: {
      error: {
        invalid:
          'This diagram could not be drawn. Open it again, or change it a little and try once more.',
        busy: 'Too many diagrams at once. Wait a minute and try again.',
        failed: 'We could not draw this diagram right now. Please try again in a moment.',
      },
    },
    // P014 (2026-09-13) — the five identity writes that had no ownership check. Each message says
    // what the caller may do instead and names no row id and no other person.
    grantPartyNotFound:
      'We could not find that therapist. Check the invite link or code and try again.',
    notPracticeAdmin:
      'Only a practice administrator can remove someone from their own practice.',
    // the practice-wide client tools (the unassigned pool, transfers, the permanent invite link) — a
    // read as well as a write, so the copy names no act (E50 drive, 2026-09-25)
    practiceAdminOnly: 'Only a practice administrator can do this.',
    // E33/E50 · the backoffice's refusals — the operator reads these in the portal
    backoffice: {
      noSuchAccount: 'No account has this e-mail. Check the address and try again.',
      ambiguousAccount:
        'More than one account has this e-mail. Grant the account from the CLI by its key.',
      revokeRefused:
        'This membership cannot be ended: the person is not a member, or is the last member.',
    },
    erasure: {
      ERASURE_NOT_FOUND: 'No such person. They may already be erased — check the erasure log.',
      ERASURE_CONFIRM_MISMATCH: "The key you typed is not this person's key.",
      ERASURE_REASON_REQUIRED: 'Give the reason for the audit record.',
      ERASURE_BLOCKED: 'The erasure is blocked: {{detail}}',
      ERASURE_SELF: 'You cannot erase your own account from the backoffice.',
      badStatus: 'Unknown status. Use requested, completed or all.',
    },
    notYourInvite:
      'You can only remove an invitation you sent or one addressed to you.',
    notYourRelation:
      'You can only change sharing settings for your own connections.',
    selfGrantRefused: 'A sharing connection needs two different people.',
    // P016 (2026-09-18) — E24 · practiceUserInfoUpdate, board scenario "blank name → error".
    nameRequired: 'Please enter both your first and last name.',
    // P018 (2026-09-19) — E03/E07 · CreateInvite: the mail body named a token other than the invitation's.
    inviteNotPrepared:
      'The invitation could not be prepared. Please try sending it again.',
    // P020 (2026-09-19) — E07 · UpdateSharingPermissions: a relation the client fully revoked cannot be edited back.
    sharingEnded:
      'Sharing with this therapist has ended. To share again, accept a new invitation or link from them.',
    // M7 (E03 + E07) — the two refusals the E-era deciders add that no shipped sentence covers.
    alreadyConnected:
      'You are already connected to this therapist. Change what you share from the Therapists screen.',
    noPendingTransfer:
      'There is no transfer request waiting for an answer. Ask your practice to send a new one.',
  },
  cardNotifications: {
    intro: 'Notifications for realistic thought:',
    reminderLimitTitle: 'Reminder limit reached',
    reminderLimitText:
      "You've reached the free limit of {{count}} time-based reminders. Upgrade for unlimited reminders.",
  },
  cardsScreen: {
    addCard: 'Create a new card',
    editCard: 'Edit the card',
    createFirstCard: 'Create your first Card',
    deleteError:
      'We could not delete this card. Please try again. If it keeps happening, contact support@copingcard.com and mention code CARDS-DELETE-1.',
    resetFilterButton: 'Reset Cards Filter',
    reviewCardTitle: 'Cards Review',
    saveError:
      'We could not save this card. Please try again. If it keeps happening, contact support@copingcard.com and mention code CARDS-SAVE-1.',
    totalCount: 'Total cards count',
  },
  channelsAndCategories: {
    channels: [
      {
        description:
          'This channel is used for general CopingCard notifications like new features, updates, new, etc.',
        groupId: 'CcGeneral',
        id: 'CcGeneralNews',
        name: 'News & Updates',
      },
      {
        description:
          'This channel receives time-based reminders for your coping cards',
        groupId: 'CcCards',
        id: 'CcCardsTime',
        name: 'Card Time-based Reminders',
      },
      {
        description:
          'This channel receives location-based reminders for your coping cards',
        groupId: 'CcCards',
        id: 'CcCardsGeolocation',
        name: 'Card Geolocation Notifications',
      },
      {
        description: 'This channel receives reminders for your scheduled assessments',
        groupId: 'CcTests',
        id: 'CcTests',
        name: 'Scheduled Assessment Reminders',
      },
    ],
    groups: [
      {
        description:
          'This group is used for general CopingCard notifications like new features, updates, news, etc.',
        id: 'CcGeneral',
        name: 'General Notifications',
      },
      {
        description:
          'This group organizes time- and geolocation-based reminders for your Coping Cards',
        id: 'CcCards',
        name: 'Coping Cards Reminders',
      },
      {
        description: 'This group organizes reminders for your scheduled assessments',
        id: 'CcTests',
        name: 'Scheduled Assessment Reminders',
      },
    ],
  },
  common: {
    loadStatus: {
      offlineTitle: 'No internet connection',
      offlineBody: 'We couldn’t load your latest data.',
      serverTitle: 'Can’t reach CopingCard',
      serverBody: 'We couldn’t load your latest data.',
      authBody: 'There was a problem with your session. Please try again.',
      staleNote:
        'Showing your saved data — it will update once the connection is back.',
      retrying: 'Updating…',
      persistentBody:
        'If this keeps happening, contact support@copingcard.com.',
      retry: 'Try again',
    },
    and: 'And',
    authDebugPasswordSignInFailed:
      'We could not finish the debug sign-in request. Please try again. If the issue keeps happening, contact support@copingcard.com and mention code AUTH-DEBUG-1 with status {{status}}.',
    authBootstrapUserEmailRequired:
      'We could not finish setting up your account because your email address is missing. Please sign out and sign in again. If the issue keeps happening, contact support@copingcard.com and mention code AUTH-BOOTSTRAP-1.',
    authBootstrapUserRecordMissing:
      'We could not finish setting up your account. Please close and reopen CopingCard, then try again. If the issue keeps happening, contact support@copingcard.com and mention code AUTH-BOOTSTRAP-2.',
    authBootstrapSettingUp: 'Setting up your account…',
    authBootstrapOffline:
      "You're offline. CopingCard will finish setting up as soon as you're back online.",
    authBootstrapServerTrouble:
      "We're having trouble reaching CopingCard. We'll keep trying…",
    authBootstrapSlow:
      'This is taking longer than usual. Check your connection, or try again.',
    authBootstrapSessionExpired:
      'Your session has expired. Please sign out and sign in again.',
    authSessionProviderRequired:
      'We could not load this part of the app. Please close and reopen CopingCard. If the issue keeps happening, contact support@copingcard.com and mention code AUTH-SESSION-1.',
    back: 'Back',
    cancel: 'Cancel',
    confirm: 'Confirm',
    continue: 'Continue',
    copyToClipboard: 'Copy to Clipboard',
    delete: 'Delete',
    done: 'done',
    edit: 'Edit',
    emailTo: 'to',
    goBack: 'Go Back',
    help: 'Help',
    keyboardDone: 'Done',
    learnMore: 'Learn More',
    na: 'N/A',
    no: 'no',
    noResults: 'No results',
    ok: 'Ok',
    optionalData: 'Optional Data',
    or: 'or',
    sort: 'Sort',
    sortAscending: 'Sort Ascending',
    sortDescending: 'Sort Descending',
    readMore: 'More',
    save: 'Save',
    search: 'Search',
    selectDate: 'Select Date',
    selected: 'selected',
    send: 'send',
    timezone: 'Timezone',
    tryAgain: 'try again',
    yes: 'yes',
    next: 'Next',
    unsavedChanges: 'You have Unsaved Changes',
    returnToScreen: 'Return to the Current Screen',
    saveAndGoBack: 'Save and Go Back',
    discardAndGoBack: 'Discard and Go Back',
    moveUp: 'Move Up',
    moveDown: 'Move Down',
    start: 'Start',
    stop: 'Stop',
    createdAt: 'Created at',
    failedToFetchImage: 'Failed to fetch image',
    uploadSuccess: 'Upload Success',
    close: 'Close',
    suffix_ordinal_one: 'st',
    suffix_ordinal_two: 'nd',
    suffix_ordinal_few: 'rd',
    suffix_ordinal_other: 'th',
    areYouSure: 'Are you sure?',
  },
  countriesFallback: [
    {
      name: 'Afghanistan',
      value: 'AF',
    },
    {
      name: 'Åland Islands',
      value: 'AX',
    },
    {
      name: 'Albania',
      value: 'AL',
    },
    {
      name: 'Algeria',
      value: 'DZ',
    },
    {
      name: 'American Samoa',
      value: 'AS',
    },
    {
      name: 'Andorra',
      value: 'AD',
    },
    {
      name: 'Angola',
      value: 'AO',
    },
    {
      name: 'Anguilla',
      value: 'AI',
    },
    {
      name: 'Antarctica',
      value: 'AQ',
    },
    {
      name: 'Antigua and Barbuda',
      value: 'AG',
    },
    {
      name: 'Argentina',
      value: 'AR',
    },
    {
      name: 'Armenia',
      value: 'AM',
    },
    {
      name: 'Aruba',
      value: 'AW',
    },
    {
      name: 'Australia',
      value: 'AU',
    },
    {
      name: 'Austria',
      value: 'AT',
    },
    {
      name: 'Azerbaijan',
      value: 'AZ',
    },
    {
      name: 'Bahamas',
      value: 'BS',
    },
    {
      name: 'Bahrain',
      value: 'BH',
    },
    {
      name: 'Bangladesh',
      value: 'BD',
    },
    {
      name: 'Barbados',
      value: 'BB',
    },
    {
      name: 'Belarus',
      value: 'BY',
    },
    {
      name: 'Belgium',
      value: 'BE',
    },
    {
      name: 'Belize',
      value: 'BZ',
    },
    {
      name: 'Benin',
      value: 'BJ',
    },
    {
      name: 'Bermuda',
      value: 'BM',
    },
    {
      name: 'Bhutan',
      value: 'BT',
    },
    {
      name: 'Bolivia',
      value: 'BO',
    },
    {
      name: 'Bosnia and Herzegovina',
      value: 'BA',
    },
    {
      name: 'Botswana',
      value: 'BW',
    },
    {
      name: 'Bouvet Island',
      value: 'BV',
    },
    {
      name: 'Brazil',
      value: 'BR',
    },
    {
      name: 'British Indian Ocean Territory',
      value: 'IO',
    },
    {
      name: 'British Virgin Islands',
      value: 'VG',
    },
    {
      name: 'Brunei',
      value: 'BN',
    },
    {
      name: 'Bulgaria',
      value: 'BG',
    },
    {
      name: 'Burkina Faso',
      value: 'BF',
    },
    {
      name: 'Burundi',
      value: 'BI',
    },
    {
      name: 'Cambodia',
      value: 'KH',
    },
    {
      name: 'Cameroon',
      value: 'CM',
    },
    {
      name: 'Canada',
      value: 'CA',
    },
    {
      name: 'Cape Verde',
      value: 'CV',
    },
    {
      name: 'Caribbean Netherlands',
      value: 'BQ',
    },
    {
      name: 'Cayman Islands',
      value: 'KY',
    },
    {
      name: 'Central African Republic',
      value: 'CF',
    },
    {
      name: 'Chad',
      value: 'TD',
    },
    {
      name: 'Chile',
      value: 'CL',
    },
    {
      name: 'China',
      value: 'CN',
    },
    {
      name: 'Christmas Island',
      value: 'CX',
    },
    {
      name: 'Cocos (Keeling) Islands',
      value: 'CC',
    },
    {
      name: 'Colombia',
      value: 'CO',
    },
    {
      name: 'Comoros',
      value: 'KM',
    },
    {
      name: 'Cook Islands',
      value: 'CK',
    },
    {
      name: 'Costa Rica',
      value: 'CR',
    },
    {
      name: "Cote d'Ivoire",
      value: 'CI',
    },
    {
      name: 'Croatia',
      value: 'HR',
    },
    {
      name: 'Cuba',
      value: 'CU',
    },
    {
      name: 'Curaçao',
      value: 'CW',
    },
    {
      name: 'Cyprus',
      value: 'CY',
    },
    {
      name: 'Czech Republic',
      value: 'CZ',
    },
    {
      name: 'Democratic Republic of the Congo',
      value: 'CD',
    },
    {
      name: 'Denmark',
      value: 'DK',
    },
    {
      name: 'Djibouti',
      value: 'DJ',
    },
    {
      name: 'Dominica',
      value: 'DM',
    },
    {
      name: 'Dominican Republic',
      value: 'DO',
    },
    {
      name: 'Ecuador',
      value: 'EC',
    },
    {
      name: 'Egypt',
      value: 'EG',
    },
    {
      name: 'El Salvador',
      value: 'SV',
    },
    {
      name: 'Equatorial Guinea',
      value: 'GQ',
    },
    {
      name: 'Eritrea',
      value: 'ER',
    },
    {
      name: 'Estonia',
      value: 'EE',
    },
    {
      name: 'Eswatini',
      value: 'SZ',
    },
    {
      name: 'Ethiopia',
      value: 'ET',
    },
    {
      name: 'Falkland Islands',
      value: 'FK',
    },
    {
      name: 'Faroe Islands',
      value: 'FO',
    },
    {
      name: 'Fiji',
      value: 'FJ',
    },
    {
      name: 'Finland',
      value: 'FI',
    },
    {
      name: 'France',
      value: 'FR',
    },
    {
      name: 'French Guiana',
      value: 'GF',
    },
    {
      name: 'French Polynesia',
      value: 'PF',
    },
    {
      name: 'French Southern Territories',
      value: 'TF',
    },
    {
      name: 'Gabon',
      value: 'GA',
    },
    {
      name: 'Gambia',
      value: 'GM',
    },
    {
      name: 'Georgia',
      value: 'GE',
    },
    {
      name: 'Germany',
      value: 'DE',
    },
    {
      name: 'Ghana',
      value: 'GH',
    },
    {
      name: 'Gibraltar',
      value: 'GI',
    },
    {
      name: 'Greece',
      value: 'GR',
    },
    {
      name: 'Greenland',
      value: 'GL',
    },
    {
      name: 'Grenada',
      value: 'GD',
    },
    {
      name: 'Guadeloupe',
      value: 'GP',
    },
    {
      name: 'Guam',
      value: 'GU',
    },
    {
      name: 'Guatemala',
      value: 'GT',
    },
    {
      name: 'Guernsey',
      value: 'GG',
    },
    {
      name: 'Guinea',
      value: 'GN',
    },
    {
      name: 'Guinea-Bissau',
      value: 'GW',
    },
    {
      name: 'Guyana',
      value: 'GY',
    },
    {
      name: 'Haiti',
      value: 'HT',
    },
    {
      name: 'Heard Island and McDonald Islands',
      value: 'HM',
    },
    {
      name: 'Honduras',
      value: 'HN',
    },
    {
      name: 'Hong Kong',
      value: 'HK',
    },
    {
      name: 'Hungary',
      value: 'HU',
    },
    {
      name: 'Iceland',
      value: 'IS',
    },
    {
      name: 'India',
      value: 'IN',
    },
    {
      name: 'Indonesia',
      value: 'ID',
    },
    {
      name: 'Iran',
      value: 'IR',
    },
    {
      name: 'Iraq',
      value: 'IQ',
    },
    {
      name: 'Ireland',
      value: 'IE',
    },
    {
      name: 'Isle of Man',
      value: 'IM',
    },
    {
      name: 'Israel',
      value: 'IL',
    },
    {
      name: 'Italy',
      value: 'IT',
    },
    {
      name: 'Jamaica',
      value: 'JM',
    },
    {
      name: 'Japan',
      value: 'JP',
    },
    {
      name: 'Jersey',
      value: 'JE',
    },
    {
      name: 'Jordan',
      value: 'JO',
    },
    {
      name: 'Kazakhstan',
      value: 'KZ',
    },
    {
      name: 'Kenya',
      value: 'KE',
    },
    {
      name: 'Kiribati',
      value: 'KI',
    },
    {
      name: 'Kosovo',
      value: 'XK',
    },
    {
      name: 'Kuwait',
      value: 'KW',
    },
    {
      name: 'Kyrgyzstan',
      value: 'KG',
    },
    {
      name: 'Laos',
      value: 'LA',
    },
    {
      name: 'Latvia',
      value: 'LV',
    },
    {
      name: 'Lebanon',
      value: 'LB',
    },
    {
      name: 'Lesotho',
      value: 'LS',
    },
    {
      name: 'Liberia',
      value: 'LR',
    },
    {
      name: 'Libya',
      value: 'LY',
    },
    {
      name: 'Liechtenstein',
      value: 'LI',
    },
    {
      name: 'Lithuania',
      value: 'LT',
    },
    {
      name: 'Luxembourg',
      value: 'LU',
    },
    {
      name: 'Macao',
      value: 'MO',
    },
    {
      name: 'Madagascar',
      value: 'MG',
    },
    {
      name: 'Malawi',
      value: 'MW',
    },
    {
      name: 'Malaysia',
      value: 'MY',
    },
    {
      name: 'Maldives',
      value: 'MV',
    },
    {
      name: 'Mali',
      value: 'ML',
    },
    {
      name: 'Malta',
      value: 'MT',
    },
    {
      name: 'Marshall Islands',
      value: 'MH',
    },
    {
      name: 'Martinique',
      value: 'MQ',
    },
    {
      name: 'Mauritania',
      value: 'MR',
    },
    {
      name: 'Mauritius',
      value: 'MU',
    },
    {
      name: 'Mayotte',
      value: 'YT',
    },
    {
      name: 'Mexico',
      value: 'MX',
    },
    {
      name: 'Micronesia',
      value: 'FM',
    },
    {
      name: 'Moldova',
      value: 'MD',
    },
    {
      name: 'Monaco',
      value: 'MC',
    },
    {
      name: 'Mongolia',
      value: 'MN',
    },
    {
      name: 'Montenegro',
      value: 'ME',
    },
    {
      name: 'Montserrat',
      value: 'MS',
    },
    {
      name: 'Morocco',
      value: 'MA',
    },
    {
      name: 'Mozambique',
      value: 'MZ',
    },
    {
      name: 'Myanmar',
      value: 'MM',
    },
    {
      name: 'Namibia',
      value: 'NA',
    },
    {
      name: 'Nauru',
      value: 'NR',
    },
    {
      name: 'Nepal',
      value: 'NP',
    },
    {
      name: 'Netherlands',
      value: 'NL',
    },
    {
      name: 'New Caledonia',
      value: 'NC',
    },
    {
      name: 'New Zealand',
      value: 'NZ',
    },
    {
      name: 'Nicaragua',
      value: 'NI',
    },
    {
      name: 'Niger',
      value: 'NE',
    },
    {
      name: 'Nigeria',
      value: 'NG',
    },
    {
      name: 'Niue',
      value: 'NU',
    },
    {
      name: 'Norfolk Island',
      value: 'NF',
    },
    {
      name: 'North Korea',
      value: 'KP',
    },
    {
      name: 'North Macedonia',
      value: 'MK',
    },
    {
      name: 'Northern Mariana Islands',
      value: 'MP',
    },
    {
      name: 'Norway',
      value: 'NO',
    },
    {
      name: 'Oman',
      value: 'OM',
    },
    {
      name: 'Pakistan',
      value: 'PK',
    },
    {
      name: 'Palau',
      value: 'PW',
    },
    {
      name: 'Palestine',
      value: 'PS',
    },
    {
      name: 'Panama',
      value: 'PA',
    },
    {
      name: 'Papua New Guinea',
      value: 'PG',
    },
    {
      name: 'Paraguay',
      value: 'PY',
    },
    {
      name: 'Peru',
      value: 'PE',
    },
    {
      name: 'Philippines',
      value: 'PH',
    },
    {
      name: 'Pitcairn',
      value: 'PN',
    },
    {
      name: 'Poland',
      value: 'PL',
    },
    {
      name: 'Portugal',
      value: 'PT',
    },
    {
      name: 'Puerto Rico',
      value: 'PR',
    },
    {
      name: 'Qatar',
      value: 'QA',
    },
    {
      name: 'Republic of the Congo',
      value: 'CG',
    },
    {
      name: 'Reunion',
      value: 'RE',
    },
    {
      name: 'Romania',
      value: 'RO',
    },
    {
      name: 'Russia',
      value: 'RU',
    },
    {
      name: 'Rwanda',
      value: 'RW',
    },
    {
      name: 'Saint Barthélemy',
      value: 'BL',
    },
    {
      name: 'Saint Helena',
      value: 'SH',
    },
    {
      name: 'Saint Kitts and Nevis',
      value: 'KN',
    },
    {
      name: 'Saint Lucia',
      value: 'LC',
    },
    {
      name: 'Saint Martin',
      value: 'MF',
    },
    {
      name: 'Saint Pierre and Miquelon',
      value: 'PM',
    },
    {
      name: 'Saint Vincent and the Grenadines',
      value: 'VC',
    },
    {
      name: 'Samoa',
      value: 'WS',
    },
    {
      name: 'San Marino',
      value: 'SM',
    },
    {
      name: 'Sao Tome and Principe',
      value: 'ST',
    },
    {
      name: 'Saudi Arabia',
      value: 'SA',
    },
    {
      name: 'Senegal',
      value: 'SN',
    },
    {
      name: 'Serbia',
      value: 'RS',
    },
    {
      name: 'Seychelles',
      value: 'SC',
    },
    {
      name: 'Sierra Leone',
      value: 'SL',
    },
    {
      name: 'Singapore',
      value: 'SG',
    },
    {
      name: 'Sint Maarten',
      value: 'SX',
    },
    {
      name: 'Slovakia',
      value: 'SK',
    },
    {
      name: 'Slovenia',
      value: 'SI',
    },
    {
      name: 'Solomon Islands',
      value: 'SB',
    },
    {
      name: 'Somalia',
      value: 'SO',
    },
    {
      name: 'South Africa',
      value: 'ZA',
    },
    {
      name: 'South Georgia and the South Sandwich Islands',
      value: 'GS',
    },
    {
      name: 'South Korea',
      value: 'KR',
    },
    {
      name: 'South Sudan',
      value: 'SS',
    },
    {
      name: 'Spain',
      value: 'ES',
    },
    {
      name: 'Sri Lanka',
      value: 'LK',
    },
    {
      name: 'Sudan',
      value: 'SD',
    },
    {
      name: 'Suriname',
      value: 'SR',
    },
    {
      name: 'Svalbard and Jan Mayen',
      value: 'SJ',
    },
    {
      name: 'Sweden',
      value: 'SE',
    },
    {
      name: 'Switzerland',
      value: 'CH',
    },
    {
      name: 'Syria',
      value: 'SY',
    },
    {
      name: 'Taiwan',
      value: 'TW',
    },
    {
      name: 'Tajikistan',
      value: 'TJ',
    },
    {
      name: 'Tanzania',
      value: 'TZ',
    },
    {
      name: 'Thailand',
      value: 'TH',
    },
    {
      name: 'Timor-Leste',
      value: 'TL',
    },
    {
      name: 'Togo',
      value: 'TG',
    },
    {
      name: 'Tokelau',
      value: 'TK',
    },
    {
      name: 'Tonga',
      value: 'TO',
    },
    {
      name: 'Trinidad and Tobago',
      value: 'TT',
    },
    {
      name: 'Tunisia',
      value: 'TN',
    },
    {
      name: 'Turkey',
      value: 'TR',
    },
    {
      name: 'Turkmenistan',
      value: 'TM',
    },
    {
      name: 'Turks and Caicos Islands',
      value: 'TC',
    },
    {
      name: 'Tuvalu',
      value: 'TV',
    },
    {
      name: 'U.S. Outlying Islands',
      value: 'UM',
    },
    {
      name: 'U.S. Virgin Islands',
      value: 'VI',
    },
    {
      name: 'Uganda',
      value: 'UG',
    },
    {
      name: 'Ukraine',
      value: 'UA',
    },
    {
      name: 'United Arab Emirates',
      value: 'AE',
    },
    {
      name: 'United Kingdom',
      value: 'GB',
    },
    {
      name: 'United States',
      value: 'US',
    },
    {
      name: 'Uruguay',
      value: 'UY',
    },
    {
      name: 'Uzbekistan',
      value: 'UZ',
    },
    {
      name: 'Vanuatu',
      value: 'VU',
    },
    {
      name: 'Vatican City',
      value: 'VA',
    },
    {
      name: 'Venezuela',
      value: 'VE',
    },
    {
      name: 'Vietnam',
      value: 'VN',
    },
    {
      name: 'Wallis and Futuna',
      value: 'WF',
    },
    {
      name: 'Western Sahara',
      value: 'EH',
    },
    {
      name: 'Yemen',
      value: 'YE',
    },
    {
      name: 'Zambia',
      value: 'ZM',
    },
    {
      name: 'Zimbabwe',
      value: 'ZW',
    },
  ],
  depressionScreen: {
    dynamics: 'Trends',
    level: 'Depression Level',
    newTest: 'Take a New Assessment',
    phq9Info:
      'PHQ-9 (Patient Health Questionnaire-9) is a multipurpose instrument for screening, diagnosing, monitoring and measuring the severity of depression. PHQ-9 demonstrated good reliability and validity. It is a simple, rapid, effective, and reliable tool for screening and evaluation of the severity of depression.',
  },
  downgradeDetectedModal: {
    contactTherapist:
      'If you had your Premium access provided via a Mental Health Professional/Provider, please contact them to regain access.',
    contactSupport: 'If you think it is a mistake, please contact support at: ',
    downgrade: 'Downgrade my experience',
    notificationsTurnOff:
      'Some of your notifications and reminders will be turned off.',
    pay: 'Keep my paid features',
    text: 'Your subscription is no longer valid. Unless you subscribe again the paid features will be turned off. In particular you will lose access to:',
    title: 'Subscription Not Valid',
  },
  errorModal: {
    clientErrors: 'App Errors',
    code: 'Code',
    contact:
      'Try again or reload the app. If the issue persists, please contact us at: ',
    contactCodeLabel: 'Support code',
    extraInfo: 'Extra Info',
    graphqlAuthorizationError: 'You do not have access to this right now.',
    graphqlErrors: 'Graphql Errors',
    graphqlRequestError: 'We could not complete your request.',
    location: 'Location',
    message: `Message`,
    name: 'Name',
    network: 'Network error',
    networkRequestError: 'Network request error',
    // P015 · the calm, classified copy a person's failed write gets when the transport fails.
    // Never the raw "Network request failed" — and never shown for a background operation.
    offlineBody: 'Check your connection and try again.',
    offlineTitle: `You're offline`,
    path: 'Path',
    reminderSaveError:
      'We could not save your reminder. Please try again. If it keeps happening, contact support@copingcard.com.',
    title: `Oops! We've got some errors.`,
    tokenExpiredTitle: 'Your session has expired',
    tokenError: 'Your token is invalid or expired. Please sign in again.',
    tokenSettings:
      'You can manage Sign-in settings in Settings -> Privacy Settings',
    unreachableBody:
      'Please try again in a moment. If it keeps happening, contact support@copingcard.com.',
    unreachableTitle: `We couldn't reach our server`,
  },
  confirmModal: {
    cancelButton: 'Cancel',
    confirmButton: 'Confirm',
  },
  crisis: {
    crisisText: `If you are experiencing a mental health crisis and need immediate help, please contact your country or local crisis line.`,
    courage:
      'Remember, it takes courage to reach out for help, and there is no shame in seeking support for your mental health. You are not alone, and there are people and resources available to help you through this difficult time.',
    findCrisisLine: 'find a Crisis Line',
    selfHelp: 'Self-Help',
    mammalianText:
      'The Mammalian Diving Reflex is a physiological response that occurs in mammals, including humans, when they are submerged in water. This reflex triggers a series of automatic changes in the body, including a decrease in heart rate and constriction of blood vessels, in order to conserve oxygen and allow for extended periods of underwater activity. While the Mammalian Diving Reflex is typically associated with diving and swimming, recent research suggests that intentionally triggering this reflex through practices such as cold water immersion or breath-holding can help alleviate symptoms of anxiety and stress.',
    instructionsLink: 'Read Instructions',
    muscleRelaxationTitle: 'Progressive Muscle Relaxation by Jacobson',
    muslceRelaxationText:
      'Progressive Muscle Relaxation is a relaxation technique developed by physician Edmund Jacobson in the early 20th century that involves systematically tensing and relaxing different muscle groups in the body. The technique is designed to help individuals recognize and release physical tension in the body, which in turn can reduce feelings of anxiety and stress. Research has shown that regular practice of Progressive Muscle Relaxation can lead to significant reductions in anxiety and related symptoms, as well as improvements in sleep quality and overall well-being.',
    technique54321Text:
      'The 5-4-3-2-1 technique is a simple mindfulness exercise that can be used to reduce feelings of anxiety and stress. The technique involves engaging each of the senses in order to ground oneself in the present moment and distract from anxious thoughts. This is done by identifying and focusing on five things you can see, four things you can touch, three things you can hear, two things you can smell, and one thing you can taste. By focusing on sensory experiences in the present moment, individuals can shift their attention away from anxious thoughts and into the present moment, leading to a reduction in feelings of anxiety and stress.',
    goToTool: 'Go to the tool',
    meditationsText:
      'Mindfulness meditation is a technique that involves intentionally paying attention to present moment experiences, such as thoughts, emotions, and sensations, without judgment. Regular practice of mindfulness meditation has been shown to have a range of beneficial effects on mental health, including reducing symptoms of anxiety and stress. This is thought to be due to the fact that mindfulness meditation can help individuals develop greater awareness and acceptance of their thoughts and emotions, leading to a reduction in the tendency to become caught up in negative thought patterns and rumination. Additionally, mindfulness meditation has been shown to have positive effects on brain function, leading to increased emotional regulation and decreased reactivity to stressors.',
    goToMediations: 'Go to Meditations',
    // P036 (founder D1 A, 2026-09-29) — the line where clients write: nothing is watched as it is written
    entryNote: 'What you write here is not monitored in real time.',
    entryNoteLink: 'Crisis lines and techniques',
  },
  urgentCrisis: {
    internationlHelp:
      'If you are in another country, you can find a list of crisis lines in your country at',
    // D-crisis-by-language-2026-10-11: the English reader's single world line (Russian keeps `internationlHelp`, "another country")
    internationlHelpOutsideUS:
      'Outside the United States, you can find a list of crisis lines for your country at',
    internationlHelpName: 'International Association for Suicide Prevention',
    ifUS: 'If you are in the United States, please call',
    orText: 'or text',
    orChat: 'or chat at',
    pleaseCall: 'please call',
    ifBY: 'If you are in Belarus,',
    ifUA: 'If you are in Ukraine,',
    ifRU: 'If you are in Russia,',
    // P043 (founder Q1 C + Q2 C, 2026-10-10): one list for both app languages, the picked country first; the hours sit in
    // the sentence where a line is not open round the clock (Q3-c A + C).
    ifKZ: 'If you are in Kazakhstan,',
    ifKG: 'If you are in Kyrgyzstan,',
    ifLV: 'If you are in Latvia,',
    ifLT: 'If you are in Lithuania,',
    ifAM: 'If you are in Armenia, on weekdays 9:00–18:00,',
    ifEE: 'If you are in Estonia, daily 10:00–24:00,',
    ifEERu: 'In Estonia, in Russian, from 19:00 to 7:00,',
    shortNumbersNote: 'Short numbers work only from a phone in that country.',
    // D-crisis-world-selector-2026-10-11: ONE "Your country" control over every country (names from `countriesFallback`)
    pickerTitle: 'Your country',
    pickerHint:
      'Choose your country and its lines come first. This stays on this phone and is not sent anywhere.',
    pickerOthers: 'Other countries',
    pickerSearch: 'Search for a country',
    pickerNoMatch: 'No country matches that search.',
    pickerClose: 'Close',
    // no declension in the sentence: a Russian country name stays in its dictionary form
    helplineIn: 'Your country: {{country}}. Crisis lines for it are listed on',
    helplineLink: 'the Find A Helpline directory',
    findCrisisLine: 'view the list of Crisis Lines',
  },
  mammalianReflex: {
    warning:
      '⚠️ Contraindications! Activating the diving reflex slows the heart rate. People with cardiac problems (particularly those with bradycardia) should avoid this strategy. Do not use this strategy if you have similar problems or if you are not sure if you have them. Consult your physician before use.',
    instructions: 'Instructions',
    details: `When we are in a state of extreme emotional arousal, our brain does not function properly to effectively absorb new information and process it. We need to "reset" our nervous system!\n
How can you help yourself if, while you are in an emotional state of agitation, you realize you need to calm down, but you are lack of internal resources and the advice to "calm down" only annoys you?\n
👉 An option to solve this problem is to use a psychophysiological effect available to every mammal, which is called the "diver reflex".\n
How to activate the reflex:
➡️ fill a bowl with ice water (50 degrees Fahrenheit / 10 degrees Celsius)
➡️ lean in and hold your breath
➡️ lower your face in ice water for 30 seconds
➡️ check: the area under the eyes/over the cheekbones (the most sensitive part of the face) should feel ice water\n
These elementary actions make the parasympathetic nervous system turn on - a person relaxes and calms down😇\n
✅ Life hack: the technique works its best if you hold your breath and bend over for 30 seconds.
    `,
  },
  technique54321: {
    title: '5-4-3-2-1 Grounding Technique',
    instructions: `The 5-4-3-2-1 technique is a grounding exercise that can help you to reduce anxiety and feel more present in the moment. Here are the steps to follow:\n
Find a quiet and comfortable place to sit or stand.\n
Take five deep breaths. As you breathe in, imagine that you are filling your lungs with calmness, and as you breathe out, imagine that you are releasing any tension or anxiety.\n
5. Next, look around and identify five things you can see. These could be objects in the room or outside, anything you can see in your surroundings. Focus on each item for a moment, and try to observe its shape, color, texture, and any other details that you notice.\n
4. Then, identify four things you can feel. This could be the texture of your clothes, the sensation of your feet on the ground, the temperature of the air around you, or anything else you can physically feel. Pay attention to each sensation, and try to describe it to yourself in as much detail as possible.\n
3. Next, identify three things you can hear. This could be the sound of traffic outside, the hum of your computer, the rustle of leaves in the wind, or anything else you can hear. Focus on each sound for a moment, and try to discern any patterns, rhythms, or tones that you notice.\n
2. Then, identify two things you can smell. This could be the scent of flowers, food cooking, perfume, or anything else you can smell. Take a deep breath and try to focus on the scent.\n
1. Finally, identify one thing you can taste. This could be the taste of your favorite food, drink, or something you can find in your surroundings. Take a moment to savor the taste and focus on it.\n
By the end of this exercise, you should feel more grounded, centered, and present in the moment. It is a great way to take a break from negative thoughts and anxiety, and to feel more connected to your surroundings.
    `,
  },
  fBConsentModal: {
    agreeButton: 'Accept and use Facebook SDK',
    cancelButton: 'Cancel',
    text: 'We need your consent to allow Facebook SDK initialization and events logging to enable Facebook Sign In / Sign Up.',
    title: 'Facebook SDK Consent',
  },
  flippingCard: {
    automaticThought: 'Automatic thought',
    cardName: 'Card name',
    categoriesSelectText: 'Choose thought categories',
    editEvent: 'Go to Activating Event',
    realisticThoughts: 'Realistic thoughts',
    supportingThoughts: 'Supporting thoughts',
    confirmCardDeleteTitle: 'Card deletion',
    confirmCardDeleteText: `Are you sure you want to delete this coping card?

  The card will be deleted permanently together with its related thought analysis, time-based and geolocation reminders.
    `,
  },
  muscleRelaxation: {
    videoTitle: 'Watch Video with Instructions',
    readTitle: 'Read Instructions',
    videoId: 'ihO02wUzgkc',
    phasesAndStepsTitle: 'Phases and Steps',
    phasesAndStepsText: `Jacobson's progressive muscle relaxation method eliminates anxiety in stressful situations. The relaxation process goes through the following phases.\n
1. Attempt to relax.
2. Relaxation.
3. Observation of the process of transition from tension to relaxation.
4. "Experiencing" relaxation.\n\n
Relaxation occurs in stages.
Relaxation of the muscles in your arms.
Relaxation of the muscles in your face.
Relaxation of the muscles of your neck and back.
Relaxation of the muscles of the lower part of your body.
Specific exercises correspond to each relaxation step.\n
Mastering these relaxation techniques will help to restore neuropsychic balance in the shortest possible time, to feel rested and full of energy.
`,
    armsTitle: 'Relaxing arms muscles (4-5 minutes)',
    armsText: `Make yourself comfortable (sitting or lying).

Relax as much as you can. With complete relaxation, clench the fist of your right arm, while controlling the degree of compression, feel the tension in the muscles of the arm, forearm - open your fist and feel relaxation. Compare your feelings.

Clench your fist again as tightly as possible - hold. Open your fist, try to achieve deep relaxation. Compare your feelings.

Repeat everything with your left arm. During this time, the whole body remains completely relaxed.

Squeeze the fingers of both arms into a fist.

Feel the tension in your fingers and forearms.

Open your fingers and relax. Compare your feelings. Continue relaxing.

Bend your right arm at the elbow and tighten your biceps.

Tighten the biceps as much as possible, control the tension of the biceps.

Extend your elbow, relax your biceps and feel the difference. Try to feel the relaxation of the biceps as much as possible.

Tighten your biceps again, maintain tension, feel the degree of tension.

Relax completely. Compare your feelings.

Constantly focus your attention on the sensations of tension and relaxation.

Repeat the same with your left arm.

Repeat the same with both arms at the same time.

Vary the degree and duration of muscle tension before relaxing. Compare your feelings. Extend your arms forward and feel the tension in your triceps. Return your arms to their original position, relax, feel the difference in sensations.

Repeat one more time. Compare your feelings again. Now try to completely relax the muscles of the arms without pre-tensioning.

Continue to relax more and more, achieve deeper relaxation.

Notice the feeling of warmth and heaviness in your arms as you relax. Arms relaxed and heavy... relaxed and heavy.
`,
    faceTitle: 'Relaxation of facial muscles (4-5 minutes)',
    faceText: `Wrinkle your forehead, raise your eyebrows.

Wrinkle your forehead more... and relax.

Move your eyebrows and note the tension.

Relax and smooth your brows.

Close your eyes tightly, feel the tension... and relax without opening your eyes.

Feel the relaxation of the muscles of the forehead, eyes.

Clench your teeth tightly, tighten your jaws. Feel the tension in your jaws.

Relax, open your mouth a little.

Press the tongue firmly against the upper palate. Feel the tension of the tongue...and relax by lowering the tongue.

Round your lips as if you want to say the letter "o", relax.

Feel the difference between tension and relaxation.

Feel the relaxation of all the muscles of your face: forehead, eyes, jaws, tongue relax. Relax completely.

Feel the warmth and heaviness in all the muscles of the face.
`,
    neckTitle: 'Relaxation of the muscles of the neck and back (4-5 minutes)',
    neckText: `Concentrate on the muscles of the neck.

Tilt your head back as much as possible, feel the tension in your neck.

Turn your head all the way to the left. Note the tension.

Turn your head to the right to failure, feel the tension.

Return your head to the starting position.

Relax. Compare your feelings.

Tilt your head forward, touch your chin to your chest. Feel the tension in your neck. Return your head to the starting position.

Relax, feel warm and relaxed.

Raise your shoulders to your ears, bring your shoulder blades together without straining your arms. Make a circular movement with your shoulders with maximum amplitude.

Return your shoulders to their original position. Relax. Feel the pleasant contrast between tension and relaxation.

Arch your spine and feel tension along your spine.

Return to starting position. Feel the relaxation, it spreads all over your back.

The back is heavy and warm. Feel the pleasant warmth...
`,
    legsTitle: 'Lower body relaxation (4-5 minutes)',
    legsText: `Concentrate on the lower body.

Tighten your buttocks and thighs, pressing your heels firmly into the ground.

Relax... Note the difference in sensations.

Tighten your buttocks and thighs again.

Keep them tense.

Keeping tension in the buttocks and hips, bend your feet, toes towards your face, feel the tension in the calf muscles.

Relax. Even deeper... deeper.

Feel the relaxation of all the muscles in your lower body.

Notice how your legs get heavier as you relax. The legs are relaxed and heavy.

Feel the warmth spreading through your legs.

Legs are heavy and warm.
    `,
    summary: `Once you have completed the entire sequence, take a few deep breaths and scan your body for any remaining areas of tension.

If you find any areas that are still tense, repeat the relaxation exercise for those muscles.

When you are finished, take a few more deep breaths and slowly open your eyes.

By practicing Progressive Muscle Relaxation regularly, you can become more aware of your body and learn to recognize when you are holding tension in your muscles. This technique can help you reduce stress and promote relaxation in your daily life.   
    `,
  },
  gad7: {
    q1: `Feeling nervous, anxious or on edge`,
    q2: `Not being able to stop or control worrying`,
    q3: `Worrying too much about different things`,
    q4: `Trouble relaxing`,
    q5: `Being so restless that it is hard to sit still`,
    q6: `Becoming easily annoyed or irritable`,
    q7: `Feeling afraid as if something awful might happen`,
    score: `GAD-7 Score`,
    severity: `Anxiety Severity`,
    title: `GENERAL ANXIETY DISORDER-7 (GAD-7)`,
  },
  insights: {
    cardsFlipped: 'Coping Cards Viewed',
    dayRemindersTitle: 'Time-based Reminders Usage',
    emptyStateDescription:
      'Use Coping Cards and reminders for a bit longer, then reopen Insights to see your activity trends here.',
    emptyStateTitle: 'Not enough activity yet',
    locationRemindersTitle: 'Geolocation Notifications Usage',
    missingCardDescription:
      'This card is no longer available, but its past usage is still included in your Insights history.',
    missingCardTitle: 'Card unavailable',
    mostUsedCards: 'Most Used Cards',
    opened: 'Opened',
    triggered: 'Triggered',
    triggeredOpenedRatio: 'Percent Opened of Triggered',
    meditationsTitle: 'Meditations Listened',
  },
  inviteTherapistModal: {
    recipientLanguage: "Recipient's language",
    title: 'Invite a Mental Health Professional',
    description:
      'Invite a therapist to join the CopingCard Provider Platform so that you could share your data with them to make your therapy more effective.',
    noName:
      'It looks like you have not entered your name yet. Please enter your name so that we could mention it in the invitation email.',
    yourName: 'Your First Name',
    yourLastName: 'Your Last Name',
    therapistInfo: 'Mental Health Professional Info',
    firstName: 'First Name',
    lastName: 'Last Name',
    therapistEmail: 'Email',
    sendInvite: 'Send Invite',
    emailText: 'Invite Email Text Preview',
    inviteText: `
Hi {{firstName}} {{lastName}},

{{yourName}} {{yourLastName}} invites you to join the CopingCard Provider Platform.

Click the link above to accept the invitation and or create your account and accept the invitation.

This would allow for effective information and progress sharing during therapy.

Best regards,
CopingCard, Inc. Team
    `,
    inviteTextHtml: `
    <p>Hi {{firstName}} {{lastName}},</p>
    <p>{{yourName}} {{yourLastName}} invites you to join the <b><a href="{{link}}">CopingCard</a></b> Provider Platform.
    <br />
    <p>Click the link above to accept the invitation and or create your account and accept the invitation.</p>
    <br />
    <p>This would allow for effective information and progress sharing during therapy.</p>
    <br />
    <p>Best regards,</p>
    <p>CopingCard, Inc. Team</p>
    `,
  },
  labels: {
    email: 'Email',
    password: 'Password',
  },
  locationReminders: {
    onApproaching: 'Notify when approaching',
    onLeaving: 'Notify when leaving',
  },
  locationModal: {
    addLocation: 'Add location',
    locationName: 'Location name',
    savedLocations: 'Saved Locations',
    searchPlaceholder: 'Search',
    selectSavedLocation: 'Select from saved locations',
    waitingForLocation: 'Detecting your location…',
  },
  meditations: {
    loading: 'Loading meditations. It can take some time on the first load...',
    // E54 — the voice setting (a control above the list) and the label on each card
    voice: {
      label: 'Voice',
      female: 'Female',
      male: 'Male',
      both: 'Both',
      cardFemale: 'Female voice',
      cardMale: 'Male voice',
    },
  },
  navigation: {
    appBlockModalText:
      'The app is blocked from receiving notifications, which makes receiving reminders not possible. Please go to the Settings and enable notifications.',
    backButtonTitle: 'Back',
    blockModalTitle: 'Restrictions Detected',
    channelBlockModalText:
      'The notifications channel is blocked from receiving notifications, which makes receiving reminders not possible. Please go to the Settings and enable notifications.',
    channelGroupBlockModalText:
      'The notifications channel group is blocked from receiving notifications, which makes receiving reminders not possible. Please go to the Settings and enable notifications.',
    toCopingCards: 'Go To Coping Cards',
  },
  notificationPermissionsModal: {
    settingText: 'Open Notification Settings',
    text: 'You have denied or removed Notification Permissions for CopingCard.',
    text1:
      'Notification Permissions are required for us to be able to send notifications to you.',
    text2:
      'Tap the button below to open your notification settings, then turn notifications on for CopingCard.',
    title: 'Notification Permissions Disabled!',
  },
  notifications: {
    locationReminderBody:
      'You triggered a geolocation reminder for your thought',
    locationReminderTitle: 'Geolocation Reminder',
    testReminderBody: 'It is time to take your scheduled assessment',
    testReminderTitle: 'Scheduled Assessment Reminder',
    timeNotificationBody: 'It is time to recall your new thought',
    timeNotificationTitle: 'Time-based notification',
    fineLocatonPermissionTitle: 'Please allow fine location permission',
    fineLocatonPermissionText:
      'Fine location permission is required to show your location on the map.',
  },
  phq9: {
    q1: `Little interest or pleasure in doing things`,
    q2: `Feeling down, depressed, or hopeless`,
    q3: `Trouble falling or staying asleep, or sleeping too much`,
    q4: `Feeling tired or having little energy`,
    q5: `Poor appetite or overeating`,
    q6: `Feeling bad about yourself — or that you are a failure or have let yourself or your family down`,
    q7: `Trouble concentrating on things, such as reading the newspaper or watching television`,
    q8: `Moving or speaking so slowly that other people could have noticed? Or the opposite — being so fidgety or restless that you have been moving around a lot more than usual`,
    q9: `Thoughts that you would be better off dead or of hurting yourself in some way`,
    score: `PHQ-9 Score`,
    severity: `Depression Severity`,
    title: `PATIENT HEALTH QUESTIONNAIRE-9 (PHQ-9)`,
  },
  // E44 · the biometric app lock (cc-account, chapter "Client Runtime — App lock (mobile, E44)"). privacy.lock.* = the setup
  // (Settings → Privacy → App lock), privacy.lock.off.* = its Turn off section, privacy.gate.* = the unlock gate,
  // privacy.reminder.* = the neutral text every reminder carries while the lock is on (Q-e44-2 A), privacy.errors.* = the
  // deciders' refusals. Founder ruling 2026-10-16: nothing opens without unlocking, so the gate has no other buttons.
  privacy: {
    lock: {
      open: 'App lock',
      openHint: 'Open CopingCard with Face ID, a fingerprint or your passcode',
      require: {
        faceId: 'Require Face ID',
        touchId: 'Require Touch ID',
        fingerprint: 'Require fingerprint',
        iris: 'Require iris scan',
        biometric: 'Require Face ID or fingerprint',
        passcode: 'Require phone passcode',
      },
      intro: 'Your journal, cards and plans stay private if someone else picks up your phone.',
      lockAfter: 'Lock after',
      timeouts: {
        immediately: 'Immediately',
        min1: '1 min',
        min5: '5 min',
        min15: '15 min',
      },
      reminders: 'While the lock is on, reminders say only "A reminder from CopingCard".',
      everything:
        'While the lock is on, everything in CopingCard opens only after unlocking. The check-in widget on your home screen still saves your mood.',
      footer: 'Uses the Face ID, fingerprint or passcode already on your phone. CopingCard never sees them.',
      noPasscode: 'Set a passcode on your phone first. Then you can turn on the app lock.',
      passcodeRemoved:
        'Your phone has no passcode now, so CopingCard opens without unlocking. Set a passcode in your phone settings to use the app lock again.',
      prompt: 'Confirm to turn on the app lock',
      promptChange: 'Confirm to change the app lock',
      checkFailed: 'The check did not go through. Try again.',
      saveError: 'The app lock could not be saved. Check your connection and try again.',
      off: {
        hint: {
          faceId: 'Confirm with Face ID to turn the lock off.',
          touchId: 'Confirm with Touch ID to turn the lock off.',
          fingerprint: 'Confirm with your fingerprint to turn the lock off.',
          iris: 'Confirm with an iris scan to turn the lock off.',
          biometric: 'Confirm with Face ID or your fingerprint to turn the lock off.',
          passcode: 'Confirm with your phone passcode to turn the lock off.',
        },
        prompt: 'Confirm to turn off the app lock',
        error: 'The app lock could not be turned off. Check your connection and try again.',
      },
    },
    gate: {
      title: 'CopingCard is locked',
      hintFaceId: 'Look at your phone to unlock',
      hint: 'Unlock to open CopingCard',
      unlock: {
        faceId: 'Unlock with Face ID',
        touchId: 'Unlock with Touch ID',
        fingerprint: 'Unlock with fingerprint',
        iris: 'Unlock with iris scan',
        biometric: 'Unlock',
        passcode: 'Unlock with passcode',
      },
      usePasscode: 'Use passcode',
      prompt: 'Unlock CopingCard',
    },
    reminder: {
      neutral: 'A reminder from CopingCard',
      // Q-e44g1-3 A — the homework e-mail fallback while any of the person's phones has the lock on
      emailSubject: 'A reminder from CopingCard',
      emailBody: 'A reminder from CopingCard — open the app.',
      emailAction: 'Open CopingCard',
    },
    errors: {
      APP_LOCK_TIMEOUT_INVALID: 'Choose one of the times offered: immediately, 1, 5 or 15 minutes.',
      APP_LOCK_NOT_ENABLED: 'The app lock is already off on this phone.',
    },
  },
  privacySettings: {
    accept: 'Accept',
    agree: 'Accept and Save Settings',
    // E50 · the in-app deletion request (App Store 5.1.1(v)) — the operator erases within 30 days
    deleteTitle: 'Delete my account',
    deleteExplain:
      'Ask us to delete your account and everything in it: your cards, thought tests, tools, reminders, assessments and your sign-in. We delete it within 30 days.',
    deleteButton: 'Delete my account',
    deleteConfirmTitle: 'Delete your account?',
    deleteConfirmText:
      'We will delete your account and all your data within 30 days. If you worked with a therapist through CopingCard, their practice keeps its own records of your work together, including any consent form you signed with your name. This does not cancel a subscription bought in the App Store or Google Play — cancel it in your store settings.',
    deletePending:
      'You asked to delete your account on {{requestedAt}}. We will delete it by {{dueBy}}. To withdraw the request or ask a question, write to',
    deleteFailed:
      'We could not send your request. Check your connection and try again.',
    // the confirm screen (founder 2026-09-27: a red button, and a typed word so the person stops and thinks)
    deleteConfirmWord: 'DELETE',
    deleteTypeToConfirm: 'To confirm, type {{word}} below.',
    deleteFinalButton: 'Yes, delete my account',
    errorsTracking: 'Errors Info Collection',
    errorsTrackingInfo:
      'Collect the errors and crashes info to assist with fixes and ease support.',
    iAgree: 'I agree to the',
    keepSignedIn: 'Keep me Signed-In',
    keepSignedInInfo: `I do not want the app to log me out frequently.`,
    keepSignedInWarning: `
      WARNING! If you turn the setting on and someone gets unauthorized access to your phone (e.g. it is stolen and not password-protected while still having internet access) it can lead to a leak of your personal health information.
      We strongly encourage you to keep the setting off.
      `,
    mainTerms:
      'Please read and accept the Privacy Policy and the Terms of Service to use the application',
    optionalSettings: 'Optional Privacy Settings',
    productEmailNotify: 'Receive Updates Emails',
    productEmailNotifyInfo:
      'Send me information about products, services, updates, deals, or recommendations by email.',
    productPushNotify: 'Receive App Updates in-app Notifications',
    productPushNotifyInfo:
      'Send me information about products, services, updates, deals, or recommendations via push notifications.',
    restoreSubscription: 'Restore Subscription',
    usageTracking: 'Application Usage Google Analytics Tracking',
    usageTrackingInfo:
      'Collect information on screens I open in the app with the help of Google Analytics to help improve the app.',
  },
  questionariesShared: {
    actions: `Typically Proposed Treatment Actions`,
    actions0: `None`,
    actions1: `Watchful waiting; repeat {{test}} at follow-up`,
    actions2: `Treatment plan, considering counseling, follow-up and/or pharmacotherapy`,
    actions3: `Active treatment with pharmacotherapy and/or psychotherapy`,
    actions4: `Immediate initiation of pharmacotherapy and, if severe impairment or poor response to therapy, expedited referral to a mental health specialist for psychotherapy and/or collaborative management`,
    answer0: `Not at all`,
    answer1: `Several days`,
    answer2: `More than half the days`,
    answer3: `Nearly every day`,
    backToTests: 'Go back to assessments',
    disclaimer:
      'DISCLAIMER: Even though the {{test}} shows high reliability and validity, it cannot substitute medical advice, diagnosis or treatment by a mental health professional. This app does not provide medical advice. It is intended for informational purposes only. Never ignore professional medical advice in seeking treatment because of something you have read in our application or website. If you think you may have a medical emergency, immediately call your doctor or dial 911(or your emergency service number).',
    extraQuestion1: `How difficult have these problems made it for you to do your work, take care of things at home, or get along with other people?`,
    extraQuestionAnswer0: `Not difficult at all`,
    extraQuestionAnswer1: `Somewhat difficult`,
    extraQuestionAnswer2: `Very difficult`,
    extraQuestionAnswer3: `Extremely difficult`,
    intro1: `Over the last 2 weeks, how often have you been bothered by the following problem?`,
    nextQuestion: `Next Question`,
    score: `{{test}} Score`,
    // E06 — the ES lane can now REFUSE a save (the server-side score recompute, founder G1
    // 2026-08-28), and the shipped screen swallowed every error. This is the fallback the screen
    // shows when the server sent no readable copy; a coded refusal uses the server's own sentence.
    saveError:
      'We could not save this assessment. Please check your connection and try again — if it keeps happening, contact support@copingcard.com.',
    seeResult: 'See Result',
    severity0: `None-minimal`,
    severity1: `Mild`,
    severity2: `Moderate`,
    severity3: `Moderately Severe`,
    severity4: `Severe`,
    // GAD-7's lowest band (P041): the authors' word, where PHQ-9's severity0 says "None-minimal".
    // The key ENDS in its level digit — both surfaces read the swatch from it.
    severityMinimal0: `Minimal`,
    testReminder: 'Next Assessment Reminder',
    testResult: 'Assessment Result',
    seeTherapistsText:
      'Do you want to search for Mental Health Professionals who use CopingCard as part of their treatment process?',
    seeTherapists: 'Go to Therapists Search',
  },
  rnPaperDates: {
    close: 'Close',
    dateIsDisabled: 'Day is not allowed',
    mustBeBetween: (startDate: any, endDate: any) =>
      `Must be between ${startDate} - ${endDate}`,
    mustBeHigherThan: (date: any) => `Must be later then ${date}`,
    mustBeLowerThan: (date: any) => `Must be earlier then ${date}`,
    next: 'Next',
    notAccordingToDateFormat: (inputFormat: any) =>
      `Date format must be ${inputFormat}`,
    pickDateFromCalendar: 'Pick date from calendar',
    previous: 'Previous',
    save: 'Save',
    selectMultiple: 'Select dates',
    selectRange: 'Select period',
    selectSingle: 'Select date',
    typeInDate: 'Type in date',
  },
  screens: {
    // E35
    assessments: 'Questionnaires',
    // E44
    appLock: 'App lock',
    // E38
    safetyPlan: 'Safety plan',
    safetyPlanEdit: 'Edit safety plan',
    abcModel: 'ABC Model',
    abcModels: 'ABC Models',
    anxiety: 'Anxiety',
    article: 'Article',
    articles: 'Articles',
    audio: 'Audio',
    behaviorExperiment: 'Behavior Experiment',
    behaviorExperiments: 'Behavior Experiments',
    behaviorExperimentDetail: 'Experiment',
    behaviorExperimentObservation: 'Observation',
    behaviorExperimentComplete: 'Complete Experiment',
    unfinishedBehaviorExperiments: 'Unfinished / Drafts',
    cardNotifications: 'Coping Card Notifications',
    // E05 · R1 — the Reminder Schedule Picker (E-era only; the shipped app has no picker).
    reminderSchedulePicker: 'Reminder schedule',
    // E34 · Homework on the phone (block 1c)
    myHomework: 'Homework',
    checkIn: 'Check-in',
    diaryCard: 'Diary card',
    diaryCardSetup: 'My diary card',
    diaryCardWeek: 'My week',
    myCheckIns: 'My check-ins',
    myPathways: 'My programs',
    pathwayProgram: 'Program',
    courses: 'Programs',
    homeworkAssignment: 'Homework',
    homeworkSkip: 'Skip homework',
    worksheetForm: 'Worksheet',
    worksheetOverTime: 'Over time',
    worksheetEntry: 'Worksheet entry',
    // E34 block 6 — the homework video player (a practice's YouTube / Vimeo link)
    homeworkVideo: 'Video',
    addMyHomework: 'Add my own',
    copingCard: 'Coping Card',
    copingCards: 'Coping Cards',
    crisis: 'Crisis',
    urgentCrisis: 'Urgent Crisis',
    depression: 'Depression',
    downwardArrow: 'Downward Arrow',
    downwardArrows: 'Downward Arrows',
    exposures: 'Exposures',
    exposure: 'Exposure',
    exposureSituation: 'Exposure Situation',
    gad7: 'GAD-7',
    generalSettings: 'General Settings',
    home: 'Home',
    info: 'Info',
    insights: 'Insights',
    // E07 (M7) — the two new sharing routes' navigation titles.
    joinPractice: 'Join your practice',
    transferRequestPrompt: 'Transfer request',
    learn: 'Learn',
    mammalianReflex: 'Mammalian Diving Reflex',
    muscleRelaxation: 'Muscle Relaxation',
    technique54321: '5-4-3-2-1 Technique',
    meditations: 'Meditations',
    notificationsSettings: 'Notifications Settings',
    passwordReset: 'Reset Password',
    phq9: 'PHQ-9',
    privacy: 'Privacy Policy',
    privacySettings: 'Privacy Settings',
    deleteAccount: 'Delete account',
    saas: 'Software Services Agreement for Health Care Providers',
    settings: 'Settings',
    signIn: 'Sign In',
    subscription: 'Subscription Management',
    viciousCycles: 'Vicious Cycles',
    viciousCycle: 'Vicious Cycle',
    terms: 'Terms & Conditions',
    tests: 'Assessments',
    therapist: 'Mental Health Professional',
    therapists: 'Search Mental Health Professionals',
    therapistMessage: 'Message Therapist',
    therapistsSharing: 'Data Sharing with Therapists',
    thoughtsTesting: 'Dysfunctional Thoughts Test',
    thoughtsTestingLocation: 'Event Location',
    unfinishedThoughtTests: 'Unfinished Thought Tests',
    toolKit: 'Toolkit',
    tools: 'Tools',
    video: 'Video',
    worryTrees: 'Worry Trees',
    worryTree: 'Worry Tree',
  },
  sendTherapistMessageModal: {
    title: 'Send Email to the Therapist',
    message: 'Enter Your Message',
  },
  settings: {
    chooseLanguage: 'Choose Your Language',
    languageEnglish: 'English',
    languageRussian: 'Russian',
    displayName: 'Display name',
    displayNameHint:
      'Display name comes from the OAuth provider you used to log in with, like Facebook or Google',
    email: 'Email',
    firstName: 'First name',
    lastName: 'Last name',
    profileInfo: 'User Info',
    reminders: 'Reminders',
    remindersCount: 'Total reminders',
    remindersEmptyState:
      'No thought reminders are available yet. Enable reminders from a coping card or thought flow, then manage them here.',
    loadError:
      'We could not load your settings right now. Please close and reopen CopingCard, then try again. If it keeps happening, contact support@copingcard.com and mention code SETTINGS-LOAD-1.',
    saveSettings: 'Save Settings',
    saveError:
      'We could not save your settings. Please try again. If it keeps happening, contact support@copingcard.com and mention code SETTINGS-SAVE-1.',
    searchTimezone: 'Search Country or Timezone',
    signOut: 'Sign Out',
    userId: 'User ID',
    userIdCopied: 'User ID Copied to Clipboard',
  },
  signIn: {
    // accessibility labels of the password field's eye toggle (restored 2026-09-07)
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    authEmailInUse: 'That email address is already in use!',
    authEmailInvalid: 'That email address is invalid!',
    authFacebookCancel: 'User canceled the login/signup process.',
    authNoToken: 'Something went wrong obtaining {{token}} access token',
    authAppleSimulatorUnavailable:
      'Apple sign-in failed in the iOS simulator. Retry on a real device, or remove the Simulator entry from your Apple account device list and try again.',
    authAppleUnavailable:
      'Sign in with Apple did not work on this phone. Please try again, or sign in with Google or your email. If it keeps happening, contact support@copingcard.com and mention code AUTH-APPLE-1.',
    authAppleAccountExists:
      'This email already has a CopingCard account with a different sign-in. Please sign in the way you did before — with Google or with your email and password.',
    authAppleFailed:
      'Sign in with Apple did not finish. Please try again. If it keeps happening, contact support@copingcard.com and mention code AUTH-APPLE-3.',
    authProviderConnectedTitle: '{{token}} sign-in connected',
    authSignedInAs: 'Signed in as {{email}}',
    authProviderCompleted: '{{token}} sign-in completed successfully.',
    authUserNotFound: 'We have no user with this email!',
    // E50: a saved session whose account was deleted (at the person's request, or otherwise)
    accountGoneTitle: 'This account no longer exists',
    accountGoneText:
      'It may have been deleted at your request. You can sign in with another account or create a new one at any time.',
    authWeakPassword: 'That password is not strong enough!',
    authWrongPassword: 'The password is wrong for this user!',
    newPasswordTitle: 'Set New Password',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    newPasswordSubmit: 'Set Password',
    checkEmailAgain: `Still no email or not sure you entered the correct one?`,
    checkEmailSpam: `If you do not receive an email from us within several minutes, check your spam folder to make sure the email is not there.`,
    websiteOpenInstructions:
      'If the link to verify email opens in a browser instead of our Mobile app, you will need to close and re-open the Mobile app for the verification to work.',
    checkEmailTitle: `Reset Email Sent`,
    confirmEmailTitle: 'Confirmation Email Sent',
    confirmPassword: 'Confirm password',
    email: 'Email address',
    appleSignIn: 'Sign In with Apple',
    appleSignUp: 'Sign Up with Apple',
    facebookSignUp: 'Sign Up with Facebook',
    facebooSignIn: 'Sign In with Facebook',
    forgotPassword: 'Forgot password?',
    googleSignIn: 'Sign In with Google',
    googleSignUp: 'Sign Up with Google',
    noAccount: 'Do not have an account yet?',
    password: 'Password',
    passwordEmailHint:
      'Please provide the email you registered with so that we could send you a password reset email. Please click the link in the email on your phone to proceed.',
    passwordHint:
      'The password should be at least 8 characters long. Adding numbers, uppercase letters, and special characters is encouraged but not required.',
    passwordResetFinished:
      'We have updated your password. You will be automatically redirected to the Sign In screen shortly.',
    reset: 'Reset',
    resetTitle: 'Reset your password',
    signIn: 'Sign In',
    signUp: 'Sign up',
    title: 'Welcome Back to CopingCard',
    tryAnother: 'Still no email?',
    tryAnotherButton: 'Go back to Sign In',
  },
  states: [
    'Alabama',
    'Alaska',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Puerto Rico',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'Washington, DC',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
  ],
  subscription: {
    feature1: 'Unlimited Time-based Reminders',
    feature2: 'Unlimited Worry Trees',
    feature3: 'Unlimited Geolocation Notifications',
    feature4: 'Unlimited PHQ-9 Depression and GAD-7 Anxiety Assessments',
    feature5: 'Unlimited Meditations Listening',
    feature6: 'Unlimited Behavior Experiments',
    feature7: 'Unlimited history in Insights/Stats',
    feature8: 'Unlimited Downward Arrows',
    feature9: 'Unlimited Expositions',
    feature10: 'Unlimited AI-generated Images',
    featureDescription1: 'Free accounts get only 9 active time-based reminders',
    featureDescription2: 'Free accounts can create only 1 Worry Tree per day',
    featureDescription3:
      'Free accounts get only 2 active geolocation notifications',
    featureDescription4:
      'Free accounts can have PHQ-9 and GAD-7 tests only once every 2 weeks',
    featureDescription5:
      'Free accounts can listen to a meditation only once every 3 days',
    featureDescription6:
      'Free accounts can create Behavior Experiments only once every 3 days',
    featureDescription7: 'Free accounts get only 1 month of statistics',
    featureDescription8:
      'Free accounts can create only 2 Downard Arrows per day',
    featureDescription9:
      'Free accounts can create an Exposure only once every 3 days',
    featureDescription10:
      'Free accounts can create only 3 AI-generated images per day',
    month_one: 'month',
    month_other: 'months',
    noSubscriptionText:
      'We did not receive any purchases to restore from the app store. If you believe it is a mistake, please contact us at support@copingcard.com',
    noSubscriptionTitle: 'No purchases to restore',
    notNow: 'Not now',
    restoreUnavailableText:
      'We could not contact the store to restore your purchases. Please try again in a moment. If it keeps happening, contact support@copingcard.com.',
    restoreSubscription: 'Restore Subscription',
    paymentInfo1:
      'Pricing will be automatically converted into your local currency. Payment will be charged to {{store}} Account upon confirmation of purchase.',
    paymentInfo2:
      'Subscription will renew automatically unless auto-renew is turned off at least 24 hours before the end of the current period.',
    paymentInfo3:
      'Your account will be charged for renewal within 24 hours prior to the end of the current period.',
    paymentInfo4:
      'You can manage and cancel your subscriptions by going to your account settings on the {{store}} after purchase.',
    paymentInfo5:
      'You can turn off auto-renew at any time from your {{store}} account settings but refunds will not be provided for the unused portion of the term.',
    paymentInfo6:
      'Any unused portion of a free trial period, if offered, will be forfeited when the user purchases a subscription, where applicable.',
    paymentMotivation:
      'A paid subscription allows us to cover our costs and add more features',
    paywall_downgrade:
      'Please choose a subscription below to keep your paid features and notifications turned on. The features you maintain after subscribing are:',
    paywall_geo_notifications:
      'Many of the features we provide to you, e.g. Geolocation Notifications require us to pay other companies and providers. Please upgrade to get access to:',
    paywall_settings:
      'Many of the features we provide to you require us to pay other companies and providers. Please upgrade to get access to:',
    paywall_stats:
      'Many of the features we provide to you, e.g. Unlimited Stats access require us to pay extra to other providers (hosting, etc.). Please upgrade to get access to:',
    paywall_tests_phq_9:
      'Many of the features we provide to you require us to pay other companies and providers. Please upgrade to get access to:',
    paywall_tests_gad_7:
      'Many of the features we provide to you require us to pay other companies and providers. Please upgrade to get access to:',
    paywall_time_notifications:
      'Many of the features we provide to you, e.g. Time-based Notifications require us to pay other companies and providers. Please upgrade to get access to:',
    paywall_behavior_experiments:
      'Free accounts can create Behavior Experiments only once every 3 days. Upgrade now to have unlimited Behavior Experiments enabled and other Premium features.',
    paywall_meditations:
      'Free accounts can listen to a meditation only once every 3 days. Upgrade now to have unlimited meditations access and other Premium features.',
    paywall_worry_trees:
      'Free accounts can create only 1 Worry Tree per day. Upgrade now to have unlimited Worry Trees enabled and other Premium features.',
    paywall_downward_arrows:
      'Free accounts can create only 2 Downward Arrows per day. Upgrade now to have unlimited Downward Arrows enabled and other Premium features.',
    paywall_exposures:
      'Free accounts can create an Exposure only once every 3 days. Upgrade now to be able to create unlimited Exposures and other Premium features',
    paywall_ai_image_generation:
      'Free accounts can create only 3 AI-generated images per day. Upgrade now to be able to create unlimited AI-generated images and other Premium features.',
    save: 'save',
    subscriptionFoundText:
      'We were able to find an existing subscription for you. Your Premium access is restored.',
    subscriptionFoundTitle: 'Existing Subscription Found',
    title: 'Unlock Premium Features',
    titlePremium: 'You Have Premium Access',
    premiumIntro: 'This unlocks the following Premium features for you:',
    year_one: 'year',
    year_other: 'years',
    goBack: 'Go back',
  },
  therapist: {
    call: 'Call',
    sendMessage: 'Send Email',
    about: 'About',
    aceptingClients: 'Accepting Clients',
    mentalHealthRole: 'Mental Health Role',
    phone: 'Phone',
    extension: 'Extension',
    therapyFormats: 'Therapy Formats',
    licensedInStates: 'Licensed in States',
    licenseNumber: 'License Number',
    yearsOfPractice: 'Years of Practice',
    education: 'Education',
    languages: 'Languages',
    therapyApproaches: 'Therapy Approaches',
    finances: 'Finances',
    contPerSessionFrom: 'Cost per Session From',
    to: 'To',
    currency: 'Currency',
    freeInitialConsulatation: 'Free Initial Consultation',
    slidingScale: 'Sliding Scale',
    clients: 'Clients',
    modality: 'Modality',
    age: 'Age',
    issues: 'Issues',
    linkToWebsite: 'Link to Profile on another resource',
    acceptedInsurances: 'Accepted Insurances',
    visitProfile: 'Visit Profile',
    messageSentSuccess: 'Message sent successfully',
  },
  therapistsSearch: {
    info: 'Please specify your location to find therapists in your area.',
    country: 'Your Country',
    state: 'Your State',
    learnMoreAndContact: 'Learn more and contact',
    providerInvitationText:
      'Are you a Mental Health Professional and want to be listed here? Please create a Free Provider Account at:',
    noResults: 'No results found in your area. Please try again later.',
  },
  testsShared: {
    intervalYear: 'YTD',
    intervalSixMonths: '6M',
    intervalThreeMonths: '3M',
    intervalMonth: '1M',
    intervalWeek: '1W',
  },
  /**
   * E07 · "Join your practice" — the client's end of the revocable practice link (M7, 2026-09-13).
   *
   * The copy never says "token" to the person: they followed a link from an email, and the word
   * that means something to them is the practice. The refusal is written for the case that will
   * actually produce it — a link from an email sent before the practice rotated it — and says what
   * to do next, because "invalid token" tells somebody nothing they can act on.
   */
  join: {
    title: 'Join your practice',
    joining: 'Connecting you to your practice…',
    // F-211 (founder Q-join-1 A, 2026-09-30): joining a practice by its link does NOT connect you to a
    // therapist — the practice assigns one and you approve it. The copy says what is true.
    joined:
      'You joined your practice. The practice will assign you a therapist, and you will be asked to confirm.',
    joinedNamed:
      'You joined {{practice}}. The practice will assign you a therapist, and you will be asked to confirm.',
    joinedNext:
      'Nothing is shared with a therapist until you approve. The request will reach you in the app and by email.',
    continue: 'Done',
    refused: 'This link no longer works.',
    refusedHelp:
      'Your practice may have replaced it since the invitation was sent. Ask them for a new link, or enter the invite code they gave you.',
    enterCodeInstead: 'Enter an invite code',
  },
  /**
   * E07 · the transfer request a client answers (M7, 2026-09-13).
   *
   * NEITHER ANSWER IS NUDGED. The two hints state the consequence plainly and symmetrically, and
   * neither is written to sound like the sensible option — this is a decision about a person's own
   * care, and the interface has no business having a preference.
   *
   * The decline copy deliberately does not say "we have told them": a decline records nothing, so
   * promising a notification would be a lie about the system's behaviour.
   */
  sharing: {
    transferPrompt: {
      title: 'A transfer request',
      body: '{{practice}} has asked whether {{name}} can take over your care.',
      whatStays:
        'Whatever you decide, your cards, thought tests and test results stay yours and stay where they are.',
      approve: 'Approve the transfer',
      approveHint: '{{name}} will be able to work with you, with the sharing settings you choose.',
      decline: 'Not now',
      declineHint:
        'Nothing changes and nothing is recorded. You can answer this later if you change your mind.',
      approvedConfirmation: 'Approved. {{name}} can now take over your care.',
      declinedConfirmation: 'Nothing has changed. You can come back to this whenever you like.',
      nothingPending: 'There is no transfer request waiting for you.',
      failed: 'We could not send your answer. Please check your connection and try again.',
      review: 'Review the request',
      done: 'Done',
      colleague: 'another practitioner',
      yourPractice: 'Your practice',
    },
  },
  therapistsSharing: {
    title: 'Data Sharing with Mental Health Professionals',
    inviteLinkOrToken:
      'Do you have an invite link or token from a Mental Health Professional?',
    enterLinkOrToken: 'Enter a link or token',
    dataYouCanShare:
      'You can share everything you record in the app with your Mental Health Professionals: your Coping Cards, your work in the tools, your test results and your usage statistics. The options below apply to all of it.',
    adminDataYouCanShare: `
This would allow admins of the therapist's practice to VIEW the same data that you share wth your therapist.

Some of the situations when this might be useful are:
- your therapist is on vacation and you need to share your data with another therapist in the practice
- you want to allow your therapist to get help/second opinion from other therapists in the practice
- multiple therapists in the practice work with you
- transitioning from one therapist to another within the practice
      `,
    currentTherapists: 'You currently share data with',
    professional: 'Mental Health Professional',
    viewSharing: 'Allow viewing my data',
    editSharing: 'Allow editing my data',
    adminViewSharing: 'Allow practice admins to view my data',
    adminEditSharing: 'Allow practice admins to edit my data',
    inviteTherapist: 'Invite your Therapist',
    enterInviteModalTitle: 'Enter Invite Link or Token',
    // P022 (E07 finding 50, founder 2026-09-19): say WHO is asking before anything is granted
    enterInviteFromLooking: 'Checking who sent this invitation…',
    enterInviteFrom: 'Invitation from {{name}}',
    enterInviteFromPractice: 'Invitation from {{name}} · {{practice}}',
    enterInviteFromUnknown: 'We could not find an invitation for this code. Check it and try again.',
    enterInviteModaLabel: 'Invite Link or Token',
    editingTip: `
Requires view permission to be granted first.

It can be very helpful to allow your Therapist to edit data at initial stages of therapy, especially during Telehealth sessions.

Your Mental Health Professional will be able to edit what you record in the app to help you learn the tools faster.

You will be able to revoke the access at any time.
      `,

    adminEditingTip: `
This would allow admins of the therapist's practice to EDIT the same data that you allow your therapist to EDIT.
This permission requires Viewing permission as well.

Some of the situations when this might be useful are:
- your therapist is on vacation and you need to share your data with another therapist in the practice
- you want to allow your therapist to get help/second opinion from other therapists in the practice
- multiple therapists in the practice work with you
- transitioning from one therapist to another within the practice
      `,
    acceptInvite: 'Accept Invite',
    pendingInvites: 'Pending Invites',
    inviteFrom: 'Invite from',
    expiresAt: 'Expires on',
    confirmRevoke: 'Confirm Revoke',
    editRevoke: `
If you revoke Edit access to your data, your Mental Health Professional will no longer be able to quickly edit your Coping Cards or Dysfunctional Thoughts Tests.
    `,
    viewRevoke: `
If you revoke View access to your data, your Mental Health Professional will no longer be able to see how you use our app and what content you crate, which can make it more difficult to assist you in therapy.

This will also revoke Edit access.
  `,
    noTherapists:
      'You have not shared your data with any Mental Health Professionals yet.',
    noTokenTitle: 'Token not found',
    noTokenText: `
We have not found this token in our database.

It might have expired or was incorrect.

Please verify it and try again or contact your Mental Health Professional for a new token/invite link.
`,
    accessGranted: 'You have successfully granted access to your data',
    accessUpdated: 'You have successfully updated access to your data',
    inviteSent: 'Your invite has been sent',
    inviteFailed:
      'We could not send this invite. Please try again. If it keeps happening, contact support@copingcard.com and mention code THERAPIST-INVITE-1.',
    alreadyAdded:
      'You already share your data with this Mental Health Professional',
    congratsOnPremium: 'You got Premium Access!',
    congratsOnPremiumText: `
Congratulations! 

Your mental health care provider has granted you full access to the Premium features of our app.

We hope this will help you on your journey to be happier and healthier.
    `,
  },
  thoughtChoiceModal: {
    title: 'Card Creation',
    text: 'Choose if you want to create the card going through the Automatic Thoughts Testing or just quickly create a card',
    goToTesting: 'Go to Thought Testing',
    quickEdit: 'Quickly add the card',
  },

  // E01 — Thought Testing on Event Sourcing (context prefix `thoughtTesting.<cmd>.*`, plan 03 §3)
  // ES coexistence (plan 07 §3 rule 5 / plan 04 §2.2 symmetric guard) — both directions are
  // server-enforced; the copy is what a user sees only if the client's silent refetch+retry fails
  es: {
    modeMismatch:
      'Your account was just updated. Please try again in a moment.',
    resendAsEs: 'Your account was just updated. Please try again in a moment.',
    // an edit that would change a field no built slice records yet — refused rather than written
    // to the legacy row alone (that would leave the log and the row disagreeing for ever)
    editNotPorted:
      'This part of the card cannot be edited yet in the updated version. Please try again after the next update.',
  },
  // F-207 (Q-copy-1 A, 2026-09-30) — the CLIENT's words on the app's Complete Experiment screens. The portal's
  // therapist still reads `shared.behaviorExperiment.patientReflections` ("Patient Reflections").
  behaviorExperimentApp: {
    myReflections: 'My reflections',
    myReflectionsPlaceholder: 'Write what you noticed',
  },
  // E10 — Downward Arrow on Event Sourcing (context prefix `downwardArrow.<cmd>.*`, plan 03 §3).
  // Distinct from `shared.downwardArrow.*`, which is the screen copy.
  conceptualization: {
    upsert: {
      rejected:
        'This case conceptualization could not be saved — please check the entries and try again.',
      conflictRetry:
        'This conceptualization was just updated elsewhere. Reloading the latest version…',
    },
  },
  // E17 · UpsertSession (portal): the refusals of the E lane. `limitReached` is the E08 Create
  // gate — the portal shows its upgrade modal on the same rule; this is the server's own word.
  sessions: {
    upsert: {
      rejected:
        'This session could not be saved — please check the entries and try again.',
      limitReached:
        'A new session cannot be recorded under the current practice subscription — upgrade or free a seat, then try again.',
      conflictRetry:
        'This session was just updated elsewhere. Reloading the latest version…',
    },
  },
  // E04 · the review session (the therapist's explicit RTM billable bracket): the refusals of the
  // E lane, voiced for the therapist at the header control.
  reviewSessions: {
    alreadyActive:
      'You already have a review session running with this client — end it before starting another.',
    noneActive:
      'There is no review session running with this client right now.',
    conflictRetry:
      'This review session was just updated elsewhere. Reloading the latest state…',
  },
  // E23 · the client→therapist message through the log: the refusals of the E lane.
  messaging: {
    send: {
      rejected: 'This message could not be sent — please check it and try again.',
      conflictRetry: 'This message was just sent. Reloading…',
    },
    read: {
      rejected: 'This message could not be marked as read — please reload and try again.',
    },
  },
  // E24 · the practice, its first location and the therapist's listing through the log (portal):
  // the refusals of the E lane. The wire's own validation (Yup) speaks first; these are the log's.
  practice: {
    create: {
      rejected:
        'The practice could not be created — please check the entries and try again.',
    },
    update: {
      rejected:
        'The practice information could not be saved — please check the entries and try again.',
    },
    profile: {
      rejected:
        'Your profile could not be saved — please check the entries and try again.',
    },
    conflictRetry:
      'This was just updated elsewhere. Reloading the latest version…',
  },
  // E18 · the progress note through the log (portal): the refusals of the E lane.
  progressNotes: {
    upsert: {
      rejected:
        'This progress note could not be saved — please check the entries and try again.',
      conflictRetry:
        'This progress note was just updated elsewhere. Reloading the latest version…',
    },
  },
  worryTree: {
    create: {
      rejected:
        'This worry tree could not be saved — please check the entries and try again.',
      conflictRetry:
        'This worry tree was just saved on another device. Reloading your latest version…',
    },
  },
  abcModel: {
    upsert: {
      rejected:
        'This ABC model could not be saved — please check the entries and try again.',
      conflictRetry:
        'This ABC model was just updated on another device. Reloading your latest version…',
    },
    // decider rejection codes (packages/domain/src/abcModel/errors.ts) — one key per code, in both
    // languages; the domain test error-codes-i18n fails when one is missing. E09 deliberately has
    // no CONTENT-validation code: the board carries no such scenario, and a half-written worksheet
    // is an ordinary thing to save mid-session.
    errors: {
      SUBJECT_REQUIRED: 'Please sign in again before saving this ABC model.',
    },
  },
  // ── E06 · Assessments (PHQ-9 / GAD-7) ─────────────────────────────────────────────────────────
  // Decider rejection codes (packages/domain/src/assessments/errors.ts) — one key per code, in both
  // languages; the domain test error-codes-i18n fails when one is missing. Every one of these is
  // UNREACHABLE from the shipped questionnaire (see errors.ts for the per-code argument), so the
  // copy is written for the case it is actually for: something is wrong with the app, and the
  // person needs a next step rather than an explanation.
  // E13 / E14 / E15 — Wellness (Meditations, Crisis, Learn). The transport's two refusals and the
  // copy the batch mutation renders. The eight start/finish deciders are otherwise TOTAL: a listen
  // that happened happened (founder ruling 2026-09-12).
  wellness: {
    submit: {
      rejected:
        'This activity could not be saved. It will be sent again next time the app is online.',
      invalid:
        'Some of this activity could not be recorded. Please update the app and try again.',
    },
    errors: {
      WELLNESS_UNKNOWN_EVENT_TYPE:
        'This version of the app cannot record that activity yet. Please update the app.',
      WELLNESS_INVALID_PROGRESS:
        'How far you got could not be recorded, so this activity was not saved.',
    },
  },
  assessments: {
    // 1.6.0 UX round 3: the tile / header name of a built-in instrument is "<code> · <purpose>" (code stays Latin in both languages)
    purpose: {
      phq9: 'Depression',
      gad7: 'Anxiety',
      dass21: 'Depression, anxiety and stress',
      pcl5: 'Post-traumatic stress',
      gds15: 'Depression in older adults',
      urica: 'Readiness to change',
    },
    create: {
      rejected:
        'This assessment could not be saved. Please retake it — your answers were not stored.',
      conflictRetry:
        'This assessment was just saved on another device. Reloading your latest result…',
    },
    errors: {
      ASSESSMENT_SCORE_MISMATCH:
        'This assessment could not be saved because its score did not add up. Please update the app and take the test again.',
      ASSESSMENT_ANSWERS_INCOMPLETE:
        'Some answers are missing, so this assessment cannot be scored. Please go back and answer every question.',
      ASSESSMENT_TYPE_UNKNOWN:
        'This questionnaire is not available in your version of the app. Please update and try again.',
      ASSESSMENT_NOT_CONVERTED:
        'This assessment is still being prepared. Please try again in a moment.',
      // E35 — the instruments after GAD-7, the in-session take, the external result and the backoffice definition
      ASSESSMENT_ANSWERS_COUNT:
        'The number of answers does not match this questionnaire. Check that every question has an answer and try again.',
      ASSESSMENT_ANSWER_RANGE:
        'One of the answers is not a choice on this questionnaire. Check the answers and try again.',
      ASSESSMENT_DATE_IN_FUTURE:
        'The date the questionnaire was taken cannot be in the future. Choose today or an earlier date.',
      ASSESSMENT_SCORE_RANGE:
        'The score must be between 0 and the highest score of this questionnaire. Check the score and try again.',
      HOMEWORK_NOT_YOUR_CLIENT:
        'You can only record results for clients who share their work with you. Ask the client to turn sharing on for you, then try again.',
      INSTRUMENT_UNCHANGED:
        'Nothing has changed since this questionnaire was last published, so there is nothing to save.',
      INSTRUMENT_ITEMS_MISMATCH:
        'A scale lists a question this questionnaire does not have. Check the question numbers against the number of questions.',
      INSTRUMENT_BANDS_GAP:
        'The score bands leave a gap or overlap. Each band must start one point above the end of the previous band.',
      INSTRUMENT_UNKNOWN:
        'This questionnaire is not available yet. New questionnaires arrive with an app update.',
    },
    // E35 — the Tests hub's questionnaire list, the intro, the questionnaire, the result and the standing support card
    catalog: {
      title: 'More questionnaires',
      body: 'Short questionnaires you can take now or that your therapist has given you.',
      empty: 'There are no other questionnaires available right now.',
      questions: '{{count}} questions',
      assignedBy: 'Given by {{name}}',
      assigned: 'Given by your therapist',
      due: 'Due {{date}}',
      last: 'Last result: {{score}} · {{band}}',
      lastScoreOnly: 'Last result: {{score}}',
      notTaken: 'Not taken yet',
    },
    intro: {
      questions: '{{count}} questions',
      answers: 'You choose one answer for each question: {{choices}}.',
      start: 'Start',
      source: 'Source: {{citation}}',
      assignedBy: 'Given by {{name}}',
      assigned: 'Given by your therapist',
      due: 'Due {{date}}',
      loadError: 'This questionnaire could not be opened. Go back and try again.',
    },
    take: {
      progress: 'Question {{current}} of {{total}}',
      next: 'Next',
      back: 'Back',
      seeResult: 'See result',
      saving: 'Saving…',
      error: 'Your answers could not be saved. Check your connection and try again.',
    },
    result: {
      title: 'Your result',
      total: 'Total score',
      scales: 'By scale',
      range: 'Range',
      changeUp: 'Up {{count}} since last time',
      changeDown: 'Down {{count}} since last time',
      changeSame: 'The same as last time',
      bandsLine: 'Bands are the instrument’s published ones; this is not a diagnosis.',
      loading: 'Loading your result…',
      loadError: 'Your answers were saved, but the result could not be shown. Open it from the list of questionnaires.',
      history: 'History',
      backToTests: 'Back to the questionnaires',
    },
    history: {
      title: 'History',
      empty: 'You have not taken this questionnaire yet.',
    },
    support: {
      title: 'Your plan and crisis lines',
      bodyPlan: 'Your safety plan and crisis lines are here on every result, whatever the score.',
      bodyNoPlan: 'Make a safety plan now, or open the crisis lines. This card is on every result, whatever the score.',
      openPlan: 'Open my safety plan',
    },
    // the labels of the bands; a band id is the definition's (packages/domain/src/assessments/instruments.ts)
    band: {
      dass21: {
        normal: 'Normal',
        mild: 'Mild',
        moderate: 'Moderate',
        severe: 'Severe',
        extremelySevere: 'Extremely severe',
      },
      pcl5: {
        belowCutoff: 'Below the screening cut-off',
        atOrAboveCutoff: 'At or above the screening cut-off (31–33)',
      },
      gds15: {
        belowCutoff: 'Below the screening cut-off',
        suggestsDepression: 'Suggests depression; a follow-up interview is advised',
        almostAlwaysDepression: 'Almost always depression',
      },
    },
    subscale: {
      dass21: {
        depression: 'Depression',
        anxiety: 'Anxiety',
        stress: 'Stress',
      },
      pcl5: {
        intrusion: 'Intrusion',
        avoidance: 'Avoidance',
        cognitionMood: 'Thoughts and mood',
        arousal: 'Arousal and reactions',
      },
      urica: {
        precontemplation: 'Not yet considering a change',
        contemplation: 'Thinking about a change',
        action: 'Making a change',
        maintenance: 'Keeping a change going',
      },
    },
    note: {
      dass21: 'These labels compare your scores with people in general. They do not describe a disorder.',
      pcl5: 'A score at or above the cut-off suggests probable PTSD; only a clinician’s interview can confirm it.',
      urica: 'Readiness runs from −2 to 14: the agreement with thinking about, making and keeping a change, minus the agreement with not considering one. It describes where you are today, not who you are.',
    },
    dass21: {
      about: 'How often you felt low, anxious or tense over the past week.',
      instruction: 'Please read each statement and choose the answer that shows how much it applied to you over the past week. There are no right or wrong answers. Do not spend too much time on any statement.',
      answer0: 'Did not apply to me at all',
      answer1: 'Applied to me to some degree, or some of the time',
      answer2: 'Applied to me to a considerable degree, or a good part of the time',
      answer3: 'Applied to me very much, or most of the time',
      items: {
        q1:
          'I found it hard to wind down',
        q2:
          'I was aware of dryness of my mouth',
        q3:
          'I couldn\'t seem to experience any positive feeling at all',
        q4:
          'I experienced breathing difficulty (eg, excessively rapid breathing, breathlessness in the absence of physical exertion)',
        q5:
          'I found it difficult to work up the initiative to do things',
        q6:
          'I tended to over-react to situations',
        q7:
          'I experienced trembling (eg, in the hands)',
        q8:
          'I felt that I was using a lot of nervous energy',
        q9:
          'I was worried about situations in which I might panic and make a fool of myself',
        q10:
          'I felt that I had nothing to look forward to',
        q11:
          'I found myself getting agitated',
        q12:
          'I found it difficult to relax',
        q13:
          'I felt down-hearted and blue',
        q14:
          'I was intolerant of anything that kept me from getting on with what I was doing',
        q15:
          'I felt I was close to panic',
        q16:
          'I was unable to become enthusiastic about anything',
        q17:
          'I felt I wasn\'t worth much as a person',
        q18:
          'I felt that I was rather touchy',
        q19:
          'I was aware of the action of my heart in the absence of physical exertion (eg, sense of heart rate increase, heart missing a beat)',
        q20:
          'I felt scared without any good reason',
        q21:
          'I felt that life was meaningless',
      },
    },
    pcl5: {
      about: 'How much problems that can follow a very stressful experience have bothered you over the past month.',
      instruction: 'Below is a list of problems that people sometimes have after a very stressful experience. Please read each one carefully and choose how much it has bothered you in the past month.',
      stem: 'In the past month, how much were you bothered by:',
      answer0: 'Not at all',
      answer1: 'A little bit',
      answer2: 'Moderately',
      answer3: 'Quite a bit',
      answer4: 'Extremely',
      items: {
        q1:
          'Repeated, disturbing, and unwanted memories of the stressful experience?',
        q2:
          'Repeated, disturbing dreams of the stressful experience?',
        q3:
          'Suddenly feeling or acting as if the stressful experience were actually happening again (as if you were actually back there reliving it)?',
        q4:
          'Feeling very upset when something reminded you of the stressful experience?',
        q5:
          'Having strong physical reactions when something reminded you of the stressful experience (for example, heart pounding, trouble breathing, sweating)?',
        q6:
          'Avoiding memories, thoughts, or feelings related to the stressful experience?',
        q7:
          'Avoiding external reminders of the stressful experience (for example, people, places, conversations, activities, objects, or situations)?',
        q8:
          'Trouble remembering important parts of the stressful experience?',
        q9:
          'Having strong negative beliefs about yourself, other people, or the world (for example, having thoughts such as: I am bad, there is something seriously wrong with me, no one can be trusted, the world is completely dangerous)?',
        q10:
          'Blaming yourself or someone else for the stressful experience or what happened after it?',
        q11:
          'Having strong negative feelings such as fear, horror, anger, guilt, or shame?',
        q12:
          'Loss of interest in activities that you used to enjoy?',
        q13:
          'Feeling distant or cut off from other people?',
        q14:
          'Trouble experiencing positive feelings (for example, being unable to feel happiness or have loving feelings for people close to you)?',
        q15:
          'Irritable behavior, angry outbursts, or acting aggressively?',
        q16:
          'Taking too many risks or doing things that could cause you harm?',
        q17:
          'Being "superalert" or watchful or on guard?',
        q18:
          'Feeling jumpy or easily startled?',
        q19:
          'Having difficulty concentrating?',
        q20:
          'Trouble falling or staying asleep?',
      },
      notValidated: 'This Russian version has not been validated.',
    },
    gds15: {
      about: 'A short questionnaire about mood, made for older adults. It looks at the past week.',
      instruction: 'Choose the best answer for how you have felt over the past week.',
      answer0: 'No',
      answer1: 'Yes',
      items: {
        q1:
          'Are you basically satisfied with your life?',
        q2:
          'Have you dropped many of your activities and interests?',
        q3:
          'Do you feel that your life is empty?',
        q4:
          'Do you often get bored?',
        q5:
          'Are you in good spirits most of the time?',
        q6:
          'Are you afraid that something bad is going to happen to you?',
        q7:
          'Do you feel happy most of the time?',
        q8:
          'Do you often feel helpless?',
        q9:
          'Do you prefer to stay at home, rather than going out and doing new things?',
        q10:
          'Do you feel you have more problems with memory than most?',
        q11:
          'Do you think it is wonderful to be alive now?',
        q12:
          'Do you feel pretty worthless the way you are now?',
        q13:
          'Do you feel full of energy?',
        q14:
          'Do you feel that your situation is hopeless?',
        q15:
          'Do you think that most people are better off than you are?',
      },
    },
    // E49 — the URICA (McConnaughy, Prochaska & Velicer 1983; public domain). The 32 statements are the published wording
    // (docs/em&es/research/E49-motivational-interviewing/urica-form-and-scoring-umbc.pdf); the instruction is ours for an app.
    urica: {
      about: 'How ready you feel to change something — 32 statements about where you are with it right now.',
      instruction: 'Each statement describes how a person might feel when starting therapy or approaching a problem in their life. Where a statement says "my problem", think of the change you have in mind; "here" and "this place" mean your therapy, or this app. Choose how much you agree right now — not how you felt in the past or would like to feel.',
      answer1: 'Strongly disagree',
      answer2: 'Disagree',
      answer3: 'Undecided',
      answer4: 'Agree',
      answer5: 'Strongly agree',
      readiness: 'Readiness to change',
      stageLine: 'Closest stage of change: {{stage}}',
      items: {
        q1:
          'As far as I\'m concerned, I don\'t have any problems that need changing.',
        q2:
          'I think I might be ready for some self-improvement.',
        q3:
          'I am doing something about the problems that had been bothering me.',
        q4:
          'It might be worthwhile to work on my problem.',
        q5:
          'I\'m not the problem one. It doesn\'t make much sense for me to be here.',
        q6:
          'It worries me that I might slip back on a problem I have already changed, so I am here to seek help.',
        q7:
          'I am finally doing some work on my problem.',
        q8:
          'I\'ve been thinking that I might want to change something about myself.',
        q9:
          'I have been successful in working on my problem but I\'m not sure I can keep up the effort on my own.',
        q10:
          'At times my problem is difficult, but I\'m working on it.',
        q11:
          'Being here is pretty much a waste of time for me because the problem doesn\'t have to do with me.',
        q12:
          'I\'m hoping this place will help me to better understand myself.',
        q13:
          'I guess I have faults, but there\'s nothing that I really need to change.',
        q14:
          'I am really working hard to change.',
        q15:
          'I have a problem and I really think I should work at it.',
        q16:
          'I\'m not following through with what I had already changed as well as I had hoped, and I\'m here to prevent a relapse of the problem.',
        q17:
          'Even though I\'m not always successful in changing, I am at least working on my problem.',
        q18:
          'I thought once I had resolved my problem I would be free of it, but sometimes I still find myself struggling with it.',
        q19:
          'I wish I had more ideas on how to solve the problem.',
        q20:
          'I have started working on my problems but I would like help.',
        q21:
          'Maybe this place will be able to help me.',
        q22:
          'I may need a boost right now to help me maintain the changes I\'ve already made.',
        q23:
          'I may be part of the problem, but I don\'t really think I am.',
        q24:
          'I hope that someone here will have some good advice for me.',
        q25:
          'Anyone can talk about changing; I\'m actually doing something about it.',
        q26:
          'All this talk about psychology is boring. Why can\'t people just forget about their problems?',
        q27:
          'I\'m here to prevent myself from having a relapse of my problem.',
        q28:
          'It is frustrating, but I feel I might be having a recurrence of a problem I thought I had resolved.',
        q29:
          'I have worries but so does the next guy. Why spend time thinking about them?',
        q30:
          'I am actively working on my problem.',
        q31:
          'I would rather cope with my faults than try to change them.',
        q32:
          'After all I had done to try to change my problem, every now and again it comes back to haunt me.',
      },
    },
  },
  exposure: {
    upsert: {
      rejected:
        'This exposure could not be saved — please check the entries and try again.',
      conflictRetry:
        'This exposure was just updated on another device. Reloading your latest version…',
    },
    // decider rejection codes (packages/domain/src/exposure/errors.ts) — one key per code, in both
    // languages; the domain test error-codes-i18n fails when one is missing. The legacy resolvers
    // answered a silent null for the first three, which is the L20 finding these codes correct.
    errors: {
      EXPOSURE_NOT_FOUND:
        'This exposure is no longer available. Please go back and open it again.',
      EXPOSURE_STIMULUS_NOT_FOUND:
        'This situation is no longer in the ladder — it may have been deleted on another device.',
      EXPOSITION_NOT_FOUND:
        'This exposure run is no longer available. Close the timer and start a new run.',
      EXPOSITION_REACTION_NOT_FOUND:
        'This reaction is no longer part of the run. Close the run and open it again to see the current readings.',
      EXPOSITION_EDIT_NOT_PORTED:
        'Past exposure runs cannot be edited or removed yet. Start a new run instead, or reopen this one and add a reaction.',
      EXPOSURE_NOT_CONVERTED:
        'This exposure is still being prepared. Please try again in a moment.',
      EXPOSITION_LIKELIHOOD_RANGE:
        'The likelihood must be a whole number from 0 to 100. Move the slider to a value in that range, or leave it unanswered.',
      USER_NOT_AUTHORIZED:
        'You do not have access to this exposure. If you think this is a mistake, contact support@copingcard.com and mention code EXPOSURE-AUTH-1.',
      PAYWALL_EXPOSURES:
        'You have reached the free limit for new exposures. Upgrade to create more, or continue with the ones you have.',
      IMAGE_PROMPT_REQUIRED:
        'Describe the image you would like before generating one.',
      IMAGE_REQUEST_ALREADY_ANSWERED:
        'This image has already been generated. Tap Generate again for a new one.',
      PAYWALL_AI_IMAGE_GENERATION:
        'You have used all of today’s free AI images. Upgrade for more, or try again tomorrow.',
      LADDER_PROMPT_REQUIRED:
        'Add the fear or obsession this exposure is about, then generate the hierarchy.',
      LADDER_REQUEST_ALREADY_ANSWERED:
        'This hierarchy has already been generated. Press Generate again for a new one.',
    },
  },
  // E34 · Homework & Pathways (block 1a, 2026-09-28) — the homework deciders' refusal codes
  // (packages/domain/src/homework/errors.ts): one key per code, in both languages; the domain test
  // error-codes-i18n fails when one is missing. The screens' own copy (homework.assign.*, .list.*,
  // .detail.*, .skip.*, .self.*) arrives with the portal and phone blocks.
  homework: {
    errors: {
      HOMEWORK_NOT_YOUR_CLIENT:
        'This client is not connected with you at your practice — they are not your client here, or they have switched off sharing with you — so their homework cannot be assigned or changed. Check the client list, or ask the client to turn sharing with you back on in the app.',
      HOMEWORK_DUE_IN_PAST:
        'That due date has already passed. Choose a date and time in the future.',
      HOMEWORK_ONE_DEADLINE_SHAPE:
        'Choose either a due date or a repeat schedule — not both.',
      HOMEWORK_TARGET_REQUIRED:
        'Choose what the homework is — the tool, questionnaire, worksheet, article, video or link — before you assign it.',
      HOMEWORK_TITLE_REQUIRED: 'Give the homework a title before you assign it.',
      WORKSHEET_TEMPLATE_RETIRED:
        'This worksheet has been retired and can no longer be assigned. Choose another worksheet.',
      HOMEWORK_SELF_WORKSHEET_NOT_JOURNAL:
        'Only CopingCard journals can be added to your own homework. Choose a journal from the list.',
      HOMEWORK_SESSION_NEEDS_THERAPIST:
        'A step done in a session is set by your therapist. Add a task or a tool instead.',
      HOMEWORK_NOT_OPEN:
        'This homework is already done, skipped or withdrawn, so it cannot be changed. Refresh to see where it stands.',
      HOMEWORK_ALREADY_CANCELLED:
        'This homework has already been withdrawn. Refresh to see where it stands.',
      HOMEWORK_ALREADY_OPEN:
        'This homework is still open, so there is nothing to reopen.',
      HOMEWORK_ALREADY_ACKNOWLEDGED: 'This homework has already been opened.',
      // Q-b1e-6-skip A (2026-09-29): also a Skip inside a window whose occurrence is already done OR
      // skipped — the line the Skip screen keeps ("already marked done" was untrue after a skip)
      HOMEWORK_ALREADY_DONE:
        'This one is already done or skipped, so there is nothing more to record for now.',
      HOMEWORK_CANCELLED:
        'Your therapist has withdrawn this homework, so it can no longer be completed. Pull down to refresh your list.',
      HOMEWORK_NEEDS_EVIDENCE:
        'This homework completes itself when you do it in the app — open it and finish it there. If your therapist allowed paper for it, add a photo of the sheet.',
      // Q-paper (1.5.0): a photo on a tool or worksheet that is not allowed on paper, or on a kind that never is.
      // `HOMEWORK_PAPER_NOT_ALLOWED` is the code's own key (the API maps every refusal to `homework.errors.<CODE>`);
      // `paperNotAllowed` is the model's copy key (the screens that name it directly) — one text.
      HOMEWORK_PAPER_NOT_ALLOWED:
        'This one cannot be done on paper. Open it in the app to finish it.',
      paperNotAllowed:
        'This one cannot be done on paper. Open it in the app to finish it.',
      HOMEWORK_REMINDED_TODAY:
        'A reminder for this homework was already sent today. You can send another one tomorrow.',
      HOMEWORK_NOT_FOUND:
        'This homework is no longer available. Refresh the list and try again.',
      HOMEWORK_BAD_CURSOR:
        'The list could not load the next page. Pull down to refresh it and try again.',
      // block 4 (2026-09-29) — the comment thread
      HOMEWORK_COMMENT_NOT_ALLOWED:
        'You cannot comment on this homework. Only the client and the therapists at their practice can write in its thread — and only while the client shares with you. Check the client list.',
      HOMEWORK_COMMENT_TEXT:
        'A comment needs some text — up to 2,000 characters. Write a few words and send it again.',
      // block 1d — the notifier's exactly-once guard (only the system sends that command)
      HOMEWORK_ALREADY_NOTIFIED:
        'The client has already been told about this homework. Nothing more to send.',
      // block 1e — the paper-photo viewer (the founder's Q-b1b-2 A)
      HOMEWORK_PHOTO_UNAVAILABLE:
        'This photo is no longer available — the client may have removed it. Ask the client to add the photo again.',
      // block 2a (2026-09-29) — worksheets: templates (the Builder, the backoffice library), submit, sign
      WORKSHEET_TEMPLATE_EMPTY:
        'This worksheet is empty. Add some instructions, a video or a question before you save it.',
      WORKSHEET_DUPLICATE_FIELD:
        'Two questions in this worksheet have the same ID. Delete one of them and save again.',
      WORKSHEET_SCORING_FIELD:
        'Scoring can only add up number and scale questions. Choose only those questions in the scoring settings.',
      WORKSHEET_SIGNED_JOURNAL:
        'A journal is filled in again and again, so it cannot ask for a signature. Turn off either “Repeatable” or “Signature required”.',
      WORKSHEET_NOT_OWNER:
        'Only worksheets your practice made can be changed here. Use “Use this template” to make your own copy.',
      WORKSHEET_RIGHTS_NOT_CONFIRMED:
        'Tick “I have the right to use this content” first, then try again. Your practice is responsible for the content it imports or creates.',
      WORKSHEET_REQUIRED_MISSING:
        'Some required questions are still empty. Answer them, then send the form.',
      WORKSHEET_UNKNOWN_FIELD:
        'This form has changed since it was opened. Close it, open it again and send the answers.',
      WORKSHEET_ALREADY_SUBMITTED:
        'This form has already been sent. The therapist can reopen it if it is needed again.',
      WORKSHEET_NO_SIGNATURE:
        'This form does not need a signature — it is complete once it is sent.',
      WORKSHEET_CONSENT_REQUIRED: 'Tick “I agree” before you sign.',
      WORKSHEET_ALREADY_SIGNED:
        'This form has already been signed. There is nothing more to do.',
      WORKSHEET_SIGNER_NOT_SUBJECT:
        'Only the client can sign this form, in their CopingCard app.',
      WORKSHEET_TEMPLATE_NOT_FOUND:
        'This worksheet is no longer available. Refresh the list and choose it again.',
      WORKSHEET_ANSWER_INVALID:
        'One of the answers does not fit its question — for example, a number outside the scale. Check the answers and send again.',
      WORKSHEET_SUBMISSION_SUPERSEDED:
        'A newer copy of this form has been sent. Sign the newest one instead.',
      // block 3a (2026-09-29) — pathways: the Builder, the library, Enroll, Release, Withdraw; the phone's
      // Start and Leave (programs and courses)
      PATHWAY_EMPTY:
        'This program has no steps yet. Add at least one step before you save it.',
      PATHWAY_FIRST_STEP_RULE:
        'The first step cannot wait for a previous one. Set it to start at enrollment, on a day, or when you release it.',
      PATHWAY_STEP_TARGET_REQUIRED:
        'One of the steps does not say what it is — choose its tool, questionnaire, worksheet, article, video or link.',
      PATHWAY_SESSION_STEP_PUBLIC:
        'A step done in a session cannot be part of a public program. Make the program private, or remove that step.',
      PATHWAY_PUBLISH_NOT_ALLOWED:
        'Your practice cannot publish programs yet, so this program can only be private. Choose “Practice” as the visibility, or contact CopingCard about publishing programs.',
      PATHWAY_CUSTOMISE_NOT_ALLOWED:
        'Your plan does not include customizing CopingCard programs. You can still enroll clients in the program as it is.',
      PATHWAY_RETIRED:
        'This program has been retired, so it cannot be changed or given to new clients. Duplicate it to make a new one.',
      PATHWAY_NOT_OWNER:
        'Only programs your practice made can be changed here. Duplicate it, or use it as a template, to make your own copy.',
      PATHWAY_ALREADY_RETIRED:
        'This program is already retired. Refresh to see where it stands.',
      PATHWAY_ALREADY_ENROLLED:
        'This client is already on this program. Open their progress to see where they are.',
      PATHWAY_PRESCRIBE_NOT_ALLOWED:
        'Your plan does not include this paid program. Upgrade your plan in Billing to prescribe programs — your client never pays for what you prescribe.',
      PATHWAY_PURCHASE_REQUIRED:
        'This program is a one-off purchase. Buy it first, then start it.',
      PATHWAY_PLAN_ONLY:
        'This program is available only through a therapist’s practice. Ask your therapist about it.',
      PATHWAY_NOT_SELF_ENROLABLE:
        'This program is not open for you to start yourself. Choose a program from the list.',
      PATHWAY_STEP_ALREADY_RELEASED:
        'This step has already been released. Refresh to see the client’s progress.',
      PATHWAY_ENROLLMENT_CLOSED:
        'This program has already ended — it was completed or withdrawn. Refresh to see where it stands.',
      PATHWAY_STEP_UNKNOWN:
        'This step is not part of the version this client is on. Refresh the progress and try again.',
      PATHWAY_STEPS_OPEN:
        'Some steps of this program are still open, so it is not complete yet.',
      PATHWAY_NOT_FOUND:
        'This program is no longer available. Refresh the list and try again.',
      PATHWAY_ENROLLMENT_NOT_FOUND:
        'This program is no longer available. Refresh the list and try again.',
      PATHWAY_LEAVE_ASK_THERAPIST:
        'Your therapist started this program with you. Talk to them if you would like to stop it.',
      // block 5a (2026-09-29) — course access, capabilities and review (the backoffice)
      PATHWAY_ACCESS_NOT_LIBRARY:
        'Access rules are set only on CopingCard library programs. A practice’s own program has none — choose a library program.',
      PATHWAY_ACCESS_PRODUCT_REQUIRED:
        'A purchase program needs its store product. Enter the product ID configured in the App Store and Google Play, then save again.',
      PATHWAY_ACCESS_PLACEMENT_REQUIRED:
        'A purchase program needs its Adapty placement. Enter the placement ID of the program’s paywall in Adapty, then save again.',
      PRACTICE_CAPABILITY_UNKNOWN:
        'That capability does not exist. Choose prescribe programs, customize programs or publish programs.',
      PRACTICE_CAPABILITY_UNCHANGED:
        'Nothing to change — this switch is already in that position. Refresh the page to see the current state.',
      PATHWAY_NOT_IN_REVIEW:
        'This version is not waiting for review any more — it was decided, replaced by a newer version, made private or retired. Refresh the queue.',
      PATHWAY_REVIEW_REASON_REQUIRED:
        'Write the reason the practice will read, then reject again.',
      // ── block 6 (2026-09-29): the homework video player — WatchAssignedVideo ──
      HOMEWORK_NOT_A_VIDEO:
        'This homework is not a video, so nothing was recorded. Go back to your homework list and open it from there.',
      HOMEWORK_INVALID_PROGRESS:
        'We could not save how much of the video you watched. Open the video again from your homework list and play it.',
    },
    // ── block 1c (2026-09-28): the client's side on the phone ──
    saveError:
      'This could not be saved. Check your connection and try again.',
    toolkitEntry: {
      title: 'Homework',
      summaryOpen: '{{count}} to do',
      summaryOverdue: '{{count}} overdue',
      summaryNone: 'Nothing to do right now — add your own',
      badgeLabel: '{{count}} homework to do',
    },
    kind: {
      tool: 'tool',
      assessment: 'questionnaire',
      worksheet: 'worksheet',
      reading: 'reading',
      task: 'task',
      link: 'link',
      session: 'session',
      video: 'video',
    },
    status: {
      open: 'open',
      overdue: 'overdue',
      done: 'done',
      skipped: 'skipped',
      cancelled: 'withdrawn',
    },
    list: {
      openSection: 'To do',
      closedSection: 'Done · skipped · withdrawn',
      loadingMore: 'Loading earlier homework…',
      empty:
        'No homework yet. What your therapist gives you appears here — and you can add your own.',
      add: '+ Add my own',
      you: 'You',
      yourTherapist: 'Your therapist',
      due: 'due {{date}}',
      nextDue: 'next {{date}}',
      // the founder's Q-b1c-4 A: a done one-off reads when it was done
      doneOn: 'done {{date}}',
      // the founder's Q-b1c-6 C: a recurring row's last outcome, beside its next date
      lastOutcome: {
        day: 'today’s: {{outcome}}',
        week: 'this week’s: {{outcome}}',
        month: 'this month’s: {{outcome}}',
        other: '{{date}}: {{outcome}}',
      },
      noDue: 'no due date',
      scheduleEnded: 'no more dates',
      video: 'Ticks itself off once watched to the end',
      rowLabel: '{{title}}, {{status}}',
    },
    detail: {
      from: 'From {{name}}',
      fromYou: 'Set by you',
      // F-220 (2026-10-03): a library photo that could not be made a picture your therapist can open
      photoConvertFailed:
        'That photo could not be prepared. Try taking it again.',
      instructions: 'Instructions',
      // the founder's Q-b1d-3 A: the practice's latest reminder line, on the assignment only
      reminderFrom: 'Reminder from {{name}}',
      whatToDo: 'What to do',
      open: 'Open',
      occurrenceLine: '{{label}} · {{date}}',
      // the founder's Q-b1e-8 A (2026-09-29): inside a window already answered — "Today’s: done", the next
      // below it as occurrenceLine with occurrence.next ("Next · <date>")
      occurrenceAnswered: '{{label}}: {{outcome}}',
      occurrence: {
        day: 'Today’s',
        week: 'This week’s',
        month: 'This month’s',
        next: 'Next',
        overdue: 'Overdue',
      },
      note: 'Note (optional)',
      notePlaceholder: 'Anything you want to remember or tell your therapist',
      markDone: 'Mark done',
      markDoneWithPhoto: 'Mark done with this photo',
      skip: 'Skip this one…',
      outcome: {
        done: 'Done',
        skipped: 'Skipped',
        doneOccurrence: 'Done for {{date}}. The next one is due {{next}}.',
        skippedOccurrence: 'Skipped for {{date}}. The next one is due {{next}}.',
      },
      toolHint:
        'Open the tool and finish it in the app — this homework then completes itself.',
      evidenceOnly:
        'This one has no “Mark done” — open it and finish it; the homework completes itself when the record lands.',
      // block 2b — a worksheet: the form is the way to do it
      worksheetHint:
        'Open the form, fill it in and send it — this homework then completes itself. A form that needs your signature finishes when you sign it.',
      session:
        'Done with {{name}} in a session — it turns done when your therapist records it.',
      video:
        'It ticks itself off once you have watched it to the end.',
      // block 1d — the tool still writes outside the homework log for this person (Q-b1d-1)
      targetTool: '{{name}} (Toolkit)',
      targetArticle: 'Learn · {{title}}',
      targetLink: 'Link · {{url}}',
      targetAssessment: '{{name}}',
      targetNone: 'Nothing to open — do it your way, then mark it done.',
      // block 6 — a video step: a practice's link plays in the app's player; a Learn clip opens Learn's player
      targetVideo: 'Video · {{player}} · plays in the app',
      targetLearnVideo: 'Learn video · {{title}}',
      notFound: 'This homework is not on your list. Go back to see the rest.',
      // FQ-3 B (2026-09-29): a withdrawn assignment stays, read-only
      withdrawn:
        'Your therapist withdrew this homework, so there is nothing to do now. You can still read it and its comments.',
      paper: {
        // Q-paper (1.5.0): a tool the therapist allowed on paper, or a paper-eligible worksheet
        prompt: 'Done on paper? Add a photo',
        // a task: the photo is optional — it completes on your word either way
        optionalPhoto: 'Add a photo (optional)',
        hint: 'Add a photo of the sheet, then mark it done — your therapist sees the photo.',
        takePhoto: 'Take a photo',
        choosePhoto: 'Choose a photo',
        // the founder's Q-photo-1 A: beside the line a refused camera shows
        openSettings: 'Open Settings',
        remove: 'Remove photo',
        sending: 'Sending the photo…',
        unavailable:
          'Adding a photo needs the latest version of CopingCard. Update the app from the store, then try again.',
        denied:
          'CopingCard is not allowed to use the camera. Allow it in your phone’s Settings, or choose a photo instead.',
        failed:
          'The photo could not be sent. Check your connection and try again.',
        noSession:
          'We could not confirm it is you. Sign out and back in, then add the photo again.',
      },
    },
    // ── block 6 (2026-09-29): "Homework — Assignment — Video player" — a practice's YouTube / Vimeo link ──
    video: {
      source:
        'Plays in the app — {{player}}’s own player. Your therapist shared this link; CopingCard stores no video.',
      target: 'Video · {{link}}',
      ruleTitle: 'Watch to the end',
      rule: 'This step completes by itself once you have watched it to the end. Closing early keeps it open — you can come back.',
      close: 'Close',
      unavailable:
        'This video cannot be played here — it may have been removed, or its owner lets it play only on other sites. Ask your therapist for a new link.',
      offline:
        'No connection? Your viewing is kept on this phone and sent when you are back online.',
    },
    skip: {
      reasonLabel: 'Why are you skipping it?',
      reasons: {
        notTime: 'No time',
        notRelevant: 'Not relevant',
        tooHard: 'Too hard',
        other: 'Other',
      },
      lineLabel: 'Reason (optional)',
      linePlaceholder: 'A few words, if you like',
      therapistSees:
        'Your therapist sees the skip and the reason. They can put it back on your list.',
      submit: 'Skip',
    },
    // P039 — the journal search in "Add my own"
    addMine: {
      searchJournals: 'Search journals',
      noJournalMatch: 'No journal matches “{{query}}”.',
    },
    self: {
      kindLabel: 'Kind',
      kinds: {
        task: 'task',
        tool: 'tool',
        reading: 'reading',
        link: 'link',
        journal: 'journal',
      },
      journalLabel: 'Journal',
      journalNone: 'There are no journals in the library yet.',
      titleLabel: 'Title',
      titlePlaceholder: 'Walk 20 minutes before work',
      instructionsLabel: 'Instructions (optional)',
      toolLabel: 'Tool',
      articleLabel: 'Article',
      linkLabel: 'Link',
      linkPlaceholder: 'https://',
      whenLabel: 'When',
      when: {
        none: 'No date',
        due: 'Due date',
        repeat: 'Repeat',
      },
      dueLabel: 'Due',
      repeat: {
        daily: 'Daily',
        weekly: 'Weekly',
        monthly: 'Monthly',
      },
      timeLabel: 'Time',
      activityToggle: 'Add an activity target',
      activityHint:
        'When you share your phone’s activity, it can tick this off for you.',
      activityTypes: {
        walking: 'Walking',
        running: 'Running',
        cycling: 'Cycling',
      },
      minutesEach: 'Minutes each time',
      timesPerWeek: 'Times a week',
      submit: 'Add to my homework',
      visibleToTherapists:
        'The therapists you share with see what you set yourself, but cannot edit it.',
      problems: {
        titleRequired: 'Give it a title.',
        toolRequired: 'Choose the tool.',
        articleRequired: 'Choose the article.',
        journalRequired: 'Choose the journal.',
        linkInvalid: 'Enter a web address that starts with https://',
        activityInvalid: 'Enter the minutes and how many times a week.',
        weekdayRequired: 'Choose at least one day of the week.',
        dueInPast: 'Choose a due date and time in the future.',
      },
    },
    remind: {
      title: 'Remind me',
      none: 'No reminder on this phone yet.',
      add: 'Remind me',
      addAnother: 'Add another reminder',
      nextLine: 'Next: {{date}}',
      therapistNudges:
        'Your therapist’s due-date nudges still come; this is your own extra.',
      notificationTitle: 'Homework reminder',
      notificationBody: 'Your homework is waiting — open it when you have a moment.',
    },
    // ── block 4 (2026-09-29): the comment thread, Add to calendar, the Toolkit home card ──
    comments: {
      title: 'Comments',
      hint: 'Ask your therapist something, or tell them how it went. They see it in CopingCard.',
      hintSelf: 'Notes about this one. A therapist you let see your data in CopingCard can read them and reply.',
      empty: 'No comments yet.',
      you: 'You',
      add: 'Comment',
      placeholder: 'Write a comment',
      send: 'Send',
      tooLong: 'A comment can have up to 2,000 characters.',
      loadFailed:
        'The comments could not be loaded. Check your connection and try again.',
      retry: 'Try again',
      cancelled: 'This homework was withdrawn, so it takes no new comments.',
    },
    calendar: {
      add: 'Add to calendar',
      hint: 'Puts it in your own calendar. Later changes in CopingCard are not copied there.',
      eventTitle: '{{title}} — CopingCard',
      eventNotes: 'Open it in CopingCard: {{link}}',
      failed:
        'The calendar could not be opened. Try again, or add it to your calendar by hand.',
    },
    homeCard: {
      title: 'Next homework',
      open: 'Open',
      all: 'All homework',
      counts: '{{open}} to do · {{overdue}} overdue',
      countsOpen: '{{open}} to do',
    },
    conflictRetry:
      'This homework was just changed somewhere else. Refresh and try again.',
  },
  // E34 · Pathways on the phone (block 3b, 2026-09-29) — My programs (list), Program (steps), Courses
  // (catalogue) with Start, Leave. The refusals are `homework.errors.PATHWAY_*` (one context, one set of
  // codes). The portal's `pathways` object spreads these in (`...translationEn.pathways`).
  pathways: {
    mine: {
      entryTitle: 'My programs',
      entrySummary: 'Programs from your therapist and programs you started',
      prescribed: 'Prescribed by {{name}}',
      prescribedUnnamed: 'Prescribed by your therapist',
      selfStarted: 'You started this program',
      progress: '{{percent}}% · steps done: {{done}} of {{total}}',
      nextOn: 'Next: {{title}} · unlocks {{date}}',
      nextAfterPrevious: 'Next: {{title}} · unlocks after the previous step',
      nextManual: 'Next: {{title}} · your therapist releases it',
      nextReady: 'Next: {{title}} · unlocking now',
      allReleased: 'Every step has been released',
      completed: 'Completed — well done',
      empty:
        'You are not on a program yet. Your therapist can prescribe one, or you can start a free program.',
      courses: 'Programs',
      coursesHint: 'Self-paced programs you can start yourself',
      rowLabel: '{{name}}, {{percent}} percent done',
    },
    program: {
      prescribed:
        'Your therapist prescribed this program. Your practice’s plan covers it, so there is nothing to pay. To stop it, talk to your therapist.',
      selfStarted: 'You started this program yourself.',
      progress: '{{percent}}% · steps done: {{done}} of {{total}}',
      completed: 'Completed — well done.',
      state: {
        locked: 'Locked',
        released: 'Ready',
        done: 'Done',
        skipped: 'Skipped',
        withdrawn: 'Withdrawn by your therapist',
      },
      unlocks: 'Unlocks {{date}}',
      unlocksNow: 'Unlocking now',
      unlocksAfterPrevious: 'Unlocks after the previous step',
      unlocksManual: 'Your therapist releases it',
      releasedOn: 'Released {{date}}',
      doneOn: 'Done {{date}}',
      skippedOn: 'Skipped {{date}}',
      stepLabel: '{{title}}, {{state}}',
      notFound:
        'This program is no longer available. Go back to My programs and try again.',
    },
    courses: {
      empty:
        'More programs are coming soon: short guided ones you can follow at your own pace. Until then, you can read the articles and watch the videos in Learn.',
      by: 'By {{name}}',
      steps: 'Steps: {{count}}',
      access: {
        free: 'Free',
        purchase: 'Program · one-off purchase',
        owned: 'Owned',
      },
      start: 'Start',
      open: 'Open',
      onIt: 'You are on this program',
      startTitle: 'Start “{{name}}”?',
      startBody:
        'Its first step arrives in your homework within a minute. You can leave the program whenever you like.',
      startConfirm: 'Start program',
      startCancel: 'Not now',
      buy: 'Buy',
      // block 5a — the Buy section (makePurchase (course)): the store's sheet, then "Unlocking…" until the grant lands
      buyPrice: 'Buy · {{price}}',
      unlocking: 'Unlocking…',
      unlockSlow:
        'The store confirmed your purchase, but unlocking is taking longer than usual. Pull down to refresh in a minute. If it still says Buy, write to support@copingcard.com.',
      buyCancelled: 'Purchase canceled. Nothing has changed.',
      buyPending:
        'The store is still processing your purchase — for example, waiting for approval. The program unlocks here as soon as it goes through.',
      buyUnavailable:
        'This program cannot be bought on this phone right now. Check that you are signed in to the App Store or Google Play, then try again later.',
      buyFailed:
        'The store could not complete the purchase. Check your connection and payment details, then try again.',
      restore: 'Bought it with this account on another phone? It is yours here too — pull down to refresh.',
      startError:
        'This program could not be started. Check your connection and try again.',
      // the refusals whose shared wording speaks to a therapist (homework.errors.PATHWAY_*) — in the person's voice
      refusal: {
        PATHWAY_ALREADY_ENROLLED:
          'You are already on this program. Open it from My programs.',
        PATHWAY_RETIRED:
          'This program is no longer offered. Refresh the list and choose another one.',
      },
    },
    leave: {
      button: 'Leave this program',
      title: 'Leave “{{name}}”?',
      body: 'Steps you have not finished are withdrawn from your homework. What you have done stays in your history.',
      reasonLabel: 'Reason (optional)',
      reasonPlaceholder: 'For example: not for me right now',
      confirm: 'Leave',
      keep: 'Keep going',
      error:
        'You could not leave the program. Check your connection and try again.',
    },
  },
  // E34 · Worksheets (block 2a, 2026-09-29) — the vocabulary the phone and the portal share: a
  // template's category, its language and the eight question types. The portal's screens
  // (worksheets.library.* / .builder.* / .retire.*) spread these in; the phone's form (worksheets.form.*,
  // worksheets.sign.* — block 2b) adds its own here.
  worksheets: {
    // E34 block 5b — the box the worksheet import adds to a consent that came with no question (the API
    // writes it into the draft in the DOCUMENT's language; the practice can reword it before saving)
    importAgreeLabel: 'I have read and agree',
    // the import request's own failure (never a refusal — those come back as codes the portal shows)
    importFailed: 'The form could not be imported. Try again in a minute.',
    category: {
      // F-197 (Q-lib-cat-2 A): the purpose categories; `homework` is history only (kept so old rows still read)
      sessions: 'Sessions and progress',
      problems: 'Problems and decisions',
      selfEsteem: 'Self-esteem and self-compassion',
      emotions: 'Emotions and hard moments',
      relationships: 'Relationships and communication',
      homework: 'Homework',
      journal: 'Journal',
      intake: 'Intake',
      consent: 'Consent',
      lesson: 'Lesson',
    },
    language: {
      en: 'English',
      ru: 'Russian',
    },
    fieldType: {
      text: 'Short answer',
      longText: 'Paragraph',
      number: 'Number',
      scale: 'Scale',
      singleChoice: 'One choice',
      multiChoice: 'Several choices',
      date: 'Date',
      checkbox: 'Tick box',
    },
    // block 2b (2026-09-29) — the phone's form (Homework — Worksheet (form)) and its Sign section
    form: {
      progress: 'Section {{current}} of {{total}}',
      requiredLegend: '* Required',
      answerPlaceholder: 'Your answer',
      numberPlaceholder: 'A number',
      chooseDate: 'Choose a date',
      clearDate: 'Clear',
      next: 'Next',
      back: 'Back',
      submit: 'Submit',
      doneReading: 'Done reading',
      video: 'Video — watching is optional and is not recorded.',
      videoUnavailable: 'This video cannot be played here.',
      notFound:
        'This form is not available. Go back to your homework and try again.',
      cancelled:
        'Your therapist has withdrawn this form, so it can no longer be sent.',
      sent: 'Sent. Thank you — your therapist can now see your answers.',
      sentOn: 'Sent on {{date}}.',
      // Q-paper-2 A (1.5.0): the paper alternative to filling the form
      paperPrompt:
        'Prefer paper? Take a photo of the filled-in sheet instead of filling in the form here.',
      paperMarkDone: 'Mark done with this photo',
      signedOn: 'Sent and signed on {{date}}.',
      journalLast: 'Last entry sent {{date}}. You can add another one.',
      backToHomework: 'Back to homework',
      draftKept: 'Your answers are kept on this phone until you send them.',
    },
    sign: {
      title: 'Sign to finish',
      intro:
        'Your answers are sent. This form is finished when you sign it: type your full name and tick “I agree”.',
      nameLabel: 'Your full name',
      namePlaceholder: 'Full name',
      agree: 'I agree',
      submit: 'Sign',
      nameRequired: 'Type your full name to sign.',
      record:
        'Your name is stored with the date, the time and the device you sign from.',
    },
    // E34 · WorksheetEntriesOverTime (D-entries-over-time-2026-10-07) — a repeated worksheet's numbers drawn as
    // lines (the hub's and the phone's Over time). A description, never a verdict: no score is judged here.
    overTime: {
      entry: 'Over time',
      title: '{{name}} — over time',
      back: 'Back to worksheets',
      chart: 'Chart',
      table: 'Table',
      summary_one: '{{count}} entry · {{from}} – {{to}}',
      summary_other: '{{count}} entries · {{from}} – {{to}}',
      legend_one: '{{label}}: latest {{latest}} · {{count}} entry',
      legend_other: '{{label}}: latest {{latest}} · {{count}} entries',
      score: 'Score',
      entryColumn: 'Entry',
      open: 'Open',
      empty: 'Nothing to draw yet',
      emptyHint: 'The numbers appear here after the first submission.',
      emptySent: 'Sent {{date}}. The numbers appear here after the first submission.',
      eyebrow: 'Client hub · {{name}} · Worksheets & documents',
      eyebrowAnon: 'Client hub · Worksheets & documents',
      note: 'Numeric fields only (number · scale). Text answers stay in each entry — open one to read it. These are the client’s own numbers: no score is judged here, nothing alerts.',
      loadFailed: 'This worksheet could not be loaded. Try again in a minute.',
      notAvailable: 'This worksheet is not available.',
      chartLabel: 'Line chart of {{name}} over time',
      entries: 'Entries',
      pointLabel: '{{label}}, {{date}}: {{value}}',
    },
  },
  reminders: {
    // E05 · the RRULE reminder kernel. Decider rejection codes
    // (packages/domain/src/reminders/errors.ts) — one key per code, in both languages; the domain
    // test error-codes-i18n fails when one is missing.
    errors: {
      REMINDER_NOT_FOUND:
        'This reminder is no longer available. Go back and open the reminder list again.',
      REMINDER_ALREADY_ENDED:
        'This reminder has already been turned off. Switch it back on to change its schedule.',
      REMINDER_RULE_NOT_SUPPORTED:
        'This repeat pattern is not supported yet. Choose daily, weekly, monthly or a single date.',
      REMINDER_DTSTART_MISMATCH:
        'The start date does not match the repeat pattern. Pick a start date the reminder can actually fall on.',
      REMINDER_TIMEZONE_INVALID:
        'This reminder needs a time zone we can recognize. Check your device time-zone setting and try again.',
      REMINDER_ZONE_REQUIRED_ON_BEHALF:
        'A reminder you set for a client has to name that client’s time zone, so it reaches them at the hour you chose.',
      REMINDER_SUBJECT_ZONE_UNKNOWN:
        'This client’s time zone is not known yet, so a reminder could arrive at the wrong time of day. Ask them to open the app once, then set it.',
      REMINDER_TARGET_NOT_SUPPORTED:
        'Reminders cannot be set for this kind of item yet.',
      REMINDER_CHANNEL_NOT_SUPPORTED:
        'This reminder cannot be delivered that way. Choose a device notification.',
      REMINDER_OCCURRENCE_NOT_FOUND:
        'That date is not one of this reminder’s times, so there was nothing to skip.',
      REMINDER_TARGET_IMMUTABLE:
        'A reminder cannot be moved to a different card. Add a reminder there instead.',
      REMINDER_NOT_CONVERTED:
        'This reminder is still being prepared. Please try again in a moment.',
      // The three refusals of the BULK acts. Each is an idempotent no-op at the resolver — a
      // downgrade signal arriving twice, a regain for someone who was never trimmed, a card with no
      // reminders — so a person should never read these. They exist because the domain code is the
      // law and a code without copy cannot ship (the error-codes-i18n test).
      REMINDER_NOTHING_TO_TRIM:
        'Your reminders are already within the free plan, so nothing was turned off.',
      REMINDER_NOTHING_TO_RESTORE:
        'There are no reminders to bring back. Reminders you switched off yourself stay off.',
      REMINDER_NO_SCHEDULES_FOR_TARGET:
        'This card has no reminders, so there was nothing to turn off.',
      REMINDER_NOT_STOPPED:
        'This reminder is still on. Switch it off first, or change its time from the reminder itself.',
      USER_NOT_AUTHORIZED:
        'You do not have access to this reminder. If you think this is a mistake, contact support@copingcard.com and mention code REMINDER-AUTH-1.',
    },
    // The two answers the resolver lane gives when the failure is not a named decider code: a
    // rejection with no copy of its own, and a lost DCB race (two saves for the same schedule).
    command: {
      rejected: 'We could not save this reminder. Please try again.',
      conflictRetry:
        'This reminder was changed somewhere else a moment ago. Open it again and re-apply your change.',
    },
    // The rule summary a list row and the screen reader read out. The DOMAIN answers which key and
    // which values (packages/domain/src/reminders/rrule/describe.ts); the sentence lives here, so
    // Russian agreement stays where a translator can see it.
    summary: {
      daily: 'Every day at {{time}}',
      everyNDays: 'Every {{interval}} days at {{time}}',
      weekly: 'Every week on {{days}} at {{time}}',
      everyNWeeks: 'Every {{interval}} weeks on {{days}} at {{time}}',
      monthlyOnDay: 'Every month on day {{day}} at {{time}}',
      monthlyOnNthWeekday: 'Every month on the {{nth}} {{day}} at {{time}}',
      everyNMonths: 'Every {{interval}} months at {{time}}',
      yearly: 'Every year on {{date}} at {{time}}',
      everyNYears: 'Every {{interval}} years on {{date}} at {{time}}',
      oneTime: 'Once, on {{date}} at {{time}}',
      unsupported:
        'This reminder uses a schedule this version cannot show. Update the app to see it.',
      boundNever: 'Repeats indefinitely',
      boundCount: 'Repeats {{count}} times',
      boundUntil: 'Repeats until {{date}}',
      skipped_one: '{{count}} time skipped',
      skipped_other: '{{count}} times skipped',
    },
  },
  // ── E05 · R1 (2026-09-05) — THE E-ERA AUTHORING SURFACE ────────────────────────────────────
  // The board's E-era Card-Notifications screen: a per-card SCHEDULE LIST (rule summary, next
  // occurrence, add → picker, per-row "Skip next") plus the STOPPED section, which is the view the
  // kernel has instead of a mutable `enabled` flag. Nothing here is verbatim legacy copy: the
  // legacy screen has three fixed slots called morning/day/evening, and this one has schedules.
  reminderSchedules: {
    title: 'Reminders for this card',
    intro:
      'Each reminder has its own schedule. Add as many as you need, skip a single day, or switch one off without losing its time.',
    addSchedule: 'Add a reminder',
    empty: 'No reminders yet. Add one to be nudged about this card.',
    // The a11y read-back the board asks for. `{{summary}}` is rendered from `reminders.summary.*`,
    // which the domain chooses; this only says what the sentence IS.
    ruleSummary: 'Reminder: {{summary}}',
    nextOccurrence: 'Next: {{when}}',
    noNextOccurrence: 'No upcoming times',
    skipNext: 'Skip next',
    skipNextDone: 'The next time was skipped.',
    editSchedule: 'Edit',
    stoppedTitle: 'Switched off',
    stoppedHint:
      'These keep the time you chose. Switch one back on and it starts reminding you again.',
    changeTime: 'Change time',
    removeSchedule: 'Remove',
    removeConfirmTitle: 'Remove this reminder?',
    removeConfirmText:
      'The reminder stops and disappears from this card. You can add a new one at any time.',
    toggleOn: 'Turn this reminder on',
    toggleOff: 'Turn this reminder off',
  },
  // The Reminder Schedule Picker — the screen that makes the kernel's extra expressive power
  // reachable by a person. It composes ONLY the whitelisted v1 rules; there is no free-form input,
  // because a rule outside the subset is a notification at a time nobody chose.
  reminderSchedulePicker: {
    titleNew: 'New reminder',
    titleEdit: 'Edit reminder',
    freqLabel: 'How often',
    freq: {
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      oneTime: 'One time',
    },
    intervalLabel: 'Repeat every',
    intervalUnit_daily_one: 'day',
    intervalUnit_daily_other: 'days',
    intervalUnit_weekly_one: 'week',
    intervalUnit_weekly_other: 'weeks',
    intervalUnit_monthly_one: 'month',
    intervalUnit_monthly_other: 'months',
    daysLabel: 'On these days',
    monthDayLabel: 'Day of the month',
    timeLabel: 'At',
    startsLabel: 'Starting',
    endLabel: 'Ends',
    endNever: 'Never',
    endAfter: 'After a number of times',
    endOn: 'On a date',
    endCountLabel: 'How many times',
    endUntilLabel: 'Last day',
    // The board asks the picker to steer away from 02:00–03:00 and say why: on the night the clocks
    // go forward that hour does not exist, and RFC 5545 skips a time that never happens.
    dstNote:
      'Times between 2:00 and 3:00 are skipped on the night the clocks go forward, so that reminder will not arrive that day.',
    invalidRule:
      'This combination cannot be scheduled. Change the repeat pattern or the start day.',
    // Named separately because the generic message above sent the founder looking at the repeat
    // pattern, which was never the problem (2026-09-07).
    endBeforeStart:
      'The last day is before the first reminder. Choose a later last day, or an earlier start.',
    weekdayRequired: 'Choose at least one day of the week.',
    save: 'Save reminder',
    weekday: {
      MO: 'Mon',
      TU: 'Tue',
      WE: 'Wed',
      TH: 'Thu',
      FR: 'Fri',
      SA: 'Sat',
      SU: 'Sun',
    },
  },
  downwardArrow: {
    upsert: {
      rejected:
        'This downward arrow could not be saved — please check the entries and try again.',
      conflictRetry:
        'This downward arrow was just updated on another device. Reloading your latest version…',
    },
    // decider rejection codes (packages/domain/src/downwardArrow/errors.ts) — one key per code,
    // in both languages; the domain test error-codes-i18n fails when one is missing. The legacy
    // resolver returned a silent null here, which is the L10 finding these codes correct.
    errors: {
      BELIEFS_REQUIRED:
        'Please write at least one belief before saving this downward arrow.',
      BELIEF_EMPTY: 'Please fill in each step of the chain, or remove it.',
    },
  },
  thoughtTesting: {
    submit: {
      invalid:
        "Some of this thought test's steps could not be read. Please check the entries and try again.",
      rejected:
        'This step could not be saved — please check the entry and try again.',
      conflictRetry:
        'This thought test was just updated on another device. Reloading your latest steps…',
    },
    // decider rejection codes (packages/domain/src/thoughtTesting/errors.ts) — one key per code,
    // in both languages; the domain test error-codes-i18n fails when one is missing
    errors: {
      DESCRIPTION_REQUIRED: 'Please describe the event before moving on.',
      UNKNOWN_THOUGHT_TEST_EVENT_TYPE:
        'This step comes from a newer app version. Please update CopingCard to continue.',
      AUTOMATIC_THOUGHT_REQUIRED:
        'Please write the automatic thought for the front of the card.',
      ALTERNATIVE_THOUGHT_REQUIRED:
        'Please write at least one realistic thought for the back of the card.',
      THOUGHT_TEST_NOT_FOUND:
        'This card could not be found. Please refresh the list and try again.',
      THOUGHT_TEST_DELETED:
        'This card has been deleted. Please refresh the list to see your current cards.',
      EVIDENCE_FOR_REQUIRED:
        'Please add at least one piece of evidence that supports the thought.',
      EVIDENCE_AGAINST_REQUIRED:
        'Please add at least one piece of evidence against the thought.',
      RESULT_OUT_OF_RANGE:
        'Please rate how much you believe the thought, from 0 to 100.',
      LOCATION_REQUIRED: 'Please choose a place for this reminder.',
      LOCATION_RELATION_UNSUPPORTED:
        'This reminder cannot be attached to that place. Please pick another one.',
      REMINDER_PRESET_UNKNOWN:
        'This reminder option comes from a newer app version. Please update CopingCard to continue.',
      SITUATION_NOT_FOUND:
        'This situation could not be found. Please refresh the list and try again.',
      SITUATION_HOLDS_CARDS:
        'This situation still has coping cards. Delete the cards first, and the situation stays here as a draft.',
      SITUATION_ALREADY_DELETED:
        'This situation has already been deleted. Please refresh the list to see what is left.',
    },
    // E-era wizard navigation (founder Q12, 2026-09-05): "better visibility/navigation… not simply
    // looping till finished", an ESCAPE HATCH, and per-thought progress. Every other string on the
    // wizard is the LEGACY key — the two eras are the same screens.
    wizard: {
      thoughtChip: 'Thought {{index}} of {{count}}',
      // the SECOND and later visits to the automatic-thoughts step edit one thought, not the list
      // (founder 2026-09-07: listing them again there was confusing)
      oneThoughtTitle: 'Your Automatic Thought',
      exit: 'Save & exit',
      summaryTitle: 'That thought is tested',
      summaryBody:
        'Your coping card is ready. You can work through another thought about the same situation, or stop here — everything is saved either way.',
      testAnotherThought: 'Test another thought about this situation',
      done: 'Done',
      resumeTitle: 'Continue where you stopped',
      resumeSubtitle:
        'These thought tests are still open. Tap one to pick it up at the step you left.',
      resumeEmpty: 'Nothing left open — every thought test you started is finished.',
      resumeStart: 'Start a new thought test',
      resumeDraft: 'Not started yet',
      resumeStepLabel: 'Next step: {{step}}',
      situationThoughtCount: '{{count}} thoughts',
      deleteSituation: 'Delete situation',
      deleteSituationConfirmTitle: 'Delete this situation?',
      deleteSituationConfirmBody:
        'It has no coping cards left, so nothing you made is lost. This cannot be undone.',
      deleteSituationConfirm: 'Delete',
      deleteSituationCancel: 'Keep it',
      stepNames: {
        activatingEvent: 'the event',
        behaviors: 'what you did',
        automaticThought: 'the automatic thought',
        evidenceFor: 'evidence for',
        evidenceAgainst: 'evidence against',
        cognitiveDistortions: 'cognitive distortions',
        alternativeThought: 'realistic thoughts',
        outcome: 'the result',
      },
    },
  },
  thoughtsTesting: {
    addEvidenceAgainst: 'Add evidence against',
    addEvidenceFor: 'Add evidence',
    automaticThought: 'Automatic thought',
    automaticThoughtAdd: 'Add thought',
    automaticThoughtBelief: 'Belief',
    automaticThoughtDefinition:
      'Automatic thought is an idea or a visual image, an assessment of an event or yourself in it, which appeared together with or shortly before the worsening of the condition.',
    automaticThoughtName: 'Name',
    autoThoughtsTitle: 'List Your Automatic Thoughts',
    buttonNextText: 'Next Step',
    chooseEmotions: 'Choose Emotions',
    chooseFeelings: 'Choose Sensations',
    cognitiveDistortions: 'Cognitive Distortions',
    cognitiveDistortionsDefinition:
      'A cognitive distortion is an exaggerated or irrational thought pattern',
    cognitiveDistortionsPlaceholder: 'Select Cognitive Distortions',
    congrats: 'Congratulations!',
    // TODO: refactor to i18n withCount and _plural
    // https://www.i18next.com/translation-function/plurals
    congratsCardCreated: `A New Coping Card was created as a result.`,
    congratsCardsCreatedEnd: `new Coping Cards have been created as a result.`,
    congratsCardsCreatedStart: ``,
    congratsIntro: `You finished testing your automatic thoughts!`,
    congratsTextPlural: `You can find the Coping Cards for these thoughts in the Coping Cards section of the App.`,
    congratsTextSingle: `You can find the Coping Card for this thought in the Coping Cards section of the App. `,
    dateAndDuration: 'Event Date and Duration',
    day: 'Day reminder',
    emotionDefinition:
      'Emotion is a mental process reflecting in the form of direct experience (satisfaction, joy, fear, etc.) the significance of phenomena and situations acting on a person. Part of the experience of emotions are bodily sensations.',
    emotionsTitle: 'Describe Your Emotions',
    evening: 'Evening reminder',
    eventInfo: 'An event that made your condition noticeably worse.',
    eventLabel: 'Describe Activating Event',
    eventLasted: 'lasted for',
    eventStarted: 'started on',
    eventTitle: 'Activating Event',
    evidenceAgainst: 'Fact/Evidence against the Negative Thought',
    evidenceFor: 'Thought fact/evidence',
    withEvidenceFor: 'Thought fact/evidence',
    withEvidenceAgainst: 'And evidence against the Negative Thought',
    alternativeThought: 'Alternative explanation',
    alternativeThoughtInfo:
      'Give a possible alternative explanation of the evidence for, if there is one.',
    alternativeThoughtTitle:
      'What else can be the explanation of this fact, except for the automatic thought?',
    feelingsDefinition:
      'Sensation is the process of sensual cognition of separate properties of phenomena and objects of the objective world, i.e. the process of reflection of direct influence of stimuli on sensory organs (receptors).',
    feelingsInBody: 'Sensations in the Body',
    feelingsTitle: 'Describe Your Sensations',
    forThought: 'For the automatic negative thought',
    with: 'With a',
    having: 'Which can have an',
    location: 'Location',
    locationReminders: 'Geolocation Notifications',
    locationRemindersDisclosure:
      'CopingCard requires collecting precise location data to enable Geolocation Notifications for your cards even when the app is closed or not in use.',
    locationRemindersDeferred:
      'Location reminders will be connected in the dedicated location-reminders migration. You can continue and finish the thought test now.',
    locationRemindersWhy:
      'Geofencing location reminders can help your recall realistic thought when you are approaching (200 yards) and/or leaving a location. ',
    morning: 'Morning reminder',
    optionalData: 'Optional Data',
    participants: 'Participants',
    photos: 'Photo or Image',
    photosDialogueTitle: 'Choose Image Source',
    rateEmotions: 'Rate Emotions Strength',
    realisticThought: 'Realistic thought or idea',
    realisticThoughtsDefinition:
      'Realistic thoughts are judgments about the event or yourself, which follow from the facts you listed or (if it is impossible to verify the original thought with facts) help you feel better.',
    realisticThoughtsTitle: 'List Realistic and Helpful Ideas',
    reminderLabel: 'Select Reminder Time',
    reminders: 'Thought reminders',
    remindersWhy:
      'Reading through the automatic and realistic sides of the coping cards 2-3 times a day greatly reduces the effects of the dysfunctional thoughts. We pre-created 3 reminders for you to read the thoughts, but you can customize the time to suit you better.',
    resultBelief: 'How strongly you believe in the initial negative thoughts?',
    resultEmotionStrength: 'How strong is the main initial negative emotion?',
    resultsTitle: 'Assess Result',
    saveError:
      'We could not save this thought test. Please try again. If it keeps happening, contact support@copingcard.com.',
    selectEnd: 'Select End Time',
    selectStart: 'Select Start Time',
    thoughtForForThought: 'for thought',
    thoughtsAgainstDefinition:
      'Facts or Evidence which are accessible to sensory perception and verification of specific phenomena of reality (facts), which indicate that this thought is wrong.',
    thoughtsAgainstTitle:
      'List Facts and Evidence against  the Negative Thought',
    thoughtsForDefinition:
      'Facts or Evidence which are accessible to sensory perception and verification of specific phenomena of reality (facts), which indicate that this thought is correct.',
    thoughtsForTitle: 'List Facts and Evidence supporting the Negative Thought',
    timeReminders: 'Time-based Reminders',
    validationErrors:
      'It looks like there are some validation errors. Please fix them before continuing or contact the support if something is not evident on how to fix it.',
  },
  validators: {
    email: 'must be a valid email',
    regex: 'must match the following: {{regex}}',
    required: 'is a required field',
    retypePassword: 'passwords must match',
    stringMax: 'must be at most {{max}} characters',
    stringMin: 'must be at least {{min}} characters',
    url: 'Please enter a valid URL',
  },
  viciousCycles: {
    title: 'Vicious Cycles',
    info: 'Vicious Cycles',
    definition: `In cognitive behavior therapy, vicious cycles refer to patterns of negative thoughts, emotions, and behaviors that maintain or exacerbate a particular problem or issue. These cycles involve a self-perpetuating loop in which negative beliefs and emotions lead to maladaptive behaviors, which in turn reinforce negative beliefs and emotions. The result is a worsening of the problem or issue, as well as an increase in the intensity of the negative thoughts, emotions, and behaviors associated with it. The goal of cognitive behavior therapy is to identify and disrupt these vicious cycles by helping clients develop more adaptive coping strategies and beliefs, which can ultimately lead to positive change and improved well-being.`,
    edit: 'Edit Vicious Cycle',
    totalCount: 'Total: {{count}}',
    create: 'Create Vicious Cycle',
    advancedWarning1: `This is an advanced Cognitive Behavioral Therapy technique. If you are not sure how to use it, it might be better to `,
    advancedWarning2: ` to use our Platform or `,
    advancedWarning3: ` who already uses it in therapy.`,
    inviteTherapist: 'invite your therapist',
    deleteSuccess: 'Vicious cycle deleted successfully',
    deleteConfirmTitle: 'Delete vicious cycle?',
    deleteConfirmText:
      'This vicious cycle will be permanently deleted. This cannot be undone.',
    therapistFind: 'find one',
  },
  viciousCycle: {
    title: 'Vicious Cycle',
    selectTemplate: 'Select template (optional)',
    cycleName: 'Name',
    thoughts: 'Thoughts, actions or some facts',
    relations: 'Leads To',
    influences: 'Influences',
    tempalteLabel: 'Start from a template (optional)',
    saveSuccess: 'Vicious cycle saved successfully',
    saveError:
      'We could not save this vicious cycle. Please try again. If it keeps happening, contact support@copingcard.com.',
    addField: 'Add thought, action or fact',
    // E12 (ES-era) — command outcomes and the decider's rejection codes
    // (packages/domain/src/viciousCycle/errors.ts): one key per code, in both languages.
    command: {
      rejected:
        'This vicious cycle could not be saved — please check the entries and try again.',
      conflictRetry:
        'This vicious cycle was just updated on another device. Reloading your latest version…',
    },
    errors: {
      VICIOUS_CYCLE_NOT_FOUND:
        'This vicious cycle no longer exists. Please go back to the list and try again.',
      VICIOUS_CYCLE_ALREADY_EXISTS:
        'This vicious cycle was already created. Please reload and continue editing it.',
      USER_NOT_AUTHORIZED:
        'You do not have access to this vicious cycle. If you think this is a mistake, contact support@copingcard.com and mention code CYCLE-AUTH-1.',
      INDEX_OUT_OF_RANGE:
        'That part of the cycle has changed. Please reload and try again.',
    },
  },
  shared: {
    genderOptions: ['Male', 'Female', 'Other'],
    preferredPronounsOptions: [
      'He/Him/His',
      'She/Her/Hers',
      'They/Them/Theirs',
    ],
    abcModel: {
      title: 'ABC Model',
      saveSuccess: 'ABC model saved successfully',
      saveError:
        'Could not save this ABC model. Please try again. If the problem continues, contact support@copingcard.com.',
      loadError:
        'Could not load this ABC model. Please reopen it or try again in a moment. If the problem continues, contact support@copingcard.com.',
      description: `The ABC model technique is a cognitive-behavioral therapy (CBT) tool used to help individuals understand the connection between their thoughts, emotions, and behaviors. The model is based on the premise that it is not the events themselves that cause emotional distress, but rather our interpretation of those events. The ABC model consists of three main components:  

A - Activating event: The situation or trigger that initiates a thought or emotion. 

B - Beliefs: The thoughts or interpretations we have about the activating event. 

C - Consequences: The emotional and behavioral responses resulting from our beliefs. 

The goal of the ABC model is to help individuals identify and challenge their irrational or maladaptive beliefs and replace them with healthier, more adaptive thoughts, thereby promoting more positive emotional and behavioral outcomes.`,
      a: 'A - Activating event',
      aPlaceholder: 'What happened?',
      b: 'B - Beliefs',
      bPlaceholder: 'What did you think?',
      c: 'C - Consequences',
      behaviors: 'Behavior',
      behaviorsPlaceholder: 'How did you react?',
      emotions: 'Emotions',
      emotionsPlaceholder: 'Which emotions did you experience?',
      sensations: 'Sensations',
      sensationsPlaceholder: 'What body sensations did you experience?',
    },
    abcModels: {
      title: 'ABC Models',
      create: 'Create ABC Model',
      edit: 'Edit ABC Model',
      loadError:
        'Could not load your ABC models right now. Please pull to refresh or try again in a moment. If the problem continues, contact support@copingcard.com.',
      spec: {
        a: 'I was 15 minutes late for a meeting',
        b: 'I am disorganized',
        cBehavior: 'I decided to skip the meeting altogether',
      },
    },
    behaviorExperiment: {
      spec: {
        hypothesisA: `I'm going to freeze up and embarrass myself if I try to speak in public`,
        hypothesisAStrength: '90',
        hypothesisAConfirmationCriteria:
          'Unable to speak fluently, noticeable nervousness, negative feedback from audience',
        hypothesisB:
          'I will be able to speak in public without embarrassing myself',
        hypothesisBStrength: '30',
        hypothesisBConfirmationCriteria:
          'Able to speak fluently, manage nervousness, and receive positive feedback from the audience',
        settings: {
          experiment: 'Public speaking practice',
          time: '15-20 minutes',
          place: 'Local community center or public speaking group',
          people: 'Audience members, possibly friends or family for support',
          resources:
            'Prepared speech or talking points, presentation materials',
        },
        safetyBehaviors:
          'Avoiding eye contact, avoiding difficult topics, speaking too quietly',
        helpfulCopingStrategies:
          'Deep breathing exercises, visualization techniques, practice/rehearsal',
        prediction: {
          behaviors: 'Verbal communication, body language, audience engagement',
          emotions: ['hopelessness', 'anxiety'],
          feelings: ['chills', 'heartbeat rate change'],
          otherPredictions:
            'Increased confidence, improvement of presentation skills',
        },
        followUpExperimentsIdeas:
          'Attempting more challenging speaking situations or larger audiences',
      },
      title: 'Behavior Experiment',
      description: `A behavior experiment is a technique commonly used in Cognitive Behavioral Therapy (CBT) to test the validity of a patient's beliefs and assumptions. The purpose of the experiment is to gather empirical evidence that challenges the patient's unhelpful thoughts and behaviors, and replaces them with more realistic and adaptive ones.

      In a behavior experiment, the therapist and patient collaboratively design an experiment to test the patient's assumptions or beliefs. For example, if a patient has a fear of public speaking, the experiment could involve giving a short speech to a small group of trusted individuals. The therapist and patient would then observe and evaluate the patient's experience, including any physiological or emotional responses, and any feedback received.
      
      By conducting the experiment and analyzing the results, the patient can gain new insights into their thoughts and behaviors, and develop more adaptive coping strategies. Behavior experiments are often used in conjunction with other CBT techniques, such as cognitive restructuring, to help patients challenge and change their unhelpful thought patterns.
      `,
      purpose: 'Experiment Purpose',
      purposeRequired: 'Experiment Purpose is required',
      purposePlaceholder: 'What do you want to test?',
      purposes: [
        'Develop the Formulation/Conceptualization',
        'Testing Negative Cognitions',
        'Constructing and testing new perspectives',
      ],
      purposesTip: `
      Develop the Formulation/Conceptualization: these experiments help elaborate the formulation of the patient's problems, especially early in therapy when understanding is still evolving. These experiments offer therapists and clients the chance to observe subtle aspects of the patient's behavior and thinking that may not be accessible purely through memory-based verbal reports.
      Testing Negative Cognitions: test negative cognitions, reducing the credibility of outdated and unhelpful negative automatic thoughts, dysfunctional assumptions, and core beliefs. These experiments allow patients to see the validity of new, more adaptive perspectives through direct personal experience.
      Constructing and testing new perspectives: creating and strengthening new, more realistic and more helpful thoughts, assumptions, and beliefs.
      `,
      design: 'Experiment Design',
      designRequired: 'Experiment Design is required',
      designs: ['Hypothesis-testing experiment', 'Discovery experiment'],
      designsTip: `Hypothesis-testing experiments try to find answers to questions similar to ‘Is it true that... ?’.
      Discovery experiments are more open, investigative, discovery-oriented questions similar to ‘What would happen if . . . ?’
      `,
      hypotheses: 'Hypotheses',
      hypothesisType: 'Number of Hypotheses',
      hypothesisTypeVariants: [
        'Testing hypothesis A',
        'Comparing hypothesis A & hypothesis B',
        'Testing hypothesis B',
      ],
      hypothesisTypeVariantsTip: `
      Testing hypothesis A: tests the validity of a current unhelpful cognition (hypothesis A).
      Comparing hypothesis A & hypothesis B: tests the validity of a current unhelpful cognition (hypothesis A) and a new, potentially helpful or justified cognition (hypothesis B).
      Testing hypothesis B: tests the validity of a new, potentially helpful cognition (hypothesis B).
      `,
      type: 'Experiment Type',
      typeVariants: ['Active experiment', 'Observational experiment'],
      activeSubtype: 'Active Experiment Subtype',
      activeSubtypes: ['In real situations', 'Simulated (e.g. role play)'],
      observationalSubtype: 'Observational Experiment Subtype',
      observationalSubtypes: [
        'Direct observation (modeling)',
        'Survey',
        'Information gathering from other sources',
      ],
      settings: 'Settings',
      timeAndPlace: 'Time and Place',
      time: 'Date and Time',
      place: 'Place',
      people: 'People',
      peoplePlaceholder: 'Who will be involved in the experiment?',
      resources: 'Resources and Instruments',
      resourcesPlaceholder: 'What resources will you need?',
      survey: 'Survey',
      surveyPlaceholder: 'Info on the survey you could use.',
      safetyBehaviors: 'Safety Behaviors',
      safetyBehaviorsPlaceholder:
        'What safety/avoidance behaviors will you suspend?',
      safetyBehaviorsTip: `Safety-seeking behaviors are actions taken to reduce negative emotions in situations where they occur. Suppressing these behaviors is crucial in behavioral experiments to prevent interference with the experiment and therapy process.
      If safety-seeking behaviors are allowed to persist, they can reinforce the individual's belief that the stimulus or situation is dangerous, and what helps is the safety behavior, thus maintaining or even exacerbating their negative emotions.
        `,
      safetyAndCoping: 'Safety Behaviors and Coping Strategies',
      helpfulCopingStrategies: 'Helpful Coping Strategies',
      helpfulCopingStrategiesPlaceholder:
        'What coping strategies can you use to manage the situation?',
      selectOrType: 'Select or type',
      hypothesisA: 'Hypothesis A',
      hypothesisAPlaceholder:
        'What is the thought or belief you would like to test?',
      hypothesisAStrength: 'How strongly you believe in Hypothesis A?',
      hypothesisATip:
        'Hypothesis A is current unhelpful cognition you want to test.',
      hypothesisAConfirmationCriteria:
        'Criteria/signs for confirming Hypothesis A',
      hypothesisB: 'Hypothesis B',
      hypothesisBPlaceholder:
        'What is a plausible and helpful alternative thought or belief you would like to test?',
      hypothesisBStrength: 'How strongly you believe in Hypothesis B?',
      hypothesisBTip:
        'Hypothesis B is a new, potentially helpful cognition you want to test.',
      hypothesisBConfirmationCriteria:
        'Criteria/signs for confirming Hypothesis B',
      experiment: 'Experiment',
      expremientPlaceholder: 'How can you test this hypothesis?',
      prediction: 'Prediction',
      predictionPlaceholder: 'What do you expect to happen?',
      expectedEmotions: 'Expected Emotions',
      expectedEmotionsPlaceholder:
        'What emotions do you expect to experience during the experiment?',
      expectedFeelings: 'Expected Body Sensations',
      behaviors: 'Expected reaction of the environment/people',
      behaviorsPlaceholder:
        'How do you expect the environment, other people and yourself to react?',
      physicalReactions: 'Physical Reactions',
      physicalReactionsPlaceholder: 'How do you expect your body will react?',
      otherPredictions: 'Other Predictions',
      otherPredictionsPlaceholder: 'What else do you expect to happen?',
      outcome: 'Outcome',
      outcomePlaceholder: 'What happened?',
      actualBehavior: 'Actual reaction of the environment/people',
      actualBehaviorPlaceholder:
        'How did the environment, other people and yourself react?',
      actualEmotions: 'Actual Emotions',
      actualFeelings: 'Actual Body Sensations',
      newThought: 'New Thought or Belief',
      newThoughtPlaceholder:
        'Based on the evidence from the experiment, what is your new thought?',
      evaluation: 'Evaluation',
      newLearnings: 'New Learnings',
      newLearningsPlaceholder: 'What did you learn from the experiment?',
      meaningForOriginalBelief: 'Meaning for the original belief',
      meaningForOriginalBeliefPlaceholder:
        'What does this mean for your original belief or prediction?',
      oldThoughtStrength:
        'How strongly do you believe in your old thought or belief after the experiment?',
      newThoughtStrength:
        'How strongly do you believe in your new thought or belief?',
      generateGptSuggestions: 'Generate AI Suggestions',
      generateGptSuggestionsMore: 'Generate Another Variant',
      generateGptSuggestionsTip: ``,
      generating: 'Generating suggestions using AI. This can take some time...',
      generationError: 'Error generating suggestions',
      patientReflections: 'Patient Reflections',
      patientReflectionsPlaceholder: 'Enter patient reflections',
      therapistReflections: 'Therapist Reflections',
      therapistReflectionsPlaceholder: 'Enter therapist reflections',
      followUp: 'Follow-up Experiments',
      followUpExperimentsIdeas: 'Follow-up Experiments Ideas',
      followUpExperimentsIdeasPlaceholder: 'Enter follow-up experiments ideas?',
      generatedWarning: `Warning!
      
      Some of the content below has been generated by AI.
      
      It is your responsibility as a Mental Health Professional to review and edit the content before using it with your clients.`,
      generatedVariant: 'Generated Variant',
      saveSuccess: 'Behavior Experiment saved successfully',
      saveError:
        'We could not save this behavior experiment. Please try again. If it keeps happening, contact support@copingcard.com and mention code BEHAVIOR-EXPERIMENT-SAVE-1.',
      loadError:
        'We could not load this behavior experiment right now. Please go back and try again. If it keeps happening, contact support@copingcard.com and mention code BEHAVIOR-EXPERIMENT-LOAD-1.',
      purposeSelectText: 'Choose experiment purpose',
      designSelectText: 'Choose experiment design',
      hypothesisTypeSelectText: 'Choose number of hypotheses',
      typeSelectText: 'Choose experiment type',
      activeSubtypeSelectText: 'Choose active experiment subtype',
      observationalSubtypeSelectText: 'Choose observational experiment subtype',
      jumpToOutcome: 'Jump to Outcome',
      // E02 (ES-era) mobile — the per-step design wizard, observations and completion screens
      stepTitles: [
        'Setup',
        'Hypotheses',
        'Plan',
        'Prediction',
        'Review & Activate',
      ],
      setupLocked:
        'The purpose, design, number of hypotheses and type are fixed once an experiment is started.',
      saveAndExit: 'Save & exit',
      designSummary: 'Design summary',
      activate: 'Activate experiment',
      activateHint:
        'Activating makes the experiment observable — you can then record what happens each time you run it.',
      activateIncomplete:
        'Complete the hypotheses, plan and prediction steps to activate the experiment.',
      alreadyActive: 'This experiment is already active.',
      backToExperiment: 'Back to experiment',
      recordObservation: 'Record Observation',
      editObservation: 'Edit Observation',
      runNumber: 'Run #{{n}}',
      amendRun: 'Amend run #{{n}}',
      whatHappened: 'What happened?',
      whatHappenedPlaceholder: 'Describe this run',
      whichHypothesisHeld: 'Which hypothesis held?',
      hypothesisHeldOptions: ['A', 'B', 'Mixed'],
      hypothesisHeldShort: ['Hyp A held', 'Hyp B held', 'Mixed'],
      rating: 'Belief in original thought now',
      learnings: 'Learnings',
      learningsPlaceholder: 'What did you learn?',
      saveObservation: 'Save observation',
      saveChanges: 'Save changes',
      addObservation: '+ Add observation',
      completeExperiment: 'Complete',
      reviewCompletion: 'Review completion',
      markCompleted: 'Mark completed',
      completeTitle: 'Complete Experiment',
      observationsTitle: 'Observations ({{count}})',
      observationsEmpty:
        'No observations yet. Add one each time you run the experiment.',
      observationsLabel: 'Observations',
      // the client-side order toggle in the Detail screen's Observations header (founder ruling
      // 2026-09-02, handoff §13): oldest first by default, as the runs were recorded; the choice
      // re-orders what is already on screen and is not persisted anywhere
      observationsOrder: 'Order observations',
      observationsOldestFirst: 'Oldest first',
      observationsNewestFirst: 'Newest first',
      runsCount: '{{count}} runs',
      durationLabel: 'Duration',
      durationDays: '{{count}} days',
      statusDraft: 'Draft',
      statusActive: 'Active',
      statusCompleted: 'Completed',
      activateFirst:
        'Activate the design first — then you can record observations.',
      continueDesign: 'Continue design',
      editDesign: 'Edit design',
      legacyOutcome: 'Outcome (recorded before observations existed)',
      // the DERIVED first observation of a converted row (founder ruling 2026-09-02): read-only
      legacyObservationNote: 'Recorded in the previous version',
      untitled: 'Untitled experiment',
      newThoughtBelief: 'Belief in new thought',
      oldThoughtBelief: 'Belief in old thought',
      // E02 (ES-era) — command outcomes and the decider's rejection codes
      // (packages/domain/src/behaviorExperiment/errors.ts): one key per code, in both languages.
      command: {
        rejected:
          'This behavior experiment could not be saved — please check the entries and try again.',
        conflictRetry:
          'This behavior experiment was just updated on another device. Reloading your latest version…',
      },
      errors: {
        BEHAVIOR_EXPERIMENT_NOT_FOUND:
          'This behavior experiment no longer exists. Please go back to the list and try again.',
        BEHAVIOR_EXPERIMENT_ALREADY_EXISTS:
          'This behavior experiment was already started. Please reload and continue with it.',
        USER_NOT_AUTHORIZED:
          'You do not have access to this behavior experiment. If you think this is a mistake, contact support@copingcard.com and mention code BEHAVIOR-EXPERIMENT-AUTH-1.',
        SETUP_INCOMPLETE:
          'Please choose the experiment purpose, design, number of hypotheses and type first.',
        SETUP_IMMUTABLE:
          'The purpose, design, number of hypotheses and type are fixed once an experiment is started. Start a new experiment to change them.',
        DESIGN_INCOMPLETE:
          'Please complete the hypotheses, plan and prediction steps before activating the experiment.',
        NOT_ACTIVATED:
          'Activate the experiment design first — then you can record observations and complete it.',
        EXPERIMENT_COMPLETED:
          'This experiment is completed. You can still edit its observations, but not add new ones.',
        OBSERVATION_NOT_FOUND:
          'This observation no longer exists on the experiment. Please go back and try again.',
        LEGACY_OBSERVATION_READ_ONLY:
          'This observation was recorded in the previous version and cannot be edited here. Add a new observation instead.',
        CONTENT_REQUIRED:
          'Please describe the experiment first so the AI has something to work from.',
        SUGGESTIONS_REQUEST_NOT_PENDING:
          'These suggestions were already generated. Please request a new variant.',
      },
    },
    behaviorExperiments: {
      title: 'Behavior Experiments',
      initialThoughtOrBelief: 'Initial Thought or Belief',
      edit: 'Edit Behavior Experiment',
      create: 'Create Behavior Experiment',
      // E02 (ES-era) mobile list — status badges, default-hidden completed, Drafts / Resume
      showCompleted: 'Show completed ({{count}})',
      hideCompleted: 'Hide completed',
      drafts: 'Drafts / Resume',
      empty: 'No experiments yet. Design one to start.',
      unfinishedTitle: 'Unfinished / Drafts',
      unfinishedSubtitle: 'Resume a design in progress',
      unfinishedEmpty: 'No unfinished designs.',
      resume: 'Resume',
      resumeAt: 'Resume at: {{step}}',
      observationsShort: '{{count}} obs',
      noObservations: '—',
    },
    components: {
    },
    exposure: {
      title: 'Exposure',
      /** The SITUATION or stimulus — the tool's list, the portal menu. */
      titlePlural: 'Exposures',
      /**
       * ONE RUN of an exposure, and the list of them under a situation (founder 2026-09-07: *"We
       * have buttons like Start Exposure, End Exposure, Resume Exposure. What I think would make
       * more sense would be renaming them to something like Start Exposure Session"*). "Session" is
       * the term the CBT/ERP literature uses for a single practice occasion; "experiment" belongs to
       * behavioural experiments, which is a different tool in this app.
       */
      sessionsPlural: 'Exposure Sessions',
      chooseExpositionType: 'Choose Exposure Type',
      type: 'Exposure Type',
      types: [
        {
          name: 'Graduated Exposure',
          description:
            'Graduated Exposure is a CBT method for fears and anxiety: you approach what you have been avoiding in planned steps, starting with one that is hard but doable. Before each step, write what you expect to happen and how likely it seems; afterward, write what actually happened and what you learned. The aim is not to stay calm or to wait for the fear to fade, but to test your prediction, so drop safety behaviors and vary where and when you practice. The old fear is not erased; new learning grows beside it with repetition. Strong fears, panic or trauma are best worked on with a therapist.',
        },
        {
          name: 'Exposure and Response Prevention',
          description:
            'Exposure and Response Prevention (ERP) is the main CBT method for obsessive-compulsive disorder (OCD), and it is also used for related problems kept going by checking, reassurance-seeking or rituals. You approach the thoughts, images or situations that trigger the obsession and, at the same time, hold back the compulsion or safety behavior that usually follows. This lets you learn that the anxiety and the urge can be tolerated and pass without the ritual, and that the feared outcome is less likely than the obsession says. Steps are planned, repeated, and recorded with what you expected and what you learned. It is best started with a therapist.',
        },
      ],
      avoidances: [
        'Never Avoid',
        'Occasionally Avoid',
        'Avoid Half of the Times',
        'Frequently Avoid',
        'Always Avoid',
      ],
      typeRequired: 'Exposure Type is a required field',
      fear: 'Fear or worry',
      fearPlaceholder: 'What is the fear or worry you have?',
      obsession: 'Obsession',
      obsessionPlaceholder:
        'OBSESSION: What is the thought or image that bothers you?',
      compulsion: 'Compulsion',
      compulsionPlaceholder:
        'COMPULSION: What do you typically do to reduce the anxiety?',
      compulsionTip:
        'What are the safety behaviors you typically engage in and want to reduce/stop?',
      situationsOrStimuliHierarchy: 'Situations or Stimuli Hierarchy',
      generateHierarchy: 'Generate Hierarchy using AI',
      situationOrStimulus: 'Situation or Stimulus',
      situationOrStimulusTitle: 'Situation or Stimulus Title',
      situationOrStimulusTitlePlaceholder: 'What is the situation or stimulus?',
      situationOrStimulusDescription: 'Description',
      situationOrStimulusDescriptionPlaceholder:
        'Describe the situation or stimulus',
      imagePrompt: 'AI Image Prompt',
      imagePromptTip:
        'Image Prompt you can use to generate images for the situation or stimulus using AI',
      imagePromptPlaceholder: 'Enter AI Image Prompt',
      imageDeleteWarning: 'Are you sure you want to delete this image?',
      addSituationOrStimuli: 'Add Situation or Stimulus',
      sud: 'Level of stress and anxiety (SUD)',
      sudTip: 'How distressing is the situation or stimulus? (0-100)',
      // D-expectancies-2026-10-07 — the optional inhibitory-learning questions (ES runner only)
      expectedOutcome: 'What do you fear will happen?',
      expectedOutcomePlaceholder:
        'Describe what you expect to go wrong. You can skip this.',
      expectedLikelihood: 'How likely is it?',
      outcomeOccurred: 'Did it happen?',
      outcomeYes: 'Yes',
      outcomePartly: 'Partly',
      outcomeNo: 'No',
      likelihoodAfter: 'How likely does it feel now?',
      learned: 'What did you learn?',
      learnedPlaceholder:
        'Write what you noticed or learned from this exposure. You can skip this.',
      likelihoodNotSet: 'Not set — move the slider to answer',
      likelihoodClear: 'Clear answer',
      expectedColumn: 'Expected (likelihood before → after)',
      happenedColumn: 'Happened',
      learnedColumn: 'What was learned',
      noAnswersRecorded: 'No answers recorded',
      // E43 — health data: the heart rate during an exposition (E20 phone · E21 portal; numbers only)
      heartRate: {
        column: 'Heart rate',
        values: 'Heart rate {{min}}–{{max}} bpm, average {{mean}} · {{readings}}',
        readings_one: '{{count}} reading',
        readings_other: '{{count}} readings',
        none: 'No heart rate was recorded during this exposure.',
        notShared: 'not shared',
      },
      saveSuccess: 'Exposure saved successfully',
      saveError:
        'We could not save this exposure. Please try again. If it keeps happening, contact support@copingcard.com and mention code EXPOSURE-SAVE-1.',
      loadError:
        'We could not load this exposure right now. Please go back and try again. If it keeps happening, contact support@copingcard.com and mention code EXPOSURE-LOAD-1.',
      deleteError:
        'We could not delete this situation or stimulus. Please try again. If it keeps happening, contact support@copingcard.com and mention code EXPOSURE-DELETE-1.',
      situationOrStimulusSaveSuccess:
        'Situation or Stimulus saved successfully',
      noSituationsYet: 'No situations or stimuli yet',
      saveBeforeSituation:
        'Save this exposure first, then add a situation or stimulus.',
      generatingInProgress: 'Generating — this takes a moment.',
      hierarchyAlreadyBuilt:
        'This exposure already has a hierarchy. Remove the steps first to generate a new one.',
      rank: 'Rank',
      editTitleAndDescription: 'Edit Title and Description',
      avoiding: 'Avoiding',
      doYouAvoid: 'Do you avoid this situation or stimulus?',
      worstThingThatCouldHappen:
        'Worst thing that could happen in this situation?',
      situationOrStimuliImages: 'Situation or Stimuli Images',
      generateImageUsingAI: 'Generate Image using AI',
      generateImageUsingAIMobile: 'Generate Image with AI',
      generatingImage: 'Generating image...',
      deleteAvailable120Minutes:
        'Delete is available for therapists only upto 2 hours after creation to prevent deletion of client-generated content',
      startExposure: 'Start a New Exposure Session',
      newExposure: 'New Exposure Session',
      anticipated: 'Anticipated',
      reactionNotes: 'Notes',
      addReaction: 'Add Reaction',
      exposureGraph: 'Exposure Sessions Graph',
      expositionDuration: 'Exposition Duration',
      highestSud: 'Highest SUD',
      endSud: 'End SUD',
      duration: 'Duration',
      recordSudPoint: 'Record Current SUD',
      imageGenerationError: 'Error generating image',
      contentFilter:
        'We could not generate this image. It was blocked by content-safety filters. Please try again with a more neutral description.',
      safetyBehaviorsToAvoid: 'Safety Behaviors (Compulsion) to Avoid',
      edit: 'Edit Exposure',
      create: 'Create Exposure',
      upsertExposureLoading: 'Saving Exposure...',
      stimuludDeleteWarning:
        'Warning! This will delete the situation or stimulus and all related information. Are you sure you want to delete this exposure?',
      editDetails: 'Edit Details',
      editReactionTime: 'Edit reaction time',
      // R52 — the run drawer's elapsed-time affordance and its duration editor (founder 2026-09-07).
      // "Elapsed" is a DURATION, never a time of day: it says how long the person had been in the
      // exposure when they logged that reading.
      elapsed: 'Elapsed',
      editElapsedTime: 'Edit elapsed time',
      elapsedSinceStart: 'Time since this exposure started',
      minutes: 'Minutes',
      seconds: 'Seconds',
      noExposuresYet: 'No exposures recorded yet',
      // the run list's order, the founder's default first (2026-09-08)
      newestFirst: 'Newest first',
      oldestFirst: 'Oldest first',
      // E20 WP4 — the E-era exposition runner. Every string here exists because the E-era records
      // a run as it happens (start / each reaction / finish are separate facts) instead of saving
      // it whole at the end. The copy says what IS possible, never only what is not.
      //
      // THE AMEND SLICE REWROTE TWO OF THESE (founder ruling `amend-a-recorded-reaction`,
      // 2026-09-04). They said a recorded reaction "cannot be changed afterwards" and "can no
      // longer be changed", which was true of WP4 and is now false: a reading can be CORRECTED,
      // and the correction is recorded as its own fact beside the original rather than replacing
      // it. Copy that describes a limit the product no longer has is worse than no copy at all.
      es: {
        runLiveNotice:
          'This exposure is being recorded as it happens — each reaction is saved the moment you add it. Pick the level first, then tap Add Reaction; if a reading came out wrong you can correct it, and both the original and the correction are kept.',
        runRecordedNotice:
          'This exposure is recorded. Tap Resume Exposure Session to add more reactions and finish it again with new notes, or correct a reading that came out wrong — the original stays on the record.',
        finishRun: 'Finish Exposure Session',
        resumeRun: 'Resume Exposure Session',
        viewRun: 'View Exposure Session',
        runRecorded: 'Exposure session recorded',
        saveRungBeforeRun:
          'Save this situation or stimulus first — an exposure is recorded against it as you go.',
        // the CORRECTION of one recorded reading (founder ruling 2026-09-04). "Corrected", never
        // "edited": the original reading stays a fact and the correction supersedes it for display.
        amendPoint: 'Correct this reading',
        amendTitle: 'Correct a recorded reading',
        amendSaved: 'Reading corrected',
        amendedTag: 'corrected',
        amendedOriginal: 'Originally {{sud}} at {{time}}',
      },
    },
    downwardArrows: {
      downwardArrows: 'Downward Arrows',
      initialThought: 'Initial Thought',
      totalCount: 'Total: {{count}}',
      edit: 'Edit Downward Arrow',
      create: 'Create Downward Arrow',
      loadError:
        'We could not load your downward arrows. Pull to refresh or reopen the app and try again.',
    },
    downwardArrow: {
      spec: {
        thoughts: [
          `At a pitch event, I felt like everyone was judging me and I didn't belong there.`,
          `Others think I'm stupid or boring.`,
          `I'm not interesting or likable.`,
          `I'm a failure and nobody will ever like me.`,
        ],
      },
      title: 'Downward Arrow',
      saveSuccess: 'Downward Arrow saved successfully',
      loadError:
        'We could not load this downward arrow. Go back and try again.',
      saveError:
        'We could not save your downward arrow. Please try again. If it keeps happening, contact support@copingcard.com.',
      thought: 'Thought, Underlying Assumption or Belief',
      question: 'If that were true it would bother me because it would mean...',
      description: `The Downward Arrow technique is used to get from superficial levels of thoughts (negative automatic thoughts) to deeper levels (underlying assumptions or core beliefs) that underlie a person's distress or problematic behavior.

It involves asking a series of questions that aim to identify the underlying assumptions, beliefs, or fears that are driving a person's negative thoughts. The technique gets its name from the visual metaphor of "digging deeper" into a person's beliefs, starting with a surface-level thought and using a series of questions to get to the root cause of the negative thought.

Socratic dialogue is a key component of the Downward Arrow technique. It involves the therapist asking questions in a non-judgmental, curious, and exploratory manner, encouraging the patient to examine their thoughts and beliefs more closely. 

The therapist asks the patient (or the patient asks himself) to identify their negative automatic thought, such as "I'm a failure." The therapist then asks a series of questions to dig deeper, such as "What does it mean to you to be a failure?" and "Why is that important to you?" By continuing to ask these types of questions, the therapist can help the patient uncover the underlying beliefs and assumptions that are fueling their negative thoughts.
      `,
    },
    worryTrees: {
      worryAbout: 'Worry',
      isReal: 'Is real',
      notSolvable: 'Not solvable',
      options: 'Options to solve',
      immediateAction: 'Immediate action',
      plan: 'Plan for later',
      refocusActivity: 'Refocus activity',
      definition:
        'The Worry Decision Trees tool in Cognitive Behavior Therapy is a systematic approach for conceptualizing and treating Generalized Anxiety Disorder (GAD) by breaking down complex, anxiety-provoking situations into smaller, more manageable parts. This tool helps clients with GAD to avoid "analysis paralysis" and take action by distinguishing the type of worry they are facing and identifying appropriate responses. By using this tool, clients are encouraged to view their problems as challenges that can be overcome through problem-solving skills rather than getting stuck in worry and anxiety. The Worry Decision Trees tool aims to communicate to clients that there is a better alternative to worrying and that they can improve their problem-solving skills to manage their anxiety effectively.',
      deleteSuccess: 'Worry Decision Trees cycle deleted successfully',
      view: 'View the Worry Tree',
      create: 'Create Worry Decision Tree',
    },
    worryTree: {
      spec: {
        worryAbout: 'I might fail with my newly assigned project at work',
        options: `1. I can ask for clarification on any aspects of the project I'm not sure about.
2. I can create a detailed project plan with milestones to ensure progress.
3. I can seek support from colleagues or a mentor.
4. I can review similar past projects to understand potential pitfalls.
5. I can allocate extra time to research and prepare for the project.`,
        immediateAction: `I will start by writing down all the tasks
that need to be done and prioritize them.
Then I will schedule a meeting with my supervisor
to go over the project scope and expectations.`,
      },
      worryTree: 'Worry Tree',
      worryTrees: 'Worry Trees',
      worryTreesTitle: 'Worry Decision Trees',
      title: 'Worry Decision Tree',
      worryAbout: 'What am I worrying about?',
      isReal: 'Is this a real problem?',
      decision: 'Decision',
      selectedActivity: 'Selected Activity',
      listOptions: 'List your options to solve the problem.',
      developPlan: 'Plan what you could do and when you will do it.',
      isDoable: 'Can I do anything to solve this problem?',
      isDoableNow: 'Can I do anything right now?',
      refocusTitle: 'Let the worry go. Change the focus of your attention.',
      doneTitle: 'Let the worry go. Do the action now.',
      immediateAction: 'Name the thing that you are going to do right now.',
      savedForReference: 'Your Worry Tree has been saved for future reference.',
      saveSuccess: 'Worry Tree saved successfully',
      saveError:
        'Could not save this Worry Tree. Please try again. If the problem persists, contact support@copingcard.com.',
      loadError:
        'Could not load this Worry Tree. Please go back and try again.',
      refocusIdeas: [
        {
          title: 'Practice deep breathing',
          info: 'Take slow, deep breaths in and out to help slow down your heart rate and calm your mind.',
        },
        {
          title: 'Engage in physical activity',
          info: 'Exercise or go for a walk to help release endorphins and reduce stress.',
        },
        {
          title: 'Practice mindfulness',
          info: 'Focus on the present moment by paying attention to your thoughts, feelings, and sensations without judgment.',
          mobileExtraInfo:
            'You can go the Meditations section by following the link below.',
          link: 'screens.meditations',
        },
        {
          title: 'Do a creative activity',
          info: 'Engage in an activity that requires your full attention, such as drawing, painting, or playing an instrument.',
        },
        {
          title: 'Listen to music',
          info: 'Listen to calming music or your favorite songs to help change focus.',
        },
        {
          title: 'Practice visualization',
          info: 'Visualize a peaceful scene or situation that helps you feel calm and relaxed.',
        },
        {
          title: 'Write in a journal',
          info: 'Write down your thoughts and feelings to help organize them and gain clarity.',
        },
        {
          title: 'Do a puzzle',
          info: 'Engage in a challenging puzzle or game to help refocus your attention.',
        },
        {
          title: 'Practice gratitude',
          info: 'Focus on the things in your life that you are thankful for and express gratitude for them.',
        },
        {
          title: 'Seek professional help',
          info: 'If your anxiety is persistent and interfering with your daily life, consider seeking help from a mental health professional.',
          mobileExtraInfo:
            'You can go the Therapists Search section by following the link below.',
          link: 'screens.therapists',
          root: 'screens.tests',
        },
        {
          title: 'Practice Progressive Muscle Relaxation',
          info: '',
          mobileExtraInfo:
            'You can find a video and instructions on how to do it by following the link below.',
          link: 'screens.muscleRelaxation',
          root: 'screens.crisis',
        },
      ],
    },
  },
  // E13 + E54 — six meditations x two voices (female, male), Dmitri's order; the old four files stay in Storage for old app versions
  audios: [
    {
      url: 'meditation-1-en-female.m4a',
      title: 'Breathing body',
      duration: 386,
      voice: 'female',
    },
    {
      url: 'meditation-1-en-male.m4a',
      title: 'Breathing body',
      duration: 388,
      voice: 'male',
    },
    {
      url: 'meditation-4-en-female.m4a',
      title: 'A safe place',
      duration: 358,
      voice: 'female',
    },
    {
      url: 'meditation-4-en-male.m4a',
      title: 'A safe place',
      duration: 357,
      voice: 'male',
    },
    {
      url: 'meditation-2-en-female.m4a',
      title: 'Hourglass',
      duration: 487,
      voice: 'female',
    },
    {
      url: 'meditation-2-en-male.m4a',
      title: 'Hourglass',
      duration: 486,
      voice: 'male',
    },
    {
      url: 'meditation-3-en-female.m4a',
      title: 'Sounds and thoughts',
      duration: 413,
      voice: 'female',
    },
    {
      url: 'meditation-3-en-male.m4a',
      title: 'Sounds and thoughts',
      duration: 416,
      voice: 'male',
    },
    {
      url: 'meditation-5-en-female.m4a',
      title: 'Triangulation',
      duration: 449,
      voice: 'female',
    },
    {
      url: 'meditation-5-en-male.m4a',
      title: 'Triangulation',
      duration: 450,
      voice: 'male',
    },
    {
      url: 'meditation-6-en-female.m4a',
      title: 'The observing self',
      duration: 590,
      voice: 'female',
    },
    {
      url: 'meditation-6-en-male.m4a',
      title: 'The observing self',
      duration: 588,
      voice: 'male',
    },
  ] as { url: string; title: string; duration: number; voice?: string }[], // voice is optional: the RU twin's rows have none
  // E56 · Learn 2 (1.6.0) — the Learn tab's strings. The video CATALOGUE is no longer here: it is the films table in
  // `@cc/schema` (`learn/learnLibrary.ts` — LEARN_FILMS, one line per YouTube id), the Basics titles are generated
  // from the articles. Tool names below are the labels on screen (BUILD.md §5), keyed by the ROUTE an article names.
  learn: {
    articles: {
      minRead: '{{minutes}} min read',
      researchTitle: 'Research library',
      researchHint: 'Studies on CBT, on our website.',
    },
    article: {
      watchVideo: 'Watch the video',
      openTool: 'Open {{tool}}',
      readFull: 'Read the full article',
      safetyLine:
        "If this brings up something difficult, you don't have to deal with it alone. Talk to your therapist, or open the Crisis tab.",
      openCrisis: 'Open Crisis',
    },
    videos: {
      readArticle: 'Read the article',
    },
    retired: {
      movedBody: 'This article now lives on our website, with the other research.',
      movedButton: 'Read it on the website',
      goneBody: 'This article is no longer available.',
      back: 'Back to Articles',
    },
    tools: {
      AbcModels: 'ABC Models',
      CopingCards: 'Coping Cards',
      ThoughtsTesting: 'Dysfunctional Thoughts Test',
      DownwardArrows: 'Downward Arrows',
      WorryTrees: 'Worry Trees',
      BehaviorExperiments: 'Behavior Experiments',
      Exposures: 'Exposures',
      ViciousCycles: 'Vicious Cycles',
      Meditations: 'Meditations',
      ActivateHome: 'Behavioral Activation',
      ValuesProfile: 'Values',
      MyCheckIns: 'My check-ins',
      SafetyPlan: 'My safety plan',
      Tests: 'Assessments',
      FaHome: 'Functional analysis',
      MiChanges: 'Motivational interviewing',
      ModesHome: 'Schema modes',
      SleepMorning: 'Sleep diary',
    },
  },
  learnVideoDiagnostics: {
    playerLoadFailure: 'Android Learn video player load failure',
  },
  cognitiveDistorions: {
    10: 'All-or-Nothing thinking (black and white thinking, polarized thinking)',
    20: 'Catastrophizing',
    30: 'Over-generalization',
    40: 'Discounting the positive (devaluation) / exaggerating the negative',
    50: 'Should Statements (unrealistic, super high standards, "I have to" mindset)',
    60: 'Labeling and Mislabeling',
    70: 'Personalization (taking things personally, attribution)',
    80: 'Subjective reasoning (emotional reasoning)',
    90: 'Jumping to conclusions (illogical thinking)',
    100: 'Mental Filters (selective abstraction)',
    110: 'Tunnel Vision (e.g. seeing only the negative)',
    120: 'Mind reading, fortune-telling',
  },
  // E28 — Safe Deferred Sign-out. The quiet, non-blocking banner that replaces the silent
  // 24 h capability flip: the session stays fully usable and ends at a moment that suits the
  // person (board HTML_SCREEN "Session ending soon banner", founder D-quiet-banner 2026-09-03).
  sessionEnding: {
    title: 'You’ll be signed out soon',
    // Founder 2026-09-07: never phrase the default as the person's choice ("you chose not to…"
    // reads as their fault); name the default, and name the setting that changes it.
    body: 'Staying signed in is off by default, so this session ends once you’ve finished what you’re doing. Your work is saved. To stay signed in, turn on “Keep me Signed-In” in Privacy Settings.',
    delay: 'Not now',
    openPrivacySettings: 'Open Privacy Settings',
    dismiss: 'Dismiss',
  },
  // E27 — what this build actually is, on the Settings screen. The founder reads the OTA revision
  // here during a manual test, and support can ask for one line instead of three questions.
  appBuildInfo: {
    title: 'App version',
    version: 'Version {{version}}',
    build: 'Build {{build}}',
    otaRevision: 'Update {{revision}}',
    otaEmbedded: 'Update: the one that shipped with this build',
  },
  // E32 · What's New — the Toolkit card (one variant per announcement, in the person's language),
  // the Settings history (a reading list, one row per announcement), and the article link. The
  // ANNOUNCEMENT copy itself (title, summary) is what marketing publishes and is never in here.
  whatsNew: {
    title: 'What’s new',
    readArticle: 'Read more',
    dismiss: 'Dismiss',
    releases: 'Version {{versions}}',
    historyTitle: 'What’s new',
    openHistory: 'What’s new in CopingCard',
    openArticle: 'Read the article',
    empty: 'Nothing here yet — new features and articles will appear as they ship.',
  },
  devSessionClock: {
    title: 'Session clock (dev build only)',
    age: 'Age the session by 25 h',
    away: 'Away for 31 min, then back',
    shortAway: 'Away for 2 min, then back (a phone call)',
    idle: 'Idle for 16 min, then check',
  },
  oldVersionModal: {
    appOutdatedTitle: 'App is Outdated',
    yourVersionIsOutdated:
      'The App version is outdated and needs to be upgraded.',
    installWarning:
      '⚠️ If the button below does not redirect you to the App/Play Store automatically, please update the App manually.',
    getUpdate: 'Get Update',
  },
  // E37 · Check-in & Diary Card — block A, the check-in. The phone's card and history (checkIn.*, .history.*,
  // .delete.*, .reminder.*), the deciders' refusal codes (checkIn.errors.*, packages/domain/src/checkIn/errors.ts —
  // one key per code, both languages; the domain test error-codes-i18n fails when one is missing), and the
  // portal's hub tab and session recap (checkIn.hub.*, checkIn.session.*).
  checkIn: {
    errors: {
      CHECKIN_RATING_RANGE:
        'Each rating must be between 1 and 5. Choose a face from the row and try again.',
      CHECKIN_DATE_RANGE:
        'A check-in can be for today or for any of the last 7 days. Choose one of those days.',
      CHECKIN_EMOTION_UNKNOWN:
        'One of the feelings you chose is not in the list. Choose your feelings again from the list.',
      CHECKIN_UNKNOWN:
        'This check-in could not be found — it may already have been deleted. Refresh the list.',
      CHECKIN_NOT_YOURS:
        'You can only delete your own check-ins. An entry your therapist made in session can be removed only by their practice.',
      HOMEWORK_NOT_YOUR_CLIENT:
        'This client is not connected with you at your practice — they are not your client here, or they have switched off sharing with you. Check the client list, or ask the client to turn sharing with you back on in the app.',
      DIARYCARD_EMPTY:
        'A diary card needs at least one row, feeling or skill. Add one and save again.',
      DIARYCARD_DUPLICATE_TARGET:
        'Two rows have the same id. Remove one of them and save again.',
      DIARYCARD_PRACTICE_CARD_EXISTS:
        'Your practice already has a diary card for this client. Open that card and edit it instead of setting up a second one.',
      DIARYCARD_OWN_CARD_EXISTS:
        'You already have a card of your own. Open it with “Edit my card” instead of setting up a second one.',
      DIARYCARD_UNKNOWN_CARD:
        'This card could not be found for this client. Refresh the page and open the card again.',
      DIARYCARD_TEMPLATE_EMPTY:
        'A template needs at least one row, feeling or skill. Add one and publish again.',
      DIARYCARD_NO_ACTIVE_CARD:
        'You have no diary card yet. Set one up first, then fill it in.',
      DIARYCARD_RATING_RANGE:
        'One of the ratings is outside its scale. Check the values on the form and save again.',
      DIARYCARD_UNKNOWN_TARGET:
        'One of the rows is not on any of your cards any more. Reopen the diary card to see the current rows.',
      DIARYCARD_DATE_RANGE:
        'A diary card can be filled in for today or for any of the last 7 days. Choose one of those days.',
      DIARYCARD_NO_PRACTICE_CARD:
        'Your practice has not set up a diary card for this client yet. Set one up first, then fill it in.',
    },
    title: 'How are you today?',
    hint: 'Tap the face that fits. One tap is a check-in.',
    mood: {
      '1': 'Very low',
      '2': 'Low',
      '3': 'Okay',
      '4': 'Good',
      '5': 'Very good',
    },
    // E37 · block W — the home-screen widget (iOS + Android). It shows no data: these lines and the five faces only.
    // The native copies (iOS Localizable.strings, Android strings.xml) are generated from these keys.
    widget: {
      name: 'Check-in',
      description: 'Check in with one tap. Nothing else is shown on your home screen.',
      title: 'How are you?',
      tapFace: 'Tap a face',
      saved: 'Saved · tap a face to add more',
      signedOut: 'Sign in to check in',
      intentTitle: 'Record my mood',
      intentMood: 'Mood',
    },
    scale: {
      '1': 'Very low',
      '2': 'Low',
      '3': 'Medium',
      '4': 'High',
      '5': 'Very high',
    },
    save: 'Save check-in',
    saving: 'Saving…',
    saved: 'Saved. Thank you for checking in.',
    savedOffline:
      'Saved on this phone. It will be sent as soon as you are online.',
    checkedInAt: 'Checked in at {{time}}',
    addAnother: 'Add another',
    more: 'Add more detail (optional)',
    less: 'Hide the details',
    energy: 'Energy',
    sleepQuality: 'How well you slept',
    sleepHours: 'Hours slept',
    sleepHoursPlaceholder: 'For example, 7.5',
    socialConnection: 'Feeling connected to other people',
    emotions: 'Feelings',
    emotionsHint: 'Choose the feelings that fit, and how strong each one was.',
    emotionsToggle: 'Choose feelings',
    strength: {
      mild: 'Mild',
      moderate: 'Moderate',
      strong: 'Strong',
    },
    drivers: 'What shaped today?',
    driver: {
      work: 'Work',
      family: 'Family',
      relationships: 'Relationships',
      health: 'Health',
      sleep: 'Sleep',
      money: 'Money',
      study: 'Study',
      weather: 'Weather',
      other: 'Other',
    },
    note: 'A note',
    notePlaceholder: 'Anything you want to remember about today',
    day: {
      today: 'Today',
      yesterday: 'Yesterday',
      pick: 'Which day is this for?',
    },
    myCheckIns: 'My check-ins',
    history: {
      title: 'My check-ins',
      range7: '7 days',
      range30: '30 days',
      streak_one: '{{count}} day in a row',
      streak_other: '{{count}} days in a row',
      noStreak: 'Check in today to start a streak',
      empty: 'No check-ins yet. Your first one takes a few seconds.',
      emptyAction: 'Check in now',
      enteredInSession: 'Entered in session',
      enteredInSessionHint:
        'Your therapist entered this one in your session. Only their practice can remove it.',
      noteLabel: 'Note',
      moodLine: 'Mood: {{mood}}',
      chartTitle: 'Mood over time',
      pointLabel: '{{day}}: mood {{mood}}',
      loadError: 'Could not load your check-ins. Pull down to try again.',
    },
    delete: {
      action: 'Delete',
      title: 'Delete this check-in?',
      body: 'It will disappear from your history and from your therapist’s view.',
      confirm: 'Delete',
      cancel: 'Keep it',
      failed: 'Could not delete this check-in. Try again in a moment.',
    },
    reminder: {
      title: 'Daily reminder',
      body: 'A quiet nudge to check in.',
      set: 'Set a reminder',
      change: 'Change the reminder',
      none: 'No reminder yet',
      diaryTitle: 'Diary card reminder',
      diaryBody: 'A quiet nudge to fill in your diary card.',
      notificationTitle: 'How are you today?',
      notificationBody: 'A check-in takes a minute.',
      diaryNotificationTitle: 'One minute: how was today?',
      diaryNotificationBody: 'Fill in your diary card.',
    },
    hub: {
      tab: 'Check-ins',
      title: 'Check-ins',
      range14: '14 days',
      range30: '30 days',
      range90: '90 days',
      daysChecked_one: 'Checked in {{count}} day of the last {{days}}',
      daysChecked_other: 'Checked in {{count}} days of the last {{days}}',
      empty: 'No check-ins in this window yet.',
      mood: 'Mood',
      energy: 'Energy',
      sleepQuality: 'Sleep quality',
      sleepHours: 'Sleep (hours)',
      socialConnection: 'Connection',
      feelings: 'Feelings',
      drivers: 'Drivers',
      note: 'Note',
      enteredInSession: 'Entered in session',
      loadError: 'Could not load the check-ins. Refresh to try again.',
      askForDaily:
        'To ask for a daily check-in, assign it as homework (Assign homework → Daily check-in).',
    },
    session: {
      record: 'Record a check-in (in session)',
      recordTitle: 'Record a check-in for {{name}}',
      recordHint:
        'Entered in session: it is part of your practice’s record, visible to your practice and to the client, and it does not count as the client checking in.',
      day: 'Day',
      save: 'Record check-in',
      saved: 'Check-in recorded.',
      remove: 'Remove',
      removeTitle: 'Remove this check-in?',
      removeBody:
        'It will disappear from the client’s history and from your practice’s view.',
      removeConfirm: 'Remove',
      removeCancel: 'Keep it',
      removeFailed: 'Could not remove this check-in. Try again in a moment.',
      recapTab: 'Check-in recap',
      recapTitle: 'Check-ins since the last session',
      recapSince: 'Since {{date}}',
      recapFirstSession:
        'This is the client’s first session with you, so this covers the last 14 days.',
      recapEmpty: 'No check-ins in this period.',
      recapCount_one: '{{count}} check-in',
      recapCount_other: '{{count}} check-ins',
      recapInSession: '{{count}} entered in session',
      recapMoodAverage: 'Mood average: {{value}}',
      recapLowest: 'Lowest day: {{day}} · mood {{mood}}',
      recapSleep: 'Average sleep: {{hours}} h',
      recapDrivers: 'Most common drivers',
      recapOpenEntry: 'See the entry',
      loadError: 'Could not load the check-in recap. Refresh to try again.',
    },
  },
  // E37 · Check-in & Diary Card — block B, the diary card. The phone's one form, its set-up and its week (diaryCard.*),
  // the catalogue's names (diaryCard.row.*, .emotion.*, .skill.*, .module.*, .template.*) and the portal's hub and
  // backoffice (diaryCard.hub.*, .session.*, .backoffice.*). The deciders' refusal codes are checkIn.errors.DIARYCARD_*.
  // The skill names and the dbtSkills rows are PROVISIONAL until Dmitri reviews them (Q-emo-7).
  diaryCard: {
    title: 'Diary card',
    loading: 'Loading your diary card…',
    loadError: 'Could not load your diary card. Pull down to try again.',
    setUp: 'Set up my diary card',
    editMine: 'Edit my card',
    myWeek: 'My week',
    empty: {
      title: 'No diary card yet',
      body: 'A diary card is a one-minute daily record of urges, actions, feelings and skills. Your therapist can set one up for you, or you can set up your own.',
    },
    toolkit: {
      body: 'One minute: how did today go?',
      done: 'Filled in for today.',
      open: 'Open my diary card',
      fill: 'Fill in today',
      setUpBody:
        'Track urges, actions, feelings and skills day by day. Start from a template or build your own.',
    },
    fill: {
      pickDay: 'Which day is this for?',
      today: 'Today',
      yesterday: 'Yesterday',
      replaceHint:
        'You already filled in this day. Saving again replaces it.',
      oneFormHint_one: 'One form for your card.',
      oneFormHint_other:
        'One form for your {{count}} cards. A row that is on several cards is asked once.',
      sharedRows: 'On all your cards',
      fromPractice: 'Card from {{name}}',
      fromYourTherapist: 'Card from your therapist',
      ownCard: 'My own card',
      emotions: 'Feelings today',
      emotionsHint: 'Rate the highest each one reached today, 0 to 5.',
      skills: 'Skills',
      skillsUsed: 'Skills used today (0–7)',
      skillsUsedHint:
        '0 = not thought about or used, 7 = used them, and they helped.',
      skillsPracticed: 'Which skills did you practice?',
      note: 'A note',
      notePlaceholder: 'Anything you want to remember about today',
      // under the note: who reads it (the one note is copied to every card on the form)
      sharedWith: 'Shared with {{names}}',
      sharedWithOwn: 'Shared with {{names}}, and kept in your own card',
      sharedUnnamed: 'a therapist',
      sharedJoin: '{{a}} and {{b}}',
      yes: 'Yes',
      no: 'No',
      save: 'Save',
      saving: 'Saving…',
      saved_one: 'Saved on your card.',
      saved_other: 'Saved on your {{count}} cards.',
      failed:
        'Could not save your diary card. Check your connection and try again.',
    },
    own: {
      title: 'Set up my diary card',
      editTitle: 'Edit my card',
      intro:
        'Start from a template, then change it to fit you. A therapist you share your data with can see your own card, but cannot change it.',
      blank: 'Start with a blank card',
      rowsHint:
        'Rows are what you track each day. You can change them any time; earlier days keep the rows they were filled with.',
      rows: 'Rows',
      rowName: 'Row name',
      rowNamePlaceholder: 'What do you want to track?',
      kind: {
        urge: 'Urge',
        scale: 'Scale',
        action: 'Yes / no',
        count: 'Count',
        text: 'Short text',
      },
      scaleTo: '0 to {{max}}',
      removeRow: 'Remove this row',
      addRow: 'Add a row',
      skillsHint: 'Choose the skills you are learning; you can change them later.',
      needRows: 'Add at least one row, feeling or skill to save your card.',
      needNames: 'Give every row a name to save your card.',
      save: 'Save my card',
      failed: 'Could not save your card. Try again in a moment.',
    },
    week: {
      previous: 'Earlier',
      next: 'Later',
      range: '{{from}} to {{to}}',
      empty: 'You have no diary card yet. Set one up and your week will appear here.',
      day: 'Day',
      skillsUsed: 'Skills used',
      inSession: 'Filled in session',
    },
    // the portal's client hub (diaryCard.hub.*) and the in-session fill / session recap (diaryCard.session.*)
    hub: {
      tab: 'Diary card',
      title: 'Diary card',
      previousWeek: 'Earlier week',
      nextWeek: 'Later week',
      setUpCard: 'Set up the card',
      editCard: 'Edit the card',
      setUpTitle: 'Set up a diary card for {{name}}',
      editTitle: 'Edit {{name}}’s diary card',
      setUpHint:
        'This is your practice’s card for the client: kept as part of your practice’s record. Saving again makes a new version of the same card; another practice’s card for this client is untouched. The client sees one form for all their cards.',
      startFrom: 'Start from a template (optional)',
      rowNamePlaceholder: 'Row name',
      kind: {
        urge: 'Urge',
        scale: 'Scale',
        action: 'Yes / no',
        count: 'Count',
        text: 'Short text',
      },
      scaleTo: '0 to {{max}}',
      countable: 'Count how many',
      removeRow: 'Remove',
      addRow: 'Add a row',
      emotions: 'Feelings (rated 0–5)',
      skills: 'Skills',
      needRows: 'Add at least one row, feeling or skill to save the card.',
      needNames: 'Give every row a name to save the card.',
      saveCard: 'Save card',
      cardSaved: 'Card saved. The client sees it in their form from the next fill.',
      saveFailed: 'Could not save the card. Check the rows and try again.',
      cancel: 'Cancel',
      day: 'Day',
      practiceCardTitle: 'Your practice’s card',
      clientCardTitle: 'Set up by the client',
      readOnly: 'Set up by the client · read-only',
      filledInSession: 'Filled in session',
      skillsUsed: 'Skills used',
      yes: 'Yes',
      no: 'No',
      empty:
        'No diary card for this client yet. Set one up and their week will appear here.',
      loadError: 'Could not load the diary card. Refresh to try again.',
    },
    session: {
      fillButton: 'Fill in session',
      fillTitle: 'Fill in the diary card for {{name}}',
      fillHint:
        'Entered in session: it is part of your practice’s record, visible to your practice and to the client. It does not count as the client filling it in and does not complete an assigned diary card.',
      day: 'Day',
      skillsUsed: 'Skills used (0–7)',
      skillsPracticed: 'Skills practiced',
      note: 'A note',
      save: 'Save for the client',
      saved: 'Diary card filled in for the client.',
      saveFailed: 'Could not save the diary card. Check the values and try again.',
      recapTitle: 'Diary card highlights (your practice’s card)',
      recapNone: 'Nothing rated above zero since the last session.',
      recapLine: '{{day}} · {{name}}: {{value}}',
      recapSkills: 'Skills used, average: {{value}}',
    },
    row: {
      't-suicide-urge': 'Urge to commit suicide',
      't-selfharm-urge': 'Urge to self-harm',
      't-drugs-urge': 'Urge to use drugs',
      't-selfharm': 'Self-harm',
      't-binge': 'Binge eating',
      't-other-urge': 'Another urge',
      't-acted': 'Did I act on an urge?',
      't-planned-meals': 'Meals and snacks at planned times',
      't-binges': 'Binges',
      't-compensating': 'Compensating',
      't-gap-4h': 'A gap over 4 hours',
      't-eating-feeling': 'Feeling today',
      't-alcohol-grams': 'Grams of alcohol',
      't-drink-urge': 'Urge to drink',
      't-drink-trigger': 'Trigger',
    },
    emotion: {
      emotionalMisery: 'Emotional misery',
      physicalMisery: 'Physical misery',
      joy: 'Joy',
    },
    module: {
      mindfulness: 'Mindfulness',
      distressTolerance: 'Distress tolerance',
      emotionRegulation: 'Emotion regulation',
      interpersonalEffectiveness: 'Interpersonal effectiveness',
    },
    skill: {
      wiseMind: 'Wise mind',
      observe: 'Observe',
      describe: 'Describe',
      participate: 'Participate',
      nonjudgmental: 'Non-judgmentally',
      oneMindful: 'One-mindfully',
      effective: 'Effectively',
      tipp: 'TIPP',
      stop: 'STOP',
      proCons: 'Pros and cons',
      distract: 'Distract',
      selfSoothe: 'Self-soothe',
      improve: 'IMPROVE the moment',
      radicalAcceptance: 'Radical acceptance',
      turningTheMind: 'Turning the mind',
      willingness: 'Willingness',
      checkTheFacts: 'Check the facts',
      oppositeAction: 'Opposite action',
      problemSolving: 'Problem solving',
      accumulatePositives: 'Accumulate positives',
      buildMastery: 'Build mastery',
      copeAhead: 'Cope ahead',
      please: 'PLEASE',
      mindfulOfEmotions: 'Mindfulness of current emotions',
      dearMan: 'DEAR MAN',
      give: 'GIVE',
      fast: 'FAST',
      validation: 'Validation',
      findingBalance: 'Finding balance',
      walkTheMiddlePath: 'Walk the middle path',
    },
    template: {
      dbtStandard: {
        name: 'DBT diary card',
        summary:
          'The standard DBT card: urges, actions, feelings and the skills you used, day by day',
      },
      dbtSkills: {
        name: 'DBT skills card',
        summary:
          'One minute a day: urges, misery, whether you acted, which skills you used',
      },
      eatingDay: {
        name: 'Eating day',
        summary:
          'How the day went: planned meals, binges, compensating, a long gap, how you feel',
      },
      drinkingDay: {
        name: 'Drinking day',
        summary: 'Grams of alcohol, the urge to drink, and what set it off',
      },
    },
  },
  // E43 · Health Data (cc-health): the deciders' refusals (`healthData.errors.<CODE>`) and the phone's screens
  // (`health.*` — the board's Behavior keys). {{store}} is "Apple Health" or "Health Connect".
  healthData: {
    errors: {
      HEALTH_TYPES_EMPTY: 'Choose at least one kind of health data to share, then tap Continue.',
      HEALTH_TYPE_UNKNOWN:
        'This kind of health data is not supported by your version of CopingCard. Update the app, then try again.',
      HEALTH_TYPE_NOT_GRANTED:
        'This kind of health data is not shared with CopingCard right now. Open Health data in Settings to see what is shared, then try again.',
      HEALTH_SHARING_NO_RELATION:
        'You are no longer connected to this therapist, so there is nothing to share. Pull down to refresh the list.',
      conflictRetry: 'Your health data settings changed at the same moment. Please try again.',
    },
  },
  health: {
    types: {
      sleep: 'Sleep',
      activity: 'Activity',
      heartRate: 'Heart rate',
    },
    stores: {
      appleHealth: 'Apple Health',
      healthConnect: 'Health Connect',
    },
    connect: {
      intro:
        'CopingCard can read daily summaries from {{store}}, so you do not have to type them in. Choose what to share. Nothing is written back to {{store}}.',
      typeDetail: {
        sleep: 'Time in bed, time asleep, awakenings and sleep stages: one summary a night.',
        activity: 'Steps, active minutes and workouts: one summary a day.',
        heartRate:
          'Resting heart rate and heart-rate variability: one summary a day. During exposure sessions: your lowest, average and highest heart rate.',
      },
      privacy:
        'Your therapist does not see any of it unless you turn sharing on for them. Used only for your care: never for advertising, never sold.',
      continue: 'Continue',
      saving: 'Saving…',
      saveError: 'We could not save your choice. Check your internet connection and try again.',
      permissionError:
        'We could not open the {{store}} permissions. Try again, or allow CopingCard in {{store}} yourself.',
      unavailable: {
        title: 'Health data is not available on this device',
        oldAndroid: 'Health Connect needs Android 9 or later.',
        notInstalled: 'To share health data, install Health Connect from Google Play, then come back here.',
        updateRequired: 'To share health data, update Health Connect from Google Play, then come back here.',
        noHealthKit: 'Apple Health is not available on this device.',
        updateApp: 'To share health data, update CopingCard from the App Store or Google Play.',
        openStore: 'Open Google Play',
      },
    },
    settings: {
      title: 'Health data',
      open: 'Health data',
      from: 'From {{store}}',
      shared: 'Shared since {{date}}',
      notShared: 'Not shared',
      lastNight: 'Last night: {{night}}',
      lastDay: 'Last day: {{day}}',
      noDataYet: 'No data yet',
      noDataHint:
        'Nothing has arrived yet. If you declined access, allow CopingCard to read this data in {{store}}.',
      lastImport: 'Last import {{time}}',
      shareMore: 'Share more',
      stopSharing: 'Stop sharing…',
      openHealthApp: 'Open the Health app',
      openHealthConnect: 'Open Health Connect',
      loadError: 'We could not load your health data settings. Check your internet connection and pull down to try again.',
    },
    // E43 block 2 — the phone's views (numbers only: no labels, scores or advice)
    open: {
      sleep: 'My sleep',
      activity: 'My activity',
      heartRate: 'My heart',
      sharing: 'Therapist sharing',
    },
    summary: {
      days30: '30 days',
      empty: 'Nothing has arrived yet. It appears after the next time you open CopingCard with {{store}} data on this phone.',
      loadError: 'We could not load this. Check your internet connection and pull down to try again.',
    },
    sleep: {
      title: 'My sleep',
      subtitle: '30 nights, as your device measured them',
      averageAsleep: 'Average asleep: {{duration}}',
      averageEfficiency: 'Average sleep efficiency: {{percent}}%',
      inBed: 'In bed {{duration}}',
      asleep: 'Asleep {{duration}}',
      efficiency: 'Efficiency {{percent}}%',
      awakenings_one: '{{count}} awakening',
      awakenings_other: '{{count}} awakenings',
      duration: '{{hours}} h {{minutes}} min',
    },
    activity: {
      title: 'My activity',
      subtitle: '30 days of steps, active minutes and workouts',
      averageSteps: 'Average steps: {{count}}',
      averageActiveMinutes: 'Average active minutes: {{count}}',
      steps: '{{count}} steps',
      activeMinutes: '{{count}} active min',
      workout: '{{type}} · {{minutes}} min',
      workoutTypes: {
        walking: 'Walking',
        running: 'Running',
        cycling: 'Cycling',
        swimming: 'Swimming',
        yoga: 'Yoga',
        strength: 'Strength training',
        hiking: 'Hiking',
        dance: 'Dance',
        other: 'Workout',
      },
    },
    heart: {
      title: 'My heart',
      subtitle: '30 days of resting heart rate and heart-rate variability',
      averageResting: 'Average resting heart rate: {{bpm}} bpm',
      resting: 'Resting {{bpm}} bpm',
      hrv: 'HRV {{value}} ms ({{metric}})',
      metricNote:
        'HRV is measured as SDNN on iPhone and as RMSSD on Android. They are different measures, so the numbers are not comparable between phones.',
    },
    sharing: {
      title: 'Therapist sharing',
      intro:
        'Choose what each of your therapists sees in their CopingCard portal: nightly sleep summaries, daily activity totals, and your resting heart rate, HRV and heart rate during exposures. Never minute-by-minute data. Off until you turn it on.',
      noTherapists: 'You are not connected to a therapist yet. When you are, you can choose here what they see.',
      notSharedWithCopingCard: 'Share this with CopingCard first, in Health data.',
      saveError: 'We could not save this. Check your internet connection and try again.',
      typeHint: {
        sleep: 'Nightly sleep summaries',
        activity: 'Daily steps, active minutes and workouts',
        heartRate: 'Resting heart rate, HRV and heart rate during exposures',
      },
    },
    // E43 · the client hub's Sleep & activity (portal; portalEn spreads these). Numbers only.
    hub: {
      tab: 'Sleep & activity',
      title: 'Sleep & activity: the last 30 days',
      notShared: 'not shared',
      notSharedHint: 'The client has not shared {{type}} with you.',
      noDataYet: 'No data has arrived yet.',
      loadError: 'We could not load this section. Reload the page to try again.',
      sleepSummary: 'Average asleep {{asleep}} · efficiency {{efficiency}}% · {{count}} of {{days}} nights',
      activitySummary: 'Average {{steps}} steps and {{active}} active minutes a day · {{count}} days',
      heartSummary: 'Average resting heart rate {{bpm}} bpm · {{count}} days',
      hrvMetric: 'HRV measured as {{metric}} by the client’s phone; SDNN and RMSSD are not comparable.',
      mood: 'Mood (check-ins)',
      moodSummary_one: '{{count}} day with a check-in',
      moodSummary_other: '{{count}} days with a check-in',
      empty: 'Nothing to show for the last 30 days.',
      footer: 'From the client’s phone · shared with you: {{shared}} · not shared: {{notShared}}',
      column: {
        day: 'Day',
        asleep: 'Asleep',
        efficiency: 'Efficiency',
        steps: 'Steps',
        activeMinutes: 'Active min',
        restingHeartRate: 'Resting HR',
        hrv: 'HRV',
        mood: 'Mood',
        score: 'Score',
      },
    },
    // the phone beside the E37 check-ins (Q-e43g1-6 A)
    checkIns: {
      fromPhone: 'From your phone: {{values}}',
      rowsTitle: 'From the client’s phone',
      asleepRow: 'Asleep (hours)',
      activeRow: 'Active minutes',
      notShared: 'not shared',
      sleepAverage: 'Average asleep {{duration}} · efficiency {{percent}}%',
      sleepAverageNoEfficiency: 'Average asleep {{duration}}',
      activeAverage: 'Average {{count}} active minutes a day',
      recapTitle: 'From the client’s phone since the last session',
      recapNotShared: '{{type}}: not shared with you',
    },
    revoke: {
      title: 'Stop sharing',
      choose: 'Choose what to stop sharing',
      deleteImported: 'Also delete what was imported',
      osNote: "To remove CopingCard's access completely, also turn it off in {{store}}.",
      confirm: 'Stop sharing',
      cancel: 'Cancel',
      saving: 'Stopping…',
      error: 'We could not stop sharing. Check your internet connection and try again.',
      done: 'Sharing stopped.',
    },
  },
  // E38 · Safety plan (cc-wellness: "Safety Plan — My safety plan (mobile, E38)" and "Co-author & review (portal, E38)").
  // The wording is OURS — no outside name, no outside form. Outside the app everything is the neutral "My plan"
  // (Q-e38g1-1 A): those strings are native (InfoPlist.strings, strings.xml), not here.
  safetyPlan: {
    errors: {
      SAFETYPLAN_SECTION_UNKNOWN:
        'This part of the plan does not exist in your version of CopingCard. Go back to the plan and choose one of its parts.',
      SAFETYPLAN_SECTION_TOO_LONG:
        'A part of the plan can hold up to 10 entries. Remove one and save again.',
      SAFETYPLAN_CONTACT_NAME:
        'Every person needs a name. Add a name to each entry, or remove the empty ones, then save again.',
      SAFETYPLAN_NOT_ALLOWED:
        'You can edit this plan only when the client has given you permission to edit their records. Ask the client to turn editing on for you in the app, then try again.',
      SAFETYPLAN_NONE:
        'There is nothing to review yet — no part of the plan has been saved. Fill in at least one part with the client first, then mark it reviewed.',
      SAFETY_PLAN_NOT_YOURS:
        'This plan could not be opened. Close it and open your plan again from the Crisis menu.',
      HOMEWORK_NOT_YOUR_CLIENT:
        'This client is not connected with you at your practice — they are not your client here, or they have switched off sharing with you. Check the client list, or ask the client to turn sharing with you back on in the app.',
      conflictRetry: 'The plan changed at the same moment. Please try again.',
    },
    // the diary card's standing link (E37 Q-e37-4 A): the same line on every fill
    diaryLink: 'My safety plan',
    intro:
      'A plan you make when you feel steady, for the moments you do not. Read it from the top; stop at the first step that helps.',
    entry: {
      mine: 'My safety plan',
      make: 'Make a safety plan',
      mineBody: 'The steps that help me, and the people to call.',
      makeBody: 'Write down what helps you and who to call — you can add to it any time.',
      filled: '{{count}} of 7 parts filled in',
      toolkit: 'My safety plan',
      toolkitMake: 'Make a safety plan',
    },
    sections: {
      warningSigns: {
        title: '1. Warning signs',
        prompt: 'What do I notice when a hard time may be starting?',
        hint: 'Thoughts, moods, situations or things in your body, for example “I stop answering messages”.',
      },
      copingStrategies: {
        title: '2. Things I can do on my own',
        prompt: 'What can I do on my own to take my mind off things?',
        hint: 'For example “cold water on my face” or “a walk round the block”.',
      },
      distractions: {
        title: '3. People and places that help me feel steadier',
        prompt: 'Where can I go, or who can I be around, to feel steadier?',
        hint: 'A friend’s kitchen, a café, a park, a place of worship — somewhere with other people.',
      },
      helpContacts: {
        title: '4. People I can ask for help',
        prompt: 'Who can I tell that I am having a hard time?',
        hint: 'Add a name and a number. You can pick someone from your phone’s contacts.',
      },
      professionals: {
        title: '5. Professionals and crisis lines',
        prompt: 'Who can I call if I cannot keep myself safe?',
        hint: 'Your therapist, your doctor, and the crisis lines below.',
      },
      environmentSafety: {
        title: '6. Making my surroundings safer',
        prompt: 'What can I do to make my surroundings safer?',
        hint: 'Best done with your therapist.',
        note: 'Best done with your therapist.',
      },
      reasonsForLiving: {
        title: '7. My reasons for living',
        prompt: 'What matters most to me? What do I want to stay for?',
        hint: 'People, pets, plans, things you want to see or do.',
      },
    },
    empty: 'Nothing here yet.',
    addedByTherapist: 'Added by your therapist',
    addedByName: 'Added by {{name}}',
    yourTherapist: 'Your therapist',
    action: {
      edit: 'Edit',
      call: 'Call',
      message: 'Message',
      text: 'Text',
      share: 'Share',
      save: 'Save',
      saving: 'Saving…',
      cancel: 'Cancel',
      add: 'Add',
      remove: 'Remove',
      done: 'Done',
      openChat: 'Open chat',
      openLink: 'Open link',
    },
    messageDraft: 'I’m having a hard time — can you call me?',
    shareTitle: 'My safety plan',
    shareIntro: 'My safety plan',
    opensDisclosure:
      'If you share data with a therapist, your therapist can see how many times a week you open this plan — not when, and not what you read. Nothing is sent to them when you do.',
    offline: 'You are offline. Your plan is saved on this phone and you can still read it.',
    loadError: 'We could not load your plan. Check your connection and pull down to try again.',
    edit: {
      title: 'Edit this part',
      entryText: 'One entry',
      entryName: 'Name',
      entryPhone: 'Phone number',
      pickContact: 'Choose from contacts',
      kindPerson: 'A person — tap to make it a place',
      kindPlace: 'A place — tap to make it a person',
      addEntry: 'Add another',
      maxEntries: 'Up to 10 entries.',
      clearHint: 'Leave it empty to clear this part.',
      saved: 'Saved.',
      saveError: 'We could not save. Check your connection and try again.',
      contactsDenied: 'CopingCard cannot read your contacts. Type the name and number instead, or allow contacts in your phone’s settings.',
    },
    callError: 'This phone cannot place a call from here. Dial the number yourself.',
    hub: {
      tab: 'Safety plan',
      title: 'Safety plan',
      noPlan: 'This client has not made a safety plan yet. You can start one with them here.',
      readOnly: 'You can read this plan; editing needs the client’s permission to edit their records.',
      opensThisWeek_one: 'Opened {{count}} time this week',
      opensThisWeek_other: 'Opened {{count}} times this week',
      opensNote: 'A count only — not when, and not what was read. The client is told you can see it.',
      opensWeeks: 'Opens per week',
      weekOf: 'Week of {{date}}',
      lastReviewed: 'Last reviewed {{date}} with {{name}}',
      lastReviewedNoName: 'Last reviewed {{date}}',
      nextReview: 'Next review by {{date}}',
      neverReviewed: 'Not reviewed yet',
      edit: {
        action: 'Edit with the client',
        title: 'Edit with the client',
        save: 'Save part',
        cancel: 'Cancel',
        entry: 'Entry',
        person: 'Person',
        place: 'Place',
        name: 'Name',
        phone: 'Phone',
        add: 'Add entry',
        remove: 'Remove',
        saved: 'Saved. The client’s phone shows the change at once.',
        error: 'We could not save. Check your connection and try again.',
      },
      review: {
        action: 'Mark reviewed',
        title: 'Mark the plan reviewed',
        nextReviewBy: 'Next review by',
        note: 'Note (optional)',
        notePlaceholder: 'For example: Went through every step; added a second reason for living',
        save: 'Mark reviewed',
        saving: 'Saving…',
        cancel: 'Cancel',
        saved: 'Marked reviewed.',
        error: 'We could not save the review. Check your connection and try again.',
      },
      byClient: 'the client',
      byTherapistName: '{{name}}',
    },
    history: {
      title: 'History',
      when: 'When',
      what: 'What changed',
      empty: 'No changes yet.',
      savedPart: '{{who}} changed “{{section}}”',
      reviewedBy: '{{who}} marked the plan reviewed',
      nextReview: 'Next review by {{date}}',
      noEntries: 'cleared',
      loadError: 'We could not load the history. Refresh the page to try again.',
    },
    widget: {
      // everything outside the app is NEUTRAL (Q-e38g1-1 A): nothing here says safety, crisis or suicide
      name: 'My plan',
      description: 'One tap to open your plan.',
      tap: 'Tap to open',
      intentTitle: 'Open my plan',
      intentDescription: 'Opens your plan in CopingCard.',
      shortcutShort: 'My plan',
      shortcutLong: 'Open my plan',
      // the Siri phrases (App Shortcuts); {{app}} becomes ${applicationName} in AppShortcuts.strings (Q-rel-6 B, 2026-10-13)
      siriPhrase: 'Open my plan in {{app}}',
      siriPhraseAlt: 'Open {{app}} my plan',
      // the setting inside the app (Safety plan — the name outside the app); nothing is recorded
      renameTitle: 'Name outside the app',
      renameBody:
        'Your home-screen widget shows this name. Only you see it; nothing is recorded.',
      renameLabel: 'Name',
      renameSave: 'Save',
    },
  },

  // ── E38 · the PRIVATE on-phone safety offer (D-phrase-prompt-2026-10-04; phrase list approved 2026-10-10). After a save completes,
  // a listed phrase makes the phone offer the plan and the crisis lines. Device-only: nothing sent, stored or counted.
  safetyPrompt: {
    title: 'That sounds really hard',
    body: 'If you would like some support right now, you can open your safety plan or see the crisis lines. This stays on your phone: nothing you wrote was sent to anyone.',
    openPlan: 'Open my safety plan',
    makePlan: 'Make my safety plan',
    crisisLines: 'See the crisis lines',
    notNow: 'Not now',
  },

  // ── E47 · Schema modes (cc-tools-3; G1 approved 2026-10-16) — my modes in my own words, a fast multi-mode check-in, the mode card
  // (the coping card I linked to a mode), my week, the prompts; the hub's mode map and timeline. The wording of the fourteen modes —
  // names, one-line descriptions, groups, presets and labels — is the founder-approved file docs/em&es/review-2026-10-16-argon-check/
  // E47-mode-wording.en.md (Q-e47g1-9 A); its RU twin (.ru.md, approved) is `modes.catalog.*` in translationRu.ts AS WRITTEN. The
  // fourteen modes are concepts (Lobbestael et al. 2010), the words are ours. Nothing here advises: the app shows what the person
  // recorded and the card THEY linked, never "you are in X, do Y".
  modes: {
    errors: {
      MODE_SET_EMPTY: 'Your modes need at least one mode. Turn one on and save again.',
      MODE_SET_TOO_MANY:
        'That is too many modes. You can keep the 14 standard modes and add up to 6 of your own. Remove one and save again.',
      MODE_SET_NEEDS_HEALTHY_ADULT:
        'The Healthy Adult has to stay in your modes — it is always on. Turn it back on and save again.',
      MODE_KIND_INVALID:
        'One of the modes could not be saved. A mode of your own must be a Child, Coping or Critic mode (the Healthy Adult is already there), with a name. Check your own modes and save again.',
      MODE_SET_NOT_YOUR_CLIENT:
        'This client is not connected with you at your practice — they are not your client here, or they have switched off sharing with you. Check the client list, or ask the client to turn sharing with you back on in the app.',
      MODE_CHECKIN_EMPTY: 'Tap at least one mode that is here, then save.',
      MODE_UNKNOWN:
        'One of those modes is not in your modes any more. Open “My modes” to see the current list, then check in again.',
      MODE_INTENSITY_RANGE:
        'Each mode is rated from 0 to 10. Slide it to a number in that range and save again.',
      MODE_CHECKIN_TIME:
        'A check-in can be for now or for up to 48 hours ago. Choose a time in that range.',
      MODE_CARD_NOT_YOURS:
        'That card could not be found among your coping cards. Open your cards and choose one of them.',
      MODE_CHECKIN_NOT_YOURS: 'You can only delete your own check-ins.',
      MODE_CHECKIN_UNKNOWN:
        'This check-in could not be found — it may already have been deleted. Refresh the list.',
    },
    // The approved wording (Q-e47g1-9 A) — ONE list for the phone's set-up and check-in and the hub's “Set up with the client”.
    catalog: {
      presets: { commonSeven: 'The common seven', allFourteen: 'All fourteen' },
      groups: {
        child: 'Child modes',
        coping: 'Coping modes',
        critic: 'Critic modes',
        healthy: 'Healthy Adult',
      },
      kinds: {
        child: 'Child',
        coping: 'Coping',
        critic: 'Critic',
        healthyAdult: 'Healthy',
        happyChild: 'Child',
      },
      inMyWords: 'In my words',
      addOwn: 'Add my own mode',
      vc: {
        name: 'Vulnerable Child',
        description: 'feeling small, lonely, scared or overwhelmed',
      },
      ac: {
        name: 'Angry Child',
        description: "angry and frustrated when needs aren't met",
      },
      ec: { name: 'Enraged Child', description: 'rage that feels out of control' },
      ic: {
        name: 'Impulsive Child',
        description: 'acting on urges right away, without thinking of later',
      },
      uc: {
        name: 'Undisciplined Child',
        description: 'giving up when things get boring or hard',
      },
      hc: { name: 'Happy Child', description: 'playful, spontaneous, at ease' },
      cs: {
        name: 'Compliant Surrender',
        description: 'giving in and pleasing others, my own needs last',
      },
      dp: {
        name: 'Detached Protector',
        description: 'shutting off feelings, going numb or distant',
      },
      ds: {
        name: 'Detached Self-Soother',
        description:
          'numbing or distracting myself with work, scrolling, food or other habits',
      },
      sa: {
        name: 'Self-Aggrandizer',
        description: 'needing to feel superior, special or in control',
      },
      ba: {
        name: 'Bully and Attack',
        description: 'attacking or controlling others before they can hurt me',
      },
      pc: {
        name: 'Punitive Critic',
        description: 'harsh self-blame, feeling I deserve to be punished',
      },
      dc: {
        name: 'Demanding Critic',
        description: 'relentless pressure: nothing is ever enough',
      },
      ha: {
        name: 'Healthy Adult',
        description: 'wise, caring and balanced; looks after my needs',
      },
    },
    // the needs behind a mode (Young's core emotional needs, plus play and limits; Q-rev-4 A added `expression`)
    needs: {
      safety: 'Safety',
      connection: 'Connection',
      acceptance: 'Acceptance',
      expression: 'Being heard',
      autonomy: 'Autonomy',
      play: 'Play',
      limits: 'Limits',
    },
    screens: {
      home: 'Schema modes',
      setup: 'My modes',
      checkIn: 'Which modes are here?',
      week: 'My week',
      allCheckIns: 'All check-ins',
      card: 'A card for this mode',
    },
    // E47 · the phone's screens (mobile build). The Toolkit tile:
    entry: {
      title: 'Schema modes',
      body: 'Name the modes you know in yourself and notice which are here now.',
    },
    // “Modes — My modes” (the list)
    list: {
      title: 'My modes',
      intro: 'The modes I know in myself, in my own words.',
      defaultSet: 'These are the common seven. Edit my modes to make them yours.',
      checkIn: 'Which modes are here now?',
      edit: 'Edit my modes',
      week: 'My week',
      noCard: '+ Add a card',
      tapHeading: 'Tap a mode that is here now',
      openCard: 'Open card',
      changedByYou: 'Last changed by you, {{date}}',
      changedBy: 'Last changed by {{name}}, {{date}}',
      changedByTherapist: 'Last changed by your therapist, {{date}}',
    },
    // “Modes — My modes (set up)”
    setup: {
      title: 'Set up my modes',
      intro:
        'Choose the modes you want to track, name them in your own words and give each a color. You can change this any time.',
      presets: 'Start from',
      on: 'On',
      alwaysOn: 'The Healthy Adult is always on',
      colour: 'Color',
      colourChoice: 'Color {{n}}',
      ownName: 'A name for this mode',
      ownKind: 'It is a…',
      ownAdd: 'Add',
      ownCancel: 'Cancel',
      ownLimit: 'You have added the most you can: {{max}} modes of your own.',
      ownBadge: 'My own',
      save: 'Save my modes',
      saving: 'Saving…',
      saved: 'Your modes are saved.',
      failed: 'We could not save your modes. Check your connection and try again.',
    },
    // “Modes — A card for this mode (section)”
    card: {
      heading: 'The card for this mode',
      body: 'Pick one of my coping cards. After a check-in, the card of the strongest of these modes opens — because I linked it.',
      none: 'No card linked yet.',
      linked: 'Linked: {{name}}',
      use: 'Use this card',
      change: 'Change card',
      unlink: 'Unlink',
      pick: 'Choose one of my coping cards',
      myCards: 'My coping cards',
      create: 'Create a new card',
      unnamed: 'My card',
      search: 'Search my cards',
      showAll: 'Show all ({{count}})',
      noMatch: 'No card matches. Try other words, or create a new card.',
      close: 'Close',
      noCards: 'I have no coping cards yet. Create one for this mode.',
      createdNotLinked: 'Your card is saved, but we could not link it to this mode. Pick it below, or check your connection and try again.',
      saved: 'Saved.',
      failed: 'We could not link that card. Check your connection and try again.',
    },
    // “Modes — Which modes are here now?”
    checkin: {
      title: 'Which modes are here now?',
      intro: 'Tap the modes that are here right now — several can be. Then rate each from 0 to 10.',
      noModes: 'Turn on at least one mode in My modes first.',
      intensity: 'How strong is {{mode}}? (0–10)',
      triggerLabel: 'What set it off? (optional)',
      triggerPlaceholder: 'For example: my boss said the report needs work',
      bodyCueLabel: 'Where do I feel it? (optional)',
      bodyCuePlaceholder: 'For example: hot face, shoulders up',
      needLabel: 'What did I need? (optional)',
      noteLabel: 'A note (optional)',
      whenLabel: 'When was this?',
      when: {
        now: 'Now',
        hour1: '1 hour ago',
        hour3: '3 hours ago',
        yesterday: 'Yesterday',
      },
      save: 'Save',
      saving: 'Saving…',
      saved: 'Saved.',
      savedOffline: 'Saved on this phone. It will be sent when you are back online.',
      failed: 'We could not save this check-in. Check what you entered and try again.',
      week: 'My week',
      edit: 'Edit my modes',
    },
    // “Modes — My week”
    week: {
      title: 'My week',
      range7: '7 days',
      range30: '30 days',
      periodHeading: 'The whole period',
      periodMeta: 'Days: {{days}} · strongest {{peak}}',
      daysHeading: 'Day by day',
      daySummary: 'Check-ins: {{count}} · strongest: {{name}} {{peak}}',
      peak: 'strongest {{n}}',
      topTriggers: 'What set them off most',
      topTriggerCount: '{{count}}×',
      healthyAdult: 'The Healthy Adult this week',
      healthyShare: '{{share}}% of everything I rated',
      healthyPresent: 'Present in {{present}} of {{total}} check-ins',
      healthyMean: 'Average strength when present: {{mean}}',
      healthyNoShare: 'Nothing rated above 0 this week yet.',
      healthyNotRated: 'The Healthy Adult was not rated this week.',
      switchedOff: 'switched off',
      cardOpen: 'Open the card',
      edit: 'Edit my modes',
      checkIn: 'Which modes are here now?',
      olderBlur: 'See your whole history with Premium',
      olderCount: '{{count}} earlier days with check-ins',
      entries: 'Check-ins',
      allCheckIns: 'All check-ins ({{count}})',
      empty: 'Nothing recorded yet. Tap “Which modes are here now?” to start.',
      menu: 'More',
    },
    // “Modes — All check-ins”
    all: {
      title: 'All check-ins',
      empty: 'No check-ins in this period.',
    },
    // “Modes — My week — Delete (section)”
    delete: {
      action: 'Delete',
      title: 'Delete this check-in?',
      body: 'It will be removed from my week.',
      failed: 'We could not delete that check-in. Check your connection and try again.',
    },
    // “Modes — Check-in prompts (section)”
    prompts: {
      title: 'Three prompts a day',
      body: 'A quiet nudge at 11:00, 15:00 and 20:00 to notice which modes are here. You can change the times.',
      on: 'On: {{n}} prompts a day',
      off: 'Off',
      turnOn: 'Turn the prompts on',
      turnOff: 'Turn the prompts off',
      notificationTitle: 'Which modes are here?',
      notificationBody: 'A quick check-in: tap the modes that are here right now.',
    },
    // E47 · the hub's Modes tab (cc-tools-3, "Client Hub — Modes" and its two sections). The mode names, groups, presets and kinds are
    // `modes.catalog.*` (founder-approved); the client's own words come from the data. Display only: no alert, no score, no advice.
    hub: {
      title: 'Schema modes',
      displayOnly:
        'The client’s own words and numbers, shown as they are — no alerts, scores or advice.',
      loadError: 'The modes could not be loaded. Check your connection and try again.',
      loading: 'Loading the modes…',
      emptyPeriod: 'No mode check-ins in this period. They appear here when {{name}} checks in on the phone.',
      period: {
        // N-6 (2026-10-22): one bar per mode for the whole period, like the app’s My week
        title: 'The whole period',
        meta: 'Days: {{days}} · strongest {{peak}}',
        label: 'Period',
        d7: '7 days',
        d30: '30 days',
        d90: '90 days',
        custom: 'Custom',
        from: 'From',
        to: 'To',
        range: '{{from}} – {{to}}',
      },
      map: {
        title: 'Mode map',
        card: 'card',
        noCard: 'no card yet',
        switchedOff: 'switched off',
        own: 'own mode',
      },
      timeline: {
        title: 'Day by day',
        hint: 'Each day’s strongest rating per mode, stacked.',
        segment: '{{mode}} — peak {{peak}}',
      },
      matrix: {
        title: 'Triggers and modes',
        hint: 'How many check-ins with that trigger had each mode.',
        trigger: 'Trigger',
        empty: 'No triggers were written in this period.',
      },
      ha: {
        title: '{{mode}} by week',
        week: 'Week of {{date}}',
        share: '{{percent}} % of all intensity',
        noFigure: 'no figure',
        notRated: 'not rated this week',
        present: 'present in {{present}} of {{total}} check-ins',
        mean: 'mean {{mean}} when present',
        empty: 'No check-ins in this period.',
      },
      counts: {
        thisWeek: 'Check-ins this week: {{count}}',
        inRange: 'Check-ins in this period: {{count}}',
      },
      lastChange: {
        client: 'Last changed by the client on {{date}}',
        therapist: 'Last changed by {{name}} on {{date}}',
        therapistNoName: 'Last changed by a therapist on {{date}}',
        you: 'Last changed by you on {{date}}',
        never: 'The modes have not been changed yet — the common seven are shown.',
      },
      setup: {
        open: 'Set up the modes',
        title: 'Set up the modes with {{name}}',
        hint:
          'Choose the modes to turn on for {{name}} and name them in their words. The latest edit wins, whoever made it — {{name}} can change them on the phone too.',
        enable: 'Turn on {{mode}}',
        alwaysOn: 'always on',
        name: 'Name in the client’s words',
        colour: 'Color for {{mode}}',
        ownTitle: 'Their own modes',
        ownName: 'Name of the new mode',
        ownKind: 'Type',
        ownLimit: 'Up to {{max}} modes of their own beside the 14 standard ones.',
        remove: 'Remove',
        save: 'Save modes for {{name}}',
        saved: 'Saved. The modes are on {{name}}’s phone now.',
        error: 'The modes could not be saved. Check your connection and try again.',
        needsName: 'Give each mode of their own a name, then save.',
      },
      // the Assign button is the shared one (components/ToolSection); these two are its preset's defaults
      assign: {
        defaultTitle: 'Notice your modes — three check-ins a day this week',
        defaultInstructions: 'Whenever you notice a strong feeling, tap the modes that are there.',
      },
    },
  },

  // ── E36 · Values (cc-tools-values; G1 approved 2026-10-10) — the card sort, the wheel / bull's eye, the Valued Living Questionnaire,
  // the activities (LAVA) and their AI suggestions, the link kernel and the one profile. The wording is OURS; the Miller card sort
  // deck (public domain, 2001) is the instrument's own text — `values.deck.miller.*`, one "NAME — what it means" line per card (the RU
  // is generated and goes to Dmitri for review, founder Q-e36-3 A).
  // E53 · the wind rose — Dmitri Dyakov's technique («Роза ветров человеческого поведения»): a way of living rated 1–10 on eight emotional
  // needs, compared with another way, chosen and planned. The need names below are the schema-therapy core needs (see `needs`; his own Russian names are the RU).
  rose: {
    screens: {
      home: 'Wind rose',
      describe: 'A way of living',
      rate: 'The eight needs',
      choose: 'Try them on and choose',
      plan: 'My plan',
    },
    // the founder's wording (2026-10-12): Dmitri's degree before his name (RU: «доктора психологических наук»)
    credit: 'A technique by Dr. Dmitri Dyakov',
    // The eight need names are the core emotional needs of schema therapy and their sub-needs — Young, Klosko & Weishaar (2003),
    // Schema Therapy: A Practitioner's Guide — the source for Dmitri (founder D3 B, 2026-10-12). The RU names are Dmitri's own.
    needs: {
      loveAcceptance: 'Nurturance and acceptance',
      empathyUnderstanding: 'Empathy and understanding',
      predictabilityReliability: 'Stability and predictability',
      safety: 'Safety',
      competence: 'Competence',
      autonomy: 'Autonomy',
      selfExpression: 'Freedom to express needs and emotions',
      spontaneity: 'Spontaneity and play',
    },
    home: {
      intro:
        'A way of living is more than a word: it is what you do, day to day. Rate it on eight needs and see its shape, then lay another way over it and choose.',
      empty: 'Nothing here yet. Start with the way you live now.',
      describeNow: 'Describe the way I live now',
      describeAnother: 'Describe another way',
      rateIt: 'Rate it on the eight needs',
      tryOnAndChoose: 'Try them on and choose',
      chartLabel: 'The wind rose: each way of living drawn on eight rays, one for each need',
      ringHelp:
        'The ring at 8 means enough. A score above it is drawn, but adds nothing to the mean.',
      mean: 'Mean (capped at 8): {{mean}}',
      rawMean: 'Mean of the scores: {{mean}}',
      kind: { current: 'The way I live now', alternative: 'Another way' },
      basis: { lived: 'lived', imagined: 'imagined' },
      chosenTag: 'chosen',
      chosenHeading: 'The way I chose',
      chosenValue: 'Value: {{value}}',
      beliefs: 'Beliefs that hold it up',
      sharedBy: 'People who share it',
      history: 'Ratings over time',
      writePlan: 'Write my plan',
      viewPlan: 'My plan',
      rateAgain: 'Rate my chosen way again',
      loadError: 'We could not load your wind rose. Check your connection and try again.',
      retry: 'Try again',
    },
    describe: {
      titleNow: 'The way I live now',
      titleAnother: 'Another way of living',
      bodyNow:
        'Give the way you live now a name, and write what you actually do in it. Writing what you do is optional here.',
      bodyAnother:
        'Describe another way you could live: a name, and at least one concrete thing you would do. Behavior, not an outcome.',
      help: 'A way of living is a name plus the concrete things you do — not what you hope will result.',
      name: 'Name',
      namePlaceholder: 'For example: Keep it light',
      behaviorsNow: 'What I do (optional)',
      behaviorsAnother: 'What I would do (at least one)',
      behavior: 'Behavior {{n}}',
      behaviorPlaceholder: 'For example: Join the Thursday pottery group',
      addBehavior: 'Add another',
      behaviorsFull: 'That is ten — the most a way can hold.',
      inspired: 'Where did the idea come from? (optional)',
      inspiredKind: {
        myPast: 'My past',
        someoneClose: 'Someone close',
        someoneFar: 'Someone far away',
        bookOrFilm: 'A book or film',
        valuesList: 'My values list',
        other: 'Somewhere else',
      },
      inspiredRef: 'Who or what',
      inspiredRefPlaceholder: 'A name, a title or a card',
      notCompleteNow: 'Give the way a name to continue.',
      notCompleteAnother: 'Give the way a name and write at least one thing you would do.',
      save: 'Save and rate it',
      saving: 'Saving…',
      error: 'We could not save this way. Check your connection and try again.',
    },
    rate: {
      title: 'Rate it on the eight needs',
      bodyLived:
        'Close your eyes and picture living the way you just described. Rate it from 1 to 10 on each of the eight needs. This way you know — it is lived.',
      bodyImagined:
        'Close your eyes and imagine living this way. Rate it from 1 to 10 on each of the eight needs. You have not lived it yet — it is imagined.',
      help: '1 means this way gives you almost none of that need, 10 means plenty. Add a short example if one comes to mind.',
      example: 'An example (optional)',
      notComplete: 'Rate all eight needs to draw your rose.',
      save: 'Draw my rose',
      saving: 'Drawing…',
      error: 'We could not save this rating. Check your connection and try again.',
    },
    choose: {
      tryOnTitle: 'Try them on',
      tryOnProgress: 'Way {{n}} of {{total}}',
      tryOnPrompt:
        'Close your eyes. Picture living this way for a week: what you do, who is with you, how your body feels. Stay with it for a minute.',
      tryOnQuestion: 'What do you notice? Nothing is saved from this step.',
      listen: 'Listen to the guide',
      nextWay: 'Try on the next way',
      toChoice: 'Choose',
      skipToChoice: 'Go straight to choosing',
      title: 'Choose a way',
      body: 'Pick the way you choose, name the value it stands for, and say what holds it up.',
      help: 'Beliefs hold a way up from inside; people who share it hold it up from outside. A way must be rated before it can be chosen.',
      value: 'The value it stands for',
      valuePlaceholder: 'For example: Open with people',
      beliefs: 'Beliefs that hold it up',
      beliefPlaceholder: 'A belief, in your words',
      addBelief: 'Add another belief',
      sharedBy: 'People who share it',
      sharedPlaceholder: 'A name',
      addShared: 'Add another person',
      notComplete: 'Pick a way and name its value to continue.',
      nothingRated: 'Rate at least one way on the eight needs first, then come back to choose.',
      save: 'Choose this way',
      saving: 'Saving…',
      error: 'We could not save your choice. Check your connection and try again.',
    },
    plan: {
      body: 'Write what you will do: this week, this month, this year. Say who is in it and what it needs.',
      week: 'This week',
      month: 'This month',
      year: 'This year',
      what: 'What',
      withWhom: 'With whom',
      resources: 'What it needs',
      addItem: 'Add a step',
      save: 'Save my plan',
      saving: 'Saving…',
      saved: 'Your plan is saved.',
      error: 'We could not save your plan. Check your connection and try again.',
      nothingChosen: 'Choose a way first, then write its plan.',
      notComplete: 'Write at least one step to save your plan.',
      doorsTitle: 'From your plan',
      doorsBody: 'Turn a step of this week into something you do.',
      withWhomLine: 'With {{who}}',
      addActivity: 'Add to my activities',
      addActivityConfirm: 'Add',
      difficulty: 'How hard is it? 1 is easiest, 10 is hardest.',
      activityAdded: 'Added to your activities.',
      activityError: 'We could not add this activity. Check your connection and try again.',
      planStep: 'Plan the first step',
      askHelp: 'Ask someone to help',
      beliefsTitle: 'Make a belief a coping card',
      beliefsBody: 'A belief that holds your way up can become a card you can find when it matters.',
      beliefCard: 'Make a coping card',
    },
    hub: {
      title: 'Wind rose',
      empty: 'This client has not started the wind rose yet.',
      loadError: 'We could not load the wind rose. Refresh and try again.',
      credit: 'A technique by Dr. Dmitri Dyakov',
      mean: 'Mean (capped at 8)',
      rawMean: 'Mean of the scores',
      kindCurrent: 'The way they live now',
      kindAlternative: 'Another way',
      chosen: 'Chosen',
      chosenValue: 'Value',
      beliefs: 'Beliefs that hold it up',
      sharedBy: 'People who share it',
      plan: 'Their plan',
      planWeek: 'This week',
      planMonth: 'This month',
      planYear: 'This year',
      enteredInSession: 'Entered in session',
      details: 'Scores and plan',
      inspired: 'Inspired by: {{kind}}{{who}}',
      history: {
        title: 'Over time',
        empty: 'Only one rating so far — there is no trend yet.',
        way: 'Way',
        date: 'Date',
        basis: 'Basis',
        entered: 'Entered',
        basisLived: 'lived',
        basisImagined: 'imagined',
      },
      session: {
        title: 'Work on it with the client',
        intro:
          'Describe, rate and choose together in session. What you enter is part of the practice’s record and does not count as the client’s homework.',
        describe: 'Describe a way',
        describeFirst: 'Describe a way first.',
        rateFirst: 'Rate a way first.',
        describeRequired: 'Give the way a name, and for another way write at least one thing they would do.',
        rateRequired: 'Score all eight needs from 1 to 10.',
        chooseRequired: 'Choose a rated way and name the value it stands for.',
        inspiredRef: 'Who or what',
        lastRating: 'Last: {{mean}} · {{basis}} · {{date}}',
        lastScore: 'last {{n}}',
        name: 'Name',
        kind: 'Which way',
        behaviors: 'What they do or would do (one per line)',
        save: 'Save',
        cancel: 'Cancel',
        saved: 'Saved.',
        error: 'This could not be saved. Check the details and try again.',
        rate: 'Rate a way',
        way: 'Way',
        basis: 'Basis',
        rateSave: 'Save the rating',
        choose: 'Choose a way',
        value: 'The value it stands for',
        beliefs: 'Beliefs that hold it up (one per line)',
        sharedBy: 'People who share it (one per line)',
        chooseSave: 'Save the choice',
      },
    },
  },
  values: {
    screens: {
      profile: 'My values',
      sortIntro: 'Card sort',
      sort: 'Sorting',
      sortResult: 'My top values',
      wheelSetup: 'Values wheel',
      wheelRate: 'Rate my wheel',
      wheel: 'Values wheel',
      obstacle: 'An obstacle',
      commit: 'Commit to an action',
      vlq: 'Questionnaire',
      vlqResult: 'Questionnaire result',
      activities: 'Activities',
    },
    entry: {
      title: 'Values',
      body: 'What matters to you, and how you are living it.',
      bodyFilled: 'Your top values, and what you do in their name.',
    },
    profile: {
      intro:
        'The values you ranked, with what you have done in their name. The tools you use can link back to them.',
      empty:
        'Start with the card sort to find the values that matter most to you. The wheel and the questionnaire show how you are living them.',
      doors: {
        sort: 'Card sort',
        sortBody: 'Sort values cards — about 4 minutes for the quick set.',
        wheel: 'Values wheel',
        wheelBody: 'Where you are now and where you want to be, area by area.',
        vlq: 'Questionnaire',
        vlqBody: 'Ten life areas: how important, and how you lived them this week.',
        windRose: 'Wind rose',
        windRoseBody: 'Rate a way of living on eight needs, compare it with another and choose.',
      },
      rose: {
        line: 'Your chosen way: {{name}} · mean {{mean}} (capped at 8)',
      },
      lastSort: 'Last sorted {{date}}',
      rank: 'No. {{rank}}',
      unranked: 'Other',
      // E36 placement (main + also): the largest gap among a value's areas, naming the area
      wheelLargest: 'Largest gap on the wheel · {{sector}}: now {{current}}, wanted {{ideal}} (gap {{gap}})',
      wheelNone: 'Wheel · {{sector}}: not rated yet',
      vlqLargest: 'Largest gap in the questionnaire · {{area}}: important {{importance}}, lived {{consistency}} (gap {{gap}})',
      nothingYet: 'Nothing here yet — plan an activity for this value.',
      actionsHeading: 'What I committed to',
      activitiesHeading: 'Activities',
      activitiesCount_one: '{{count}} activity',
      activitiesCount_other: '{{count}} activities',
      linksCount: 'Linked: {{count}}',
      actionOpen: 'to do',
      actionDone: 'done',
      plan: 'Plan an activity',
      loadError: 'We could not load your values. Check your connection and try again.',
      retry: 'Try again',
    },
    sort: {
      intro: {
        title: 'Find what matters to you',
        body:
          'You will see one card at a time. Decide how important that value is to you — very important, important or not important — then put your very important ones in order.',
        quick: 'Quick set · 30 cards · about 4 minutes',
        full: 'Full set · 83 cards · about 10 minutes',
        citation: 'The cards are the Personal Values Card Sort ({{citation}}), in the public domain.',
        start: 'Start sorting',
        starting: 'Starting…',
        resume: 'Continue the sort I started',
        loadError: 'We could not load the cards. Check your connection and try again.',
        startError: 'We could not start the sort. Please try again.',
      },
      sorting: {
        progress: 'Card {{n}} of {{total}}',
        prompt: 'How important is this to you?',
        veryImportant: 'Very important',
        important: 'Important',
        notImportant: 'Not important',
        swipeHint: 'Swipe right: very important · up: important · left: not important',
        undo: 'Back one card',
        rankTitle: 'Put your very important values in order',
        rankBody: 'The first one matters most to you. Up to 10 are kept in your order.',
        up: 'Move up',
        down: 'Move down',
        // E36 drag to rank
        dragHandle: 'Drag to reorder {{name}}',
        dragHint: 'Press and hold, then drag. Or use Move up and Move down.',
        needMore: 'You need at least 3 very important values. Add some from “Important”:',
        promote: 'Add',
        done: 'Done',
        saving: 'Saving…',
        saveError: 'We could not save your sort. Please try again.',
        loadError: 'We could not load this sort. Go back and start it again.',
      },
      result: {
        body: 'These are the values you ranked first. They are on your profile now.',
        piles: '{{very}} very important · {{important}} important · {{not}} not important',
        toWheel: 'Put them on the wheel',
        toActivities: 'Plan an activity',
        toProfile: 'My profile',
        loadError: 'We could not load this result. Open your profile to see your values.',
      },
    },
    wheel: {
      setup: {
        title: 'Set up your wheel',
        body:
          'A wheel has an area for each part of life you want to look at. You rate each one twice: where you are now, and where you want to be. Pick a set of areas — you can name your own.',
        create: 'Create my wheel',
        creating: 'Creating…',
        customHint: 'Name between 2 and 12 areas.',
        customName: 'Area name',
        addArea: 'Add an area',
        removeArea: 'Remove',
        error: 'We could not create the wheel. Please try again.',
        presets: {
          lava5: 'Five areas (the default)',
          bullsEye4: 'Four areas (bull’s eye)',
          wheelOfLife8: 'Eight areas (wheel of life)',
          custom: 'My own areas',
        },
      },
      preset: {
        bullsEye4: {
          workEducation: 'Work and education',
          leisure: 'Leisure',
          relationships: 'Relationships',
          personalGrowthHealth: 'Personal growth and health',
        },
        lava5: {
          relationships: 'Relationships',
          educationCareer: 'Education and career',
          recreation: 'Recreation and interests',
          mindBodySpirit: 'Mind, body and spirit',
          dailyResponsibilities: 'Daily responsibilities',
        },
        wheelOfLife8: {
          career: 'Career',
          finances: 'Finances',
          health: 'Health',
          family: 'Family and friends',
          romance: 'Romance',
          growth: 'Personal growth',
          recreation: 'Fun and recreation',
          environment: 'Home and surroundings',
        },
      },
      rate: {
        body:
          'For each area, write what matters to you there in a line. Then mark where you are now and where you want to be: 0 is far off, 10 is living completely in keeping with it.',
        statement: 'What matters to me here',
        now: 'Where I am now',
        ideal: 'Where I want to be',
        save: 'Save my rating',
        saving: 'Saving…',
        error: 'We could not save your rating. Please try again.',
        notComplete: 'Mark both places for every area to save.',
      },
      view: {
        title: 'Your wheel',
        empty: 'You have no wheel yet. Set one up to see where you are and where you want to be.',
        setUp: 'Set up my wheel',
        notRated: 'Not rated yet',
        nowIdeal: 'Now {{current}} · wanted {{ideal}}',
        gap: 'Gap {{gap}}',
        before: 'Before: {{current}} → {{ideal}}',
        rateAgain: 'Rate again',
        rateFirst: 'Rate my wheel',
        addObstacle: 'Add an obstacle',
        obstacle: '{{obstacle}} (stops me: {{severity}} of 7)',
        commit: 'Commit to an action',
        actionOpen: 'to do',
        actionDone: 'done',
        ratedAt: 'Last rated {{date}}',
        ratedWithTherapist: 'Rated with {{name}} in session on {{date}}',
        ratedWithTherapistNoName: 'Rated with your therapist in session on {{date}}',
        earlier: '{{count}} earlier ratings',
        loadError: 'We could not load your wheel. Check your connection and try again.',
      },
      obstacle: {
        title: 'An obstacle in “{{sector}}”',
        body: 'What stands between where you are and where you want to be?',
        text: 'The obstacle',
        severity: 'How much does it stop me? 1 is not at all, 7 is completely.',
        save: 'Save',
        saving: 'Saving…',
        error: 'We could not save the obstacle. Please try again.',
      },
    },
    commit: {
      body: 'One concrete thing, and when. It goes on your to-do list.',
      forValue: 'For: {{label}}',
      what: 'What I will do',
      when: 'When',
      save: 'Add to my to-do list',
      saving: 'Saving…',
      done: 'Added to your to-do list',
      doneBody: 'You will find it under Homework, and you can mark it done there.',
      openHomework: 'Open my homework',
      back: 'Back',
      error: 'We could not save this. Please try again.',
      calendar: {
        add: 'Add to calendar',
        hint: 'This puts a copy in your own calendar. If you change it here later, the calendar does not change.',
        failed: 'We could not open your calendar. Please add it by hand.',
        eventTitle: '{{title}} — CopingCard',
        eventNotes: 'Open in CopingCard: {{link}}',
      },
    },
    vlq: {
      title: 'Valued living questionnaire',
      body:
        'Ten areas of life. For each, rate how important it is to you and how consistently you lived by it this past week — 1 is the lowest, 10 the highest.',
      important: 'How important is this to me?',
      lived: 'How consistently did I live it this past week?',
      submit: 'See my result',
      submitting: 'Saving…',
      notComplete: 'Rate both questions for all ten areas to continue.',
      error: 'We could not save your answers. Please try again.',
      areas: {
        family: 'Family (other than marriage or parenting)',
        marriage: 'Marriage, couples and intimate relations',
        parenting: 'Parenting',
        friends: 'Friends and social life',
        work: 'Work',
        education: 'Education and training',
        recreation: 'Recreation and fun',
        spirituality: 'Spirituality',
        citizenship: 'Citizenship and community',
        selfCare: 'Physical self-care',
      },
      result: {
        title: 'Your result',
        composite: 'Your score: {{composite}} of 100',
        compositeBody:
          'It multiplies how important each area is by how consistently you lived it. A higher score means you are living closer to what matters to you.',
        change: 'Since last time: {{change}}',
        first: 'This is your first questionnaire. Take it again later to see what changes.',
        gapHeading: 'Areas with the biggest gap first',
        line: 'Important {{importance}} · lived {{consistency}} · gap {{gap}}',
        plan: 'Plan an activity',
        loadError: 'We could not load this result. Check your connection and try again.',
      },
    },
    activities: {
      title: 'Activities for “{{value}}”',
      body: 'Small, specific things you can do in the name of this value, from the easiest to the hardest.',
      empty: 'No activities yet. Add one below, or ask for ideas.',
      difficulty: 'Difficulty {{n}}',
      status: { idea: 'idea', committed: 'committed', done: 'done' },
      doThisWeek: 'Do this week',
      add: {
        heading: 'Add an activity',
        title: 'The activity',
        difficulty: 'How hard is it? 1 is easiest, 10 is hardest.',
        save: 'Add',
        saving: 'Adding…',
        error: 'We could not add this. Please try again.',
      },
      suggest: {
        heading: 'Ideas',
        body: 'Describe the value in your own words and get a list of ideas, easiest first. You choose which to keep.',
        text: 'What I would like to do',
        button: 'Suggest ideas',
        asking: 'Thinking…',
        adopt: 'Keep',
        none: 'No new ideas right now.',
        refused: {
          RATE_LIMITED: 'The idea service is busy right now. Please try again in a few minutes.',
          CONTENT_FILTERED: 'We could not make ideas from that. Try describing it a little differently.',
          ERROR: 'We could not get ideas right now. Please try again.',
        },
        error: 'We could not ask for ideas. Please try again.',
      },
      loadError: 'We could not load your activities. Check your connection and try again.',
    },
    link: {
      chip: 'Linked to a value',
      none: 'Not linked to a value',
      add: 'Link to a value',
      hintSort: 'Sort the cards first to have values to link to.',
      remove: 'Remove link',
      error: 'We could not change the link. Please try again.',
    },
    hub: {
      tab: 'Values',
      title: 'Values',
      purpose:
        'What matters to the client: their ranked values, the wheel and the wind rose — their own answers, nothing scored for them.',
      empty: 'No values work yet. The client sorts the value cards and sets up the wheel on their phone.',
      emptyAssign: 'Assign the card sort',
      loadError: 'We could not load this client’s values. Refresh the page to try again.',
      profile: {
        title: 'Values profile',
        colValue: 'Value',
        colWheel: 'On the wheel',
        colVlq: 'Questionnaire',
        colSteps: 'Steps',
        wheelCell: '{{sector}}: {{current}} → {{ideal}} (gap {{gap}})',
        vlqCell: '{{area}}: important {{importance}}, lived {{consistency}} (gap {{gap}})',
        roseCell: 'Wind rose: {{name}} · mean {{mean}}',
        empty:
          'No values yet. The client sorts the cards on their phone; their ranked values appear here.',
        lastSort: 'Last sorted {{date}}',
        composite: 'Questionnaire score: {{composite}} of 100',
        actionOpen: 'to do',
        actionDone: 'done',
        activitiesCount_one: '{{count}} activity',
        activitiesCount_other: '{{count}} activities',
        linksCount: 'Linked records: {{count}}',
      },
      wheel: {
        title: 'Values wheel',
        empty:
          'The client has not set up a wheel yet. They create it on their phone first; then you can rate it with them here.',
        sector: 'Area',
        statement: 'What matters here',
        now: 'Now',
        ideal: 'Wanted',
        gap: 'Gap (wanted − now)',
        steps: 'Steps and obstacles',
        ratedAt: 'Last rated {{date}}',
        ratedInSession: 'Rated in session by {{name}} on {{date}}',
        ratedInSessionNoName: 'Rated in session on {{date}}',
        notRated: 'Not rated yet',
        obstacle: '{{obstacle}} (stops them: {{severity}} of 7)',
        rate: {
          open: 'Rate the wheel with the client',
          title: 'Rate the wheel with {{name}}',
          intro:
            'Rate it together: what matters to them in each area, where they are now and where they want to be (0 to 10). It starts from their last rating. This is your record of the session; it does not complete a wheel they were asked to do.',
          statement: 'What matters here',
          now: 'Now (0–10)',
          ideal: 'Wanted (0–10)',
          save: 'Save rating',
          cancel: 'Cancel',
          saved: 'Rating saved. It shows on their wheel as rated in session.',
          error: 'Could not save the rating. Check the marks and try again.',
          notComplete: 'Give both marks for every area to save.',
        },
      },
      assign: {
        exercises: {
          valuesSort: 'Values card sort',
          valuesWheel: 'Values wheel',
          valuedLivingQuestionnaire: 'Valued Living Questionnaire',
          windRose: 'Wind rose',
        },
        defaultTitle: {
          valuesSort: 'Do the values card sort',
          valuesWheel: 'Rate your values wheel',
          valuedLivingQuestionnaire: 'Fill in the valued living questionnaire',
          windRose: 'Describe the way you live now and rate it on the eight needs',
        },
      },
    },
    errors: {
      DECK_TOO_SMALL: 'A card deck needs at least 10 cards. Add more cards and publish again.',
      DECK_PRESET_UNKNOWN_CARD:
        'A preset names a card that is not in the deck. Remove it from the preset or add the card, then publish again.',
      DECK_TRANSLATION_MISSING:
        'Every card needs a line in each language of the deck. Fill in the missing lines, then publish again.',
      DECK_UNKNOWN:
        'This card sort is not available right now. Go back and start it again; if it keeps happening, update the app.',
      SORT_NOT_OPEN: 'This sort is already finished or could not be found. Go back and start a new one.',
      SORT_RANK_NOT_IN_PILE:
        'Only cards you put in “Very important” can be ranked. Go back and rank one of those cards instead.',
      SORT_RANK_COUNT: 'Rank between 3 and 10 of your very important cards, then save.',
      SORT_CARD_UNSORTED: 'Some cards are not sorted yet. Go back, put every card in a pile, then save.',
      WHEEL_SECTOR_COUNT: 'A wheel needs between 2 and 12 areas. Add or remove areas and try again.',
      WHEEL_SECTOR_DUPLICATE: 'Two areas have the same name. Give each area its own name and try again.',
      WHEEL_SECTOR_UNRATED: 'Every area needs both marks. Rate the areas you skipped, then save.',
      WHEEL_MARK_RANGE: 'Marks run from 0 to 10. Change the mark that is outside that range, then save.',
      WHEEL_UNKNOWN: 'This wheel could not be found. Go back and open your wheel again, or create a new one.',
      WHEEL_SECTOR_UNKNOWN: 'This area is not on your wheel. Go back and choose one of the areas shown.',
      WHEEL_SEVERITY_RANGE:
        'Rate the obstacle from 1 (does not stop me at all) to 7 (stops me completely), then save.',
      VALUES_ACTION_EMPTY: 'Write down what you will do, then save.',
      VLQ_INCOMPLETE: 'Rate all ten areas from 1 to 10 for both questions, then submit.',
      VALUES_ACTIVITY_EMPTY: 'Write the activity (or the value you want ideas for), then try again.',
      VALUES_DIFFICULTY_RANGE: 'Difficulty runs from 1 (easiest) to 10 (hardest). Choose a number in that range.',
      VALUES_SUGGEST_COUNT: 'Ask for between 5 and 30 ideas at a time.',
      VALUES_LINK_EXISTS: 'This is already linked to that value.',
      VALUES_LINK_FOCUS_TYPE: 'This kind of record cannot be linked to a value yet.',
      VALUES_LINK_UNKNOWN: 'This link is already gone. Refresh the screen to see the current list.',
      ROSE_NAME_EMPTY: 'Give this way of living a name, then save.',
      ROSE_BEHAVIOR_REQUIRED:
        'Another way needs at least one concrete thing you would do. Write one, then save.',
      ROSE_STRATEGY_UNKNOWN:
        'This way of living could not be found. Go back to your wind rose and open it again.',
      ROSE_NEED_MISSING: 'Rate all eight needs from 1 to 10, then save.',
      ROSE_SCORE_RANGE: 'Scores run from 1 to 10. Change the score that is outside that range, then save.',
      ROSE_NOT_RATED: 'Rate this way on the eight needs first, then choose it.',
      ROSE_STRATEGY_NOT_CHOSEN: 'Choose this way first, then write its plan.',
      ROSE_PLAN_EMPTY: 'Write at least one step in your plan, then save.',
      HOMEWORK_NOT_YOUR_CLIENT:
        'This client is not connected with you at your practice — they are not your client here, or they have switched off sharing with you. Check the client list, or ask the client to turn sharing with you back on in the app.',
      conflictRetry: 'This changed at the same moment. Please try again.',
    },
    deck: {
      miller: {
        acceptance: 'ACCEPTANCE — to be accepted as I am',
        accuracy: 'ACCURACY — to be accurate in my opinions and beliefs',
        achievement: 'ACHIEVEMENT — to have important accomplishments',
        adventure: 'ADVENTURE — to have new and exciting experiences',
        attractiveness: 'ATTRACTIVENESS — to be physically attractive',
        authority: 'AUTHORITY — to be in charge of and responsible for others',
        autonomy: 'AUTONOMY — to be self-determined and independent',
        beauty: 'BEAUTY — to appreciate beauty around me',
        caring: 'CARING — to take care of others',
        challenge: 'CHALLENGE — to take on difficult tasks and problems',
        change: 'CHANGE — to have a life full of change and variety',
        comfort: 'COMFORT — to have a pleasant and comfortable life',
        commitment: 'COMMITMENT — to make enduring, meaningful commitments',
        compassion: 'COMPASSION — to feel and act on concern for others',
        contribution: 'CONTRIBUTION — to make a lasting contribution in the world',
        cooperation: 'COOPERATION — to work collaboratively with others',
        courtesy: 'COURTESY — to be considerate and polite toward others',
        creativity: 'CREATIVITY — to have new and original ideas',
        dependability: 'DEPENDABILITY — to be reliable and trustworthy',
        duty: 'DUTY — to carry out my duties and obligations',
        ecology: 'ECOLOGY — to live in harmony with the environment',
        excitement: 'EXCITEMENT — to have a life full of thrills and stimulation',
        faithfulness: 'FAITHFULNESS — to be loyal and true in relationships',
        fame: 'FAME — to be known and recognized',
        family: 'FAMILY — to have a happy, loving family',
        fitness: 'FITNESS — to be physically fit and strong',
        flexibility: 'FLEXIBILITY — to adjust to new circumstances easily',
        forgiveness: 'FORGIVENESS — to be forgiving of others',
        friendship: 'FRIENDSHIP — to have close, supportive friends',
        fun: 'FUN — to play and have fun',
        generosity: 'GENEROSITY — to give what I have to others',
        genuineness: 'GENUINENESS — to act in a manner that is true to who I am',
        godsWill: 'GOD’S WILL — to seek and obey the will of God',
        growth: 'GROWTH — to keep changing and growing',
        health: 'HEALTH — to be physically well and healthy',
        helpfulness: 'HELPFULNESS — to be helpful to others',
        honesty: 'HONESTY — to be honest and truthful',
        hope: 'HOPE — to maintain a positive and optimistic outlook',
        humility: 'HUMILITY — to be modest and unassuming',
        humor: 'HUMOR — to see the humorous side of myself and the world',
        independence: 'INDEPENDENCE — to be free from dependence on others',
        industry: 'INDUSTRY — to work hard and well at my life tasks',
        innerPeace: 'INNER PEACE — to experience personal peace',
        intimacy: 'INTIMACY — to share my innermost experiences with others',
        justice: 'JUSTICE — to promote fair and equal treatment for all',
        knowledge: 'KNOWLEDGE — to learn and contribute valuable knowledge',
        leisure: 'LEISURE — to take time to relax and enjoy',
        loved: 'LOVED — to be loved by those close to me',
        loving: 'LOVING — to give love to others',
        mastery: 'MASTERY — to be competent in my everyday activities',
        mindfulness: 'MINDFULNESS — to live conscious and mindful of the present moment',
        moderation: 'MODERATION — to avoid excesses and find a middle ground',
        monogamy: 'MONOGAMY — to have one close, loving relationship',
        nonConformity: 'NON-CONFORMITY — to question and challenge authority and norms',
        nurturance: 'NURTURANCE — to take care of and nurture others',
        openness: 'OPENNESS — to be open to new experiences, ideas, and options',
        order: 'ORDER — to have a life that is well-ordered and organized',
        passion: 'PASSION — to have deep feelings about ideas, activities, or people',
        pleasure: 'PLEASURE — to feel good',
        popularity: 'POPULARITY — to be well-liked by many people',
        power: 'POWER — to have control over others',
        purpose: 'PURPOSE — to have meaning and direction in my life',
        rationality: 'RATIONALITY — to be guided by reason and logic',
        realism: 'REALISM — to see and act realistically and practically',
        responsibility: 'RESPONSIBILITY — to make and carry out responsible decisions',
        risk: 'RISK — to take risks and chances',
        romance: 'ROMANCE — to have intense, exciting love in my life',
        safety: 'SAFETY — to be safe and secure',
        selfAcceptance: 'SELF-ACCEPTANCE — to accept myself as I am',
        selfControl: 'SELF-CONTROL — to be disciplined in my own actions',
        selfEsteem: 'SELF-ESTEEM — to feel good about myself',
        selfKnowledge: 'SELF-KNOWLEDGE — to have a deep and honest understanding of myself',
        service: 'SERVICE — to be of service to others',
        sexuality: 'SEXUALITY — to have an active and satisfying sex life',
        simplicity: 'SIMPLICITY — to live life simply, with minimal needs',
        solitude: 'SOLITUDE — to have time and space where I can be apart from others',
        spirituality: 'SPIRITUALITY — to grow and mature spiritually',
        stability: 'STABILITY — to have a life that stays fairly consistent',
        tolerance: 'TOLERANCE — to accept and respect those who differ from me',
        tradition: 'TRADITION — to follow respected patterns of the past',
        virtue: 'VIRTUE — to live a morally pure and excellent life',
        wealth: 'WEALTH — to have plenty of money',
        worldPeace: 'WORLD PEACE — to work to promote peace in the world',
      },
    },
  },
  // E45 · Sleep diary (cc-health, context Sleep; the app + the API's notices + the client hub). Numbers, not verdicts: nothing here
  // labels a night, scores it or advises on it (the FDA line: automated sleep restriction is device territory — the therapist sets
  // the window). `sleep.errors.<CODE>` are the deciders' refusals.
  sleep: {
    errors: {
      SLEEP_TIMES_ORDER:
        'The times do not follow each other. Check that you got into bed first, then turned the lights off, woke up, and got out of bed last.',
      SLEEP_NIGHT_FUTURE: 'That night is not over yet. Come back in the morning to fill it in.',
      SLEEP_NIGHT_TOO_OLD:
        'A night can only be added for up to three days back — a diary filled in days later is memory, not a diary. Your therapist can add an older night from your paper diary.',
      SLEEP_NIGHT_KIND_INVALID:
        'This night is missing some of its times. Fill in every time, or choose “I did not sleep at all” or “I was not in my usual bed”.',
      SLEEP_DURATIONS_EXCEED:
        'Falling asleep and being awake in the night together are longer than the time between the lights going out and your final waking. Check those two numbers.',
      SLEEP_WINDOW_TOO_SHORT:
        'A sleep window cannot be shorter than 5 hours (6 hours for the BBTI protocol). Move the bedtime earlier or the rise time later.',
      SLEEP_WINDOW_ORDER:
        'The rise time must come after the bedtime across the night. Check both times — for example 23:30 and 06:00.',
      SLEEP_WINDOW_NOT_YOUR_CLIENT:
        'This client is not in your care, so you cannot change their sleep diary or window. Refresh the client list and try again.',
      SLEEP_WINDOW_NONE: 'This client has no sleep window to end. Refresh the page to see the current state.',
      conflictRetry: 'Your sleep diary changed at the same moment. Please try again.',
      loadFailed: 'Could not load your sleep diary. Pull down to try again.',
      saveFailed: 'Could not save this night. Check your connection and try again.',
    },
    units: {
      hoursMinutes: '{{hours}} h {{minutes}} min',
      minutes: '{{count}} min',
      percent: '{{count}}%',
    },
    entry: {
      title: 'Sleep diary',
      body: 'Last night in two minutes, and how your weeks are going.',
    },
    screens: {
      morning: 'Sleep diary',
      diary: 'Last night',
      week: 'My weeks',
      window: 'My sleep window',
    },
    morning: {
      title: 'Good morning',
      subtitle: 'Add how last night felt. It takes about two minutes.',
      fromWatch: 'From your watch',
      watchLine: 'In bed {{from}}–{{to}} · asleep about {{duration}}',
      emptyNight: 'Not filled in yet',
      fill: 'Fill in',
      caughtUp: 'You are all caught up. Last night is in your diary.',
      olderNote: 'You can add a night for up to three days back.',
      weeks: 'My weeks',
      window: 'My sleep window',
    },
    prompt: {
      title: 'Morning prompt',
      body: 'One reminder each morning to fill in last night while it is fresh.',
      on: 'On — every morning at {{time}}',
      off: 'Off',
      turnOn: 'Turn on',
      turnOff: 'Turn off',
      notificationTitle: 'Last night’s sleep',
      notificationBody: 'Add how you slept. It takes about two minutes.',
    },
    diary: {
      title: 'Last night',
      forNight: 'The night of {{date}}',
      watchNote: 'The times from your watch are filled in. Change any that are not right.',
      timeHint: 'Times as hours and minutes on a 24-hour clock, for example 23:10.',
      bedTime: 'I got into bed at',
      lightsOut: 'I turned the lights off at',
      sleepOnset: 'It took me about this many minutes to fall asleep',
      awakenings: 'I woke up this many times in the night',
      wakeMinutes: 'In all, I was awake in the night for this many minutes',
      finalWake: 'I woke up for good at',
      outOfBed: 'I got out of bed at',
      quality: 'How well did I sleep?',
      qualityOption: {
        1: 'Very poor',
        2: 'Poor',
        3: 'Fair',
        4: 'Good',
        5: 'Very good',
      },
      watchBeside: 'Your watch measured about {{duration}} asleep',
      optional: 'If you like',
      napStart: 'A nap, started at',
      napMinutes: 'Nap length, minutes',
      caffeine: 'Coffee, tea or cola after noon',
      alcohol: 'Alcoholic drinks',
      sleepAid: 'A sleep aid I took',
      note: 'Anything else about the night',
      noSleep: 'I did not sleep at all',
      noSleepHint: 'Only when you got into bed and when you got out of bed are needed. This night counts with no sleep.',
      skip: 'Not in my usual bed — skip this night',
      skipHint: 'This night is left out of your weekly numbers.',
      kindTitle: 'How do you want to record this night?',
      kindFull: 'The whole night',
      save: 'Save',
      saving: 'Saving…',
      timeInvalid: 'Enter the time as hours and minutes, for example 23:10.',
      numberInvalid: 'Enter a whole number.',
      qualityRequired: 'Choose how well you slept.',
      timesRequired: 'Fill in every time, or choose another way to record this night at the top.',
      error: 'Could not save this night. Check your connection and try again.',
    },
    week: {
      title: 'My weeks',
      weekOf: 'Week of {{date}}',
      earlier: 'Earlier week',
      later: 'Later week',
      averages: 'Average of the week',
      nights: '{{count}} nights filled in',
      noNights: 'No nights in this week yet.',
      inBed: 'In bed',
      asleep: 'Asleep',
      efficiency: 'Efficiency',
      efficiencyHelp: 'asleep time ÷ time in bed; your therapist uses it with you',
      fellAsleep: 'Fell asleep in',
      awakeInNight: 'Awake in the night',
      quality: 'Quality',
      watch: 'Your watch: {{duration}}',
      skipped: 'skipped',
      noSleep: 'no sleep',
      fromPaper: 'entered by your therapist from a paper diary',
      windowLine: 'Your window: {{bedtime}} – {{riseTime}}, from {{date}}',
      weeksBefore: 'The weeks before',
    },
    window: {
      title: 'My sleep window',
      body: 'Go to bed no earlier than {{bedtime}} and get up at {{riseTime}} every day.',
      from: 'From {{date}}',
      upcoming: 'Starts on {{date}}',
      setWith: 'Set with {{name}}',
      note: 'From your therapist',
      none: 'Your therapist sets a sleep window with you when the time is right.',
      remindMe: 'Remind me',
      remind: {
        title: 'Window reminders',
        body: 'Two reminders tied to your window: one to wind down before bedtime and one to get up.',
        on: 'On — wind down at {{windDown}}, get up at {{getUp}}',
        off: 'Off',
        turnOn: 'Turn on',
        turnOff: 'Turn off',
        windDownTitle: 'Time to wind down',
        windDownBody: 'Your bedtime is in an hour.',
        getUpTitle: 'Time to get up',
        getUpBody: 'It is your rise time.',
        moved: 'Your window changed. Turn the reminders on again to move them.',
      },
    },
    hub: {
      tab: 'Sleep diary',
      title: 'Sleep diary',
      intro: 'The nights as your client reported them, with the watch’s figure beside when they share sleep with you.',
      weekOf: 'Week of {{date}}',
      earlier: 'Earlier week',
      later: 'Later week',
      loadFailed: 'Could not load the sleep diary. Refresh to try again.',
      notShared: 'The client does not share this with you.',
      noNights: 'No nights in this week yet.',
      weeklyAverages: 'Weekly averages',
      // N-4/N-9 (2026-10-22): the Nights card, the Sleep window card, the empty line
      nights: { title: 'Nights' },
      empty: 'No nights in the diary yet. Assign the diary and {{name}} fills in a night each morning.',
      emptyAssign: 'Assign the diary',
      emptyPaper: 'Enter a night from a paper diary',
      nightsFilled: '{{count}} nights',
      inBed: 'In bed',
      asleep: 'Asleep',
      efficiency: 'Efficiency',
      fellAsleep: 'Fell asleep in',
      awakeInNight: 'Awake in the night',
      quality: 'Quality',
      reported: 'Reported',
      watch: 'Watch',
      watchNotShared: 'not shared',
      skipped: 'skipped',
      noSleep: 'no sleep',
      fromPaper: 'paper diary · {{name}}',
      windowEnded: 'ended {{date}}',
      noWindow: 'No window is set.',
      usualRule: {
        forYou: 'For you, not the client:',
        cbti: 'Efficiency {{efficiency}}% over {{nights}} nights → the usual rule: {{action}}. You decide.',
        bbti: 'Falling asleep {{fellAsleep}} min, awake in the night {{awake}} min over {{nights}} nights → the usual rule: {{action}}. You decide.',
        moreInBed: '15 minutes more in bed',
        keep: 'keep the window',
        lessInBed: '15 minutes less in bed',
        atFloor: 'the window is at its floor already — keep it',
        none: 'There are no filled nights in the last week to base the rule on.',
      },
      window: {
        card: 'Sleep window',
        current: '{{bedtime}} – {{riseTime}} · from {{date}} · {{protocol}}',
        upcoming: 'starts later',
        setBy: 'set by {{name}}',
        setFirst: 'Set a window',
        setNew: 'Set a new window',
        replaces: 'Replaces {{window}}',
        earlier: 'Earlier windows ({{count}})',
        last: 'Last window:',
        timesRequired: 'Enter the bedtime and the rise time as 24-hour times, for example 23:30.',
        dateRequired: 'Choose the date the window starts on.',
        title: 'Set the sleep window',
        screening:
          'Before sleep restriction, check what applies to this client: bipolar disorder, seizures, parasomnias, sleep apnea, driving for work.',
        bedtime: 'Bedtime (24-hour, for example 23:30)',
        riseTime: 'Rise time (24-hour, for example 06:00)',
        effectiveFrom: 'Starts on',
        protocol: 'Protocol',
        cbti: 'CBT-I — adjust by efficiency (at least 5 hours)',
        bbti: 'BBTI — adjust by time to fall asleep and awake in the night (at least 6 hours)',
        basis: 'Based on: {{nights}} nights · asleep {{asleep}} · efficiency {{efficiency}}%',
        fewNights: 'Fewer than five diary nights in the last seven. A paper diary may be the basis.',
        note: 'A line for the client',
        set: 'Set window',
        saved: 'The sleep window is set.',
        error: 'Could not set the window. Check the times and try again.',
        end: {
          title: 'End the window',
          body: 'The client’s screen goes back to “no window”.',
          reason: 'Reason (optional)',
          action: 'End window',
          done: 'The window ended.',
          error: 'Could not end the window. Refresh the page and try again.',
        },
      },
      // the Assign button is the shared one (components/ToolSection); these two are its preset's defaults
      assign: {
        defaultTitle: 'Keep the sleep diary for two weeks',
        defaultInstructions: 'Every morning, before you check your phone for anything else.',
      },
    },
  },
  // E45 · the client hub's "Enter a night" — the therapist types in a night from the client's paper diary
  sleepDiary: {
    enter: {
      title: 'Enter a night',
      body: 'From the client’s paper diary, in session or after it — up to fourteen days back. On the client’s phone it shows as entered by you.',
      night: 'The night of (date)',
      bedTime: 'Into bed (24-hour, for example 23:10)',
      lightsOut: 'Lights out',
      sleepOnset: 'Minutes to fall asleep',
      awakenings: 'Awakenings',
      wakeMinutes: 'Minutes awake in the night',
      finalWake: 'Final awakening',
      outOfBed: 'Out of bed',
      quality: 'Quality (1 very poor – 5 very good)',
      note: 'A note from the diary',
      kind: 'This night',
      kindSlept: 'A full night',
      kindNoSleep: 'Did not sleep at all',
      kindSkipped: 'Not in the usual bed / skipped',
      save: 'Save night',
      saved: 'The night is in the diary.',
      error: 'Could not save the night. Check the times and the date and try again.',
      open: 'Enter a night',
      timesRequired: 'Fill in every time for a full night, as 24-hour times (for example 23:10).',
      noSleepRequired: 'Fill in into bed and out of bed as 24-hour times.',
      minutesRequired: 'Write the minutes as a whole number.',
      qualityRequired: 'Choose the quality, 1 to 5.',
      nightRequired: 'Choose the night, up to fourteen days back.',
    },
  },
  // E41 — Behavioral activation (the app + the API's notices)
  ba: {
    entry: {
      title: 'Behavioral Activation',
      body: 'Notice what you do, plan the next small step, and see how it felt.',
    },
    screens: {
      home: 'Behavioral Activation',
      log: 'Log an hour',
      choose: 'Choose activities',
      rank: 'My ladder order',
      ladder: 'My ladder',
      plan: 'Plan an activity',
      agenda: 'My plan',
      done: 'Done',
      missed: 'It did not happen',
      support: 'Ask for support',
      week: 'This week',
    },
    areas: {
      relationships: 'Relationships',
      educationCareer: 'Education and work',
      recreation: 'Recreation and interests',
      mindBodySpirit: 'Mind, body and spirit',
      dailyResponsibilities: 'Daily responsibilities',
    },
    barrier: {
      noTime: 'No time',
      tooHard: 'Too hard',
      lowMood: 'Low mood',
      forgot: 'Forgot',
      otherPeople: 'Other people',
      other: 'Something else',
    },
    home: {
      body: 'Write down what you did hour by hour, with how much you enjoyed it and how important it felt. Patterns show up quickly, and they are what we plan from.',
      today: 'Today',
      prevDay: 'Earlier',
      nextDay: 'Later',
      empty: 'Nothing is logged for this day yet. Tap an hour below, or log one now.',
      ratings: 'Enjoyment {{enjoyment}} · Importance {{importance}}',
      fromPlan: 'planned activity',
      gaps: 'Not logged yet',
      mood: 'Mood from your check-in: {{mood}} of 5',
      log: 'Log an hour',
      removeHint: 'Long-press to remove this entry',
      doors: 'Next steps',
      doorChoose: 'Choose activities',
      doorLadder: 'My ladder',
      doorPlan: 'My plan',
      doorWeek: 'This week',
    },
    suggest: {
      heading: 'From your health data',
      body: 'Walks and workouts your phone recorded that are not in your log yet. Nothing is logged until you do it.',
      line: '{{minutes}}-minute {{kind}} at {{start}} — log it?',
      title: '{{kind}} ({{minutes}} min)',
      log: 'Log it',
      dismiss: 'Dismiss',
      kind: {
        walking: 'walk',
        running: 'run',
        cycling: 'bike ride',
        swimming: 'swim',
        yoga: 'yoga session',
        strength: 'strength workout',
        hiking: 'hike',
        dance: 'dance',
        other: 'workout',
      },
    },
    remove: {
      body: 'Remove this entry? You can log the hour again afterwards.',
      confirm: 'Remove',
      cancel: 'Keep it',
      error: 'The entry could not be removed. Refresh the day and try again.',
    },
    prompts: {
      title: 'Reminders to log',
      body: 'Three quiet nudges a day: "What have you been doing since…?" Change the times whenever you like.',
      on: '{{n}} reminders are on.',
      off: 'No reminders yet.',
      turnOn: 'Remind me three times a day',
      turnOff: 'Turn the reminders off',
      notificationTitle: 'What have you been doing?',
      notificationBody: 'Take a minute to log the last hours.',
    },
    log: {
      body: 'What have you been doing, and how was it? There are no right answers.',
      when: 'When',
      earlier: 'An hour earlier',
      later: 'An hour later',
      longer: 'Make it longer',
      shorter: 'Make it shorter',
      what: 'What did you do?',
      whatPlaceholder: 'For example: walked to the shop',
      enjoyment: 'Enjoyment',
      enjoymentHint: 'How much did you enjoy it? 0 is not at all, 10 is the most.',
      importance: 'Importance',
      importanceHint: 'How important was it to you? 0 is not at all, 10 is the most.',
      faces: 'Use faces',
      numbers: 'Use numbers',
      face: {
        0: 'None',
        2: 'A little',
        5: 'Some',
        8: 'Quite a lot',
        10: 'The most',
      },
      save: 'Save',
      saving: 'Saving…',
      saveNext: 'Save and log the hour before',
      error: 'The hour could not be saved. Check your connection and try again.',
    },
    choose: {
      body: 'Collect activities that could make your days fuller. Start from what already helps, then look at ideas for what matters to you.',
      use: 'Use this',
      rank: 'Put my activities in order',
      week: {
        heading: 'From your week',
        body: 'Hours you enjoyed or that mattered, from the last two weeks.',
        empty: 'Log a few hours first; the ones you enjoyed will show up here.',
      },
      ideas: {
        heading: 'Ideas for your values',
        body: 'Ideas for the things that matter to you come first. How hard each one is, is only a guess.',
        empty: 'No ideas are published yet. Add your own below.',
        difficulty: 'about {{n}} of 10 in difficulty',
        forValue: 'for {{value}}',
        more: 'Show more ideas',
        fewer: 'Show fewer ideas',
      },
      mine: {
        heading: 'My activities',
        empty: 'You have no activities yet. Use one of the ideas above, or add your own.',
        add: 'Add my own',
        ai: 'suggested for you',
      },
    },
    adopt: {
      heading: 'Make it one of my activities',
      what: 'In your own words',
      value: 'What it is for',
      otherValue: 'Or write another value',
      difficulty: 'How hard does it feel? 1 is easiest, 10 is hardest.',
      suggestAi: 'Suggest more with AI',
      save: 'Add to my activities',
      saving: 'Adding…',
      cancel: 'Cancel',
      error: 'The activity could not be added. Check your connection and try again.',
    },
    rank: {
      title: 'Put them in order',
      body: 'Tick up to fifteen activities and put them in order, the easiest at the top. Start easy and work toward the harder ones.',
      count: '{{n}} of {{max}} chosen',
      order: 'Your order',
      orderHint: 'Easiest first. Use the arrows to move one.',
      up: 'Move up',
      down: 'Move down',
      save: 'Save my ladder',
      saving: 'Saving…',
      error: 'The ladder could not be saved. Check your connection and try again.',
    },
    ladder: {
      body: 'Your activities, from the hardest at the top to the easiest at the bottom. Begin at the bottom.',
      empty: 'No ladder yet. Choose some activities and put them in order.',
      plan: 'Plan it',
      support: 'Ask for support',
      rerank: 'Change my ladder',
    },
    plan: {
      againTitle: 'Plan it again',
      body: 'Pick the day and the time. One to three of the easiest steps a day is plenty.',
      againBarrier: 'Last time: {{barrier}}. That is useful to know — you can make it smaller, or move it to another time.',
      what: 'What will you do?',
      whatPlaceholder: 'For example: a twenty-minute walk',
      day: 'Day',
      today: 'Today',
      tomorrow: 'Tomorrow',
      time: 'Time',
      duration: 'How long',
      minutes: '{{n}} min',
      predict: 'How do you expect it to be?',
      certainty: 'How sure are you that you will do it?',
      certaintyHint: 'Optional. 1 is not sure at all, 10 is certain.',
      certaintyLow: 'Below {{n}} it may help to shrink the step or bring someone in. Totally optional.',
      smaller: 'Make the step smaller',
      help: 'Ask someone to help',
      save: 'Plan it',
      saving: 'Planning…',
      saved: 'Planned',
      savedBody: 'It is on your Homework list, and you will get a nudge at the time.',
      free: {
        heading: 'Find a free time',
        body: 'CopingCard looks at when your calendar is free, on your phone only. Nothing from your calendar is sent anywhere or saved.',
        ask: 'Suggest free times',
        checking: 'Looking at your calendar…',
        slot: '{{day}} at {{time}}',
        pick: 'Tap one to use it, or choose a time yourself below.',
        none: 'No free hour found in the next seven days. Choose a time yourself below.',
        denied: 'Calendar access is off, so there are no suggestions. To get them, allow calendar access for CopingCard in your phone’s settings. You can always choose a time yourself.',
        unavailable: 'This phone cannot suggest free times. Choose a time yourself below.',
        error: 'The calendar could not be read just now. Choose a time yourself below.',
      },
      toAgenda: 'See my plan',
      error: 'The plan could not be saved. Check your connection and try again.',
      calendar: {
        add: 'Add to calendar',
        hint: 'Your calendar gets a copy. If you change the plan later, change the calendar too.',
        failed: 'The calendar could not be opened. You can add it by hand.',
        eventTitle: '{{title}}',
        eventNotes: 'Planned in CopingCard. {{link}}',
      },
    },
    agenda: {
      prev: 'Earlier',
      next: 'Later',
      weekOf: 'Week of {{date}}',
      counts: '{{planned}} planned · {{done}} done this week',
      empty: 'Nothing is planned this week yet.',
      plan: 'Plan an activity',
      done: 'Done',
      missed: 'It did not happen',
      again: 'Plan it again',
      rated: 'Enjoyment {{enjoyment}} · Importance {{importance}}',
      status: {
        planned: 'Planned',
        done: 'Done',
        missed: 'Did not happen',
        replanned: 'Planned again',
      },
    },
    done: {
      title: 'How was it?',
      body: 'Rate it now that it happened. Did it feel as you expected?',
      predicted: 'You expected Enjoyment {{enjoyment}} · Importance {{importance}}',
      note: 'Anything you noticed (optional)',
      save: 'Save',
      saving: 'Saving…',
      saved: 'Saved. It is ticked off your Homework list.',
      better: 'Saved. It was better than you expected.',
      close: 'Back',
      notHappened: 'It did not happen',
      error: 'It could not be saved. Check your connection and try again.',
    },
    missed: {
      body: 'That is useful to know, not a failure. What got in the way?',
      barrier: 'What got in the way',
      note: 'Anything else (optional)',
      save: 'Save',
      saving: 'Saving…',
      saved: 'Saved. You can plan it again, smaller or at another time.',
      error: 'It could not be saved. Check your connection and try again.',
    },
    support: {
      body: 'Up to three people, and exactly how each could help. Then you decide when to ask them.',
      privacy: 'CopingCard sends nothing to these people. Message and Call open your own messages and phone.',
      name: 'Name',
      how: 'How could they help?',
      pick: 'Choose from contacts',
      pickDenied: 'The phone did not allow access to contacts. You can type the name instead.',
      message: 'Message {{name}}',
      call: 'Call {{name}}',
      draft: 'Hi {{name}}, could you help me with this: {{what}}? {{how}}',
      add: 'Add another person',
      save: 'Save',
      saving: 'Saving…',
      saved: 'Saved',
      error: 'The contract could not be saved. Check your connection and try again.',
    },
    week: {
      plans: 'Plans',
      planned: 'Planned: {{n}}',
      done: 'Done: {{n}}',
      missed: 'Did not happen: {{n}}',
      barrier: 'Most often in the way: {{barrier}}',
      predicted: 'Expected and actual',
      predictedHint: 'For the plans you carried out. Often it is better than expected.',
      enjoyment: 'Enjoyment: expected {{predicted}}, actual {{actual}}',
      importance: 'Importance: expected {{predicted}}, actual {{actual}}',
      areas: 'Hours by life area',
      hours: '{{n}} h',
      emptyAreas: 'No hours yet in: {{areas}}',
      mood: 'Mood and activities',
      noMood: 'no check-in',
      activitiesDone: '{{n}} done',
      health: 'From your phone',
      healthLine: 'Active on {{days}} days · {{minutes}} active minutes · {{walks}} walks',
      planNext: 'Plan next week',
    },
    homework: {
      planned: 'This is a planned activity. Rate it when it happened, or say what got in the way.',
    },
    errors: {
      LIBRARY_TOO_SMALL: 'The library needs at least 20 ideas before it can be published.',
      LIBRARY_TRANSLATION_MISSING: 'Every idea needs its English and its Russian line. Add the missing one and publish again.',
      LIBRARY_DIFFICULTY_RANGE: 'Each idea needs a difficulty from 1 (easiest) to 10 (hardest).',
      LIBRARY_AREA_UNKNOWN: 'Each idea belongs to one of the five life areas. Pick one from the list.',
      BA_RATING_RANGE: 'Ratings run from 0 to 10, and how sure you are from 1 to 10. Pick a number in that range.',
      BA_TIME_RANGE: 'The end of the hour has to be after its start. Adjust the times and try again.',
      BA_LOG_IN_FUTURE: 'That hour has not happened yet. Log hours that have already passed.',
      BA_LOG_EMPTY: 'Write a few words about what you did in that hour.',
      BA_LOG_UNKNOWN: 'That entry is already gone. Refresh the day to see the current list.',
      BA_RANKING_TOO_LONG: 'A ladder holds up to 15 activities. Untick a few and save again.',
      BA_RANKING_EMPTY: 'Tick at least one activity to put on your ladder.',
      BA_RANK_DUPLICATE: 'Each activity goes on the ladder once, in its own place. Check the order and save again.',
      BA_ACTIVITY_UNKNOWN: 'That activity is not on your list any more. Choose one from My activities.',
      BA_PLAN_IN_PAST: 'That time has already passed. Pick a time later than now.',
      BA_REPLAN_NOT_MISSED: 'Only a plan marked as not happened can be planned again.',
      BA_PLAN_EMPTY: 'Write a few words about what you plan to do.',
      BA_PLAN_UNKNOWN: 'That plan is gone. Open My plan to see the current list.',
      BA_PLAN_CLOSED: 'That plan is already marked done or not happened. You can plan it again from My plan.',
      BA_PLAN_NOT_YET: 'This plan is for a later day. Come back to it on the day.',
      BA_BARRIER_UNKNOWN: 'Pick one of the reasons from the list.',
      BA_CONTRACT_EMPTY: 'Add at least one person and how they could help.',
      BA_CONTRACT_TOO_MANY: 'A contract holds up to three people. Remove one and save again.',
      HOMEWORK_NOT_YOUR_CLIENT:
        'This client is not connected with you at your practice — they are not your client here, or they have switched off sharing with you. Check the client list, or ask the client to turn sharing with you back on in the app.',
      conflictRetry: 'This changed at the same moment. Please try again.',
    },
    hub: {
      tab: 'Behavioral Activation',
      title: 'Behavioral activation',
      purpose:
        'The client’s week: what was planned and done, expected beside actual enjoyment and importance, mood beside the activities. Numbers only.',
      loadError: 'The activation data could not be loaded. Refresh the page; if it keeps failing, check that the client still shares with you.',
      ratings: 'Enjoyment {{enjoyment}} · Importance {{importance}}',
      week: {
        title: 'This week',
        counts: 'Planned {{planned}} · done {{done}} · did not happen {{missed}}',
        nothing: 'Nothing logged this week.',
        noAreas: 'No hours with a named activity yet this week.',
        day: 'Day',
        activities: 'Activities done',
        phone: 'Phone: active minutes',
      },
      plans: {
        title: 'Plans',
        empty: 'Nothing is planned this week.',
        when: 'When',
        what: 'What',
        expected: 'Expected',
        actual: 'Actual',
        status: 'Status',
        inSession: 'planned together',
      },
      grid: {
        title: 'Monitoring grid',
        empty: 'No hours logged this week.',
        area: 'Life area',
      },
      ladder: {
        title: 'Ladder',
        empty: 'The client has not ranked activities yet.',
      },
      plan: {
        title: 'Plan an activity with the client',
        open: 'Plan an activity',
        required: 'Fill in what, the day and time, and the two expected ratings (0 to 10).',
        ladder: 'From the ladder',
        durationLabel: 'How long, in minutes (5–240)',
        intro: 'Plan the next small step together. It lands on the client\'s phone and Homework list.',
        when: 'Day and time',
        expectedEnjoyment: 'Expected enjoyment (0–10)',
        expectedImportance: 'Expected importance (0–10)',
        submit: 'Plan it',
        saved: 'Planned. It is on the client\'s phone and Homework list.',
        error: 'The plan could not be saved. Check the details and try again.',
      },
      assign: {
        defaultTitle: {
          activityMonitoring: 'Log your days',
          activityRanking: 'Choose and rank your activities',
          activityPlanning: 'Plan your first activity',
          supportContract: 'Ask someone to help with a hard step',
        },
      },
    },
    library: {
      // The activity library behind "Ideas for your values": ~150 ideas in our own words (DRAFT — the founder reviews). The words only —
      // area, difficulty and the values each idea serves are in @cc/domain `behavioralActivation/libraryIdeas.ts`.
      ideas: {
        'idea-0001': 'Send a friend a short message just to say hello',
        'idea-0002': 'Tell someone close to you one thing you appreciate about them',
        'idea-0003': 'Look through old photos with someone from your family',
        'idea-0004': 'Call a friend for ten minutes',
        'idea-0005': 'Phone a relative you have not spoken to for a while',
        'idea-0006': 'Write a short thank-you note to someone who helped you',
        'idea-0007': 'Sit down with your partner for a cup of tea, phones away',
        'idea-0008': 'Ask someone how their day went and listen to the whole answer',
        'idea-0009': 'Reply to a message you have been putting off',
        'idea-0010': 'Invite a friend for a walk',
        'idea-0011': 'Cook a simple meal for someone you care about',
        'idea-0012': 'Offer to help a neighbor with something small',
        'idea-0013': 'Play a game with a child or a younger relative',
        'idea-0014': 'Have a coffee with a colleague outside of work talk',
        'idea-0015': 'Plan a small evening for the two of you at home',
        'idea-0016': 'Write down what you would like to say to someone, then decide whether to send it',
        'idea-0017': 'Meet a friend for a meal at a place neither of you has tried',
        'idea-0018': 'Visit a family member for an afternoon',
        'idea-0019': 'Tell one person you trust how you have really been feeling',
        'idea-0020': 'Spend an hour helping a friend with a task they are stuck on',
        'idea-0021': 'Get in touch with someone you lost contact with',
        'idea-0022': 'Organize a small get-together for family or friends',
        'idea-0023': 'Raise one thing that has been on your mind with your partner or a close friend',
        'idea-0024': 'Join a group where people share an interest and go to one meeting',
        'idea-0025': 'Reach out to someone after a disagreement and make the first step',
        'idea-0026': 'Say yes to an invitation you would normally decline',
        'idea-0027': 'Start a conversation with someone new at a class, a club or a queue',
        'idea-0028': 'Spend a whole day doing something together with your family',
        'idea-0029': 'Ask for the support you need from someone close, in plain words',
        'idea-0030': 'Host an evening for several friends at your place',
        'idea-0031': 'Read one page of something you have never read before',
        'idea-0032': 'Write down three things you want to learn',
        'idea-0033': 'Tidy your work or study area for ten minutes',
        'idea-0034': 'Watch a short talk or lesson on a subject that interests you',
        'idea-0035': 'Open the task you have been avoiding and work on it for five minutes',
        'idea-0036': 'Make a short list of what you want to finish this week',
        'idea-0037': 'Practice a skill for fifteen minutes',
        'idea-0038': 'Listen to a podcast about your field or a new subject',
        'idea-0039': 'Answer one email you have been putting off',
        'idea-0040': 'Look up a course or a class you might enjoy',
        'idea-0041': 'Plan tomorrow\'s three most important tasks the evening before',
        'idea-0042': 'Work through one exercise or problem from a book or course',
        'idea-0043': 'Ask a colleague or classmate a question you have been holding back',
        'idea-0044': 'Write a page about an idea you want to explore',
        'idea-0045': 'Visit a library, a museum or a lecture that relates to your interests',
        'idea-0046': 'Finish a small piece of work you started and left',
        'idea-0047': 'Update your CV or your profile with something you are proud of',
        'idea-0048': 'Spend an hour on a project that matters to you, with notifications off',
        'idea-0049': 'Offer to help a colleague or a classmate with their task',
        'idea-0050': 'Sign up for a class, a workshop or an online course',
        'idea-0051': 'Set one concrete goal for the next month and write the first step',
        'idea-0052': 'Ask someone you respect for their advice about your work or studies',
        'idea-0053': 'Start the part of a project you are most unsure about',
        'idea-0054': 'Share an idea at a meeting or in a group',
        'idea-0055': 'Apply for something that feels a little out of reach',
        'idea-0056': 'Block out a morning for focused work and protect it',
        'idea-0057': 'Teach someone a skill you have',
        'idea-0058': 'Book a conversation with a mentor or a person who does work you admire',
        'idea-0059': 'Take the first real step toward a change in your work or studies',
        'idea-0060': 'Complete a project you have wanted to finish for a long time',
        'idea-0061': 'Play one song you used to love',
        'idea-0062': 'Step outside and look at the sky for two minutes',
        'idea-0063': 'Watch a funny clip on purpose and enjoy it',
        'idea-0064': 'Make a drink you like and drink it slowly',
        'idea-0065': 'Doodle or sketch for five minutes with no goal',
        'idea-0066': 'Listen to an album from start to finish',
        'idea-0067': 'Sit in a park or on a bench and watch people go by',
        'idea-0068': 'Pick up an instrument and play for ten minutes',
        'idea-0069': 'Read a chapter of a book you chose for pleasure',
        'idea-0070': 'Take a long shower or a bath and enjoy it',
        'idea-0071': 'Dance in your room to a few songs',
        'idea-0072': 'Take a walk in a place you do not usually go',
        'idea-0073': 'Cook something new from a recipe you have been curious about',
        'idea-0074': 'Watch a film you have been meaning to see',
        'idea-0075': 'Take photographs of things you find beautiful on a walk',
        'idea-0076': 'Play a game you enjoy, alone or with someone',
        'idea-0077': 'Do a puzzle, a crossword or a jigsaw',
        'idea-0078': 'Work on a hobby project for half an hour',
        'idea-0079': 'Spend an afternoon at a market, a gallery or a neighborhood you have not explored',
        'idea-0080': 'Go to a cafe with a book or a notebook and stay a while',
        'idea-0081': 'Try a sport or a game you used to like',
        'idea-0082': 'Rearrange one corner of your room to make it more pleasant',
        'idea-0083': 'Go to a concert, a film screening or a show',
        'idea-0084': 'Spend a morning outdoors: a park, a hill, a lake',
        'idea-0085': 'Start a small creative project, like a drawing, a story or a piece of woodwork',
        'idea-0086': 'Play a sport or a board game with other people',
        'idea-0087': 'Take a day trip to a place you have never been',
        'idea-0088': 'Go to a class in something creative: pottery, painting, dance, music',
        'idea-0089': 'Plan a longer walk or a bike ride for the weekend',
        'idea-0090': 'Plan a short trip, even for a night',
        'idea-0091': 'Do something you have always wanted to try, and book it',
        'idea-0092': 'Take five slow breaths, counting out for longer than in',
        'idea-0093': 'Drink a glass of water and stretch your arms and back',
        'idea-0094': 'Notice five things you can see, hear or feel right now',
        'idea-0095': 'Open a window and breathe fresh air for a few minutes',
        'idea-0096': 'Write down one thing you did today that was good enough',
        'idea-0097': 'Go for a ten-minute walk',
        'idea-0098': 'Try a short guided meditation or body scan',
        'idea-0099': 'Go to bed at your planned time tonight',
        'idea-0100': 'Sit quietly with a candle or a cup of tea and just be',
        'idea-0101': 'Write three small things that went well today',
        'idea-0102': 'Do a few gentle stretches',
        'idea-0103': 'Do a short workout at home, as easy as you like',
        'idea-0104': 'Prepare a meal with something new in it',
        'idea-0105': 'Read a few pages of something that gives you meaning or comfort',
        'idea-0106': 'Spend ten minutes writing about how you are, without judging it',
        'idea-0107': 'Eat one meal slowly and without a screen',
        'idea-0108': 'Spend some time on something that is only for you',
        'idea-0109': 'Go for a thirty-minute walk, run or ride',
        'idea-0110': 'Visit a place that is meaningful to you: a church, a park, a quiet spot',
        'idea-0111': 'Book a check-up or an appointment you have been delaying',
        'idea-0112': 'Practice a mindfulness exercise for fifteen minutes',
        'idea-0113': 'Try a yoga, tai chi or stretching video',
        'idea-0114': 'Join a class or a group for exercise',
        'idea-0115': 'Take part in a ceremony, service or gathering that matters to you',
        'idea-0116': 'Write a letter to yourself about what you want from the next few months',
        'idea-0117': 'Plan a week of meals and shop for them',
        'idea-0118': 'Set an exercise goal for this week and do the first session',
        'idea-0119': 'Spend an hour doing something that reflects who you are, not what others expect',
        'idea-0120': 'Take a full evening to unwind with no screens',
        'idea-0121': 'Spend a half day in quiet reflection or retreat',
        'idea-0122': 'Sign up for a longer walk, a run or an event and begin to prepare',
        'idea-0123': 'Make your bed',
        'idea-0124': 'Put away five things that are out of place',
        'idea-0125': 'Wash a single cup or plate',
        'idea-0126': 'Open your mail and put it in one pile',
        'idea-0127': 'Throw away the rubbish from one room',
        'idea-0128': 'Do a load of laundry',
        'idea-0129': 'Write down the bills or tasks that are due this week',
        'idea-0130': 'Clean the kitchen surface and the sink',
        'idea-0131': 'Take out the rubbish and the recycling',
        'idea-0132': 'Plan what you will eat tomorrow',
        'idea-0133': 'Check your calendar and write down the week\'s appointments',
        'idea-0134': 'Do the dishes after a meal, straight away',
        'idea-0135': 'Pay one bill or answer one letter you have been avoiding',
        'idea-0136': 'Vacuum or sweep one room',
        'idea-0137': 'Go to the shop for groceries with a short list',
        'idea-0138': 'Sort through one drawer or shelf',
        'idea-0139': 'Make a phone call you have been postponing',
        'idea-0140': 'Check your accounts and write down what you spent this week',
        'idea-0141': 'Spend half an hour on a household task you have been putting off',
        'idea-0142': 'Change the bedding',
        'idea-0143': 'Cook and freeze a meal for a busy day',
        'idea-0144': 'Sort out a form, an appointment or a document that is waiting',
        'idea-0145': 'Take things you no longer use to a donation point or a recycling place',
        'idea-0146': 'Clean the bathroom',
        'idea-0147': 'Make a simple budget for the month',
        'idea-0148': 'Clear out one cupboard or wardrobe',
        'idea-0149': 'Deal with an official letter or an administrative task',
        'idea-0150': 'Do a full tidy of your living space, room by room, with breaks',
        'idea-0151': 'Go to an appointment you have been avoiding',
        'idea-0152': 'Start the larger task that has been hanging over you, for one hour',
      },
    },
  },

  // ── E48 · Functional analysis (cc-tools-3; remodelled on the founder's G1 answers 2026-10-17, awaiting his G1) — a behaviour to understand,
  // each instance recorded as a chain, what I noticed, one planned change and a one-tap "did I do it today"; the hub's formulation.
  // Clinical-adjacent copy: EN here, RU generated (docs/marketing/tools/gen-ru-gemini.mjs) for the founder's review. THE SIX G1 ASSUMPTIONS
  // that touch wording live in ONE place each: the four function lines `fa.noticed.escape|attention|reward|relief` (assumption 5), the three
  // intro cards `fa.intro.cards.*` and the hints `fa.record.hint.*` (assumption 6). Nothing here advises or diagnoses: the app shows the
  // person's own words and counts, the function hypothesis is the therapist's, never computed.
  fa: {
    errors: {
      FA_TARGET_NAME_REQUIRED:
        'Write a few words for the behavior you want to understand, then save.',
      FA_TARGET_TOO_MANY:
        'Three behaviors at a time is the most. Close one you are done with, then add the new one.',
      FA_NOT_YOUR_CLIENT:
        'This client is not connected with you at your practice — they are not your client here, or they have switched off sharing with you. Check the client list, or ask the client to turn sharing with you back on in the app.',
      FA_TARGET_UNKNOWN:
        'This behavior could not be found — it may already be closed. Go back to the list and refresh it.',
      FA_INSTANCE_TIME:
        'A record or a tap can be for today or for up to 7 days ago, and for a planned change not before it starts. Choose a day in that range.',
      FA_URGE_RANGE:
        'The urge is rated from 0 to 10. Slide it to a number in that range and save again.',
      FA_NOT_YOUR_TARGET:
        'This behavior was set with your therapist, so it can only be changed or closed in session. You can still record it and plan a change.',
      FA_CHANGE_UNKNOWN:
        'This planned change could not be found — its behavior may be closed. Go back to the list and refresh it.',
      FA_VALUE_INVALID:
        'Something in this form could not be saved. Check the highlighted answers and try again.',
    },
    screens: {
      my: 'Functional analysis',
      record: 'Record',
      noticed: 'What I noticed',
      intro: 'How it works',
    },
    tile: {
      title: 'Functional analysis',
      description:
        'Pick a behavior, record what leads to it and what follows, and see what repeats.',
    },
    // the choices, shared by the phone and the hub
    measure: {
      frequency: 'frequency (how many times)',
      duration: 'duration (minutes)',
      intensity: 'intensity (0–10)',
    },
    function: {
      escapeAvoidance: 'Escape or avoidance',
      attention: 'Attention',
      tangible: 'A tangible gain',
      automaticRelief: 'Automatic relief',
      unknown: 'Not sure yet',
    },
    functionLine: {
      escapeAvoidance: 'it gets me out of, or away from, something hard or scary',
      attention: 'it brings other people closer: they notice, check in or help',
      tangible: 'it gets me something I want: a break, a treat, a thing',
      automaticRelief: 'it calms a feeling or a body sensation right away',
      unknown: 'I am not sure what it does for me yet',
    },
    // Q-e48f-1 A (2026-10-24): the function choice is multi-select — the line under the checkboxes, on the phone and the hub
    functionHint: 'Choose one or more — or “Not sure yet” on its own.',
    vulnerability: {
      sleep: 'Slept badly',
      tired: 'Tired / worn out',
      hunger: 'Hungry / skipped a meal',
      illness: 'Ill',
      pain: 'In pain',
      substances: 'Alcohol or drugs',
      hardDay: 'A hard day',
      other: 'Other…',
    },
    link: {
      event: 'What happened',
      thought: 'What I thought',
      feeling: 'What I felt',
      body: 'What I noticed in my body',
      action: 'What I did',
    },
    tool: {
      thoughtTest: 'Thought test',
      copingCard: 'Coping card',
      exposure: 'Exposure',
      plannedActivity: 'Planned activity',
      crisisKit: 'Crisis kit',
      meditation: 'Meditation',
      abcModel: 'ABC model',
      worksheet: 'Worksheet',
    },
    done: { yes: 'Yes', partly: 'Partly', no: 'No' },
    // the phone: “Functional analysis”
    my: {
      title: 'Functional analysis',
      add: '+ Add a behavior',
      empty: {
        line1:
          'Pick one thing you do that you would like to understand, such as skipping a lecture or scrolling in bed.',
        line2:
          'Record it when it happens, or when you only feel the urge. A few records show a pattern.',
      },
      record: 'Record',
      thisWeek: 'This week',
      thisWeekNothing: 'This week: nothing yet',
      times_one: '{{count}} time',
      times_other: '{{count}} times',
      urgesOnly_one: '{{count}} urge only',
      urgesOnly_other: '{{count}} urges only',
      recordsSoFar:
        "{{n}} of {{max}} records — a few more and I'll show you what I noticed",
      recordsCount_one: '{{count}} record so far',
      recordsCount_other: '{{count}} records so far',
      noticedLink: 'What I noticed',
      fromDiaryCard: 'from the diary card',
      addedBy: 'Set with my therapist',
      trying: 'Trying from {{date}}: {{what}}',
      tryingLater: 'Planned from {{date}}: {{what}}',
      doneOn: 'done on {{done}} of {{marked}} days',
      changeToday: 'I did the planned change today',
      plan: 'Plan a change',
      done: 'Stop tracking this behavior',
    },
    // “Functional analysis — How it works” (assumption 6: three cards)
    intro: {
      link: 'New here? See how it works (3 cards)',
      title: 'How it works',
      progress: '{{n}} of 3',
      next: 'Next',
      close: 'Got it',
      article: 'Read more: what a behavior does for you',
      cards: {
        record: {
          title: 'A record',
          body: 'When it happens, or when you only feel the urge, write what led up to it, what came next, and what it did for you. It takes a minute.',
        },
        rightAwayLater: {
          title: 'Right away and later',
          body: '“Right away” is what it did for you in the first minutes. “Later” is what it cost afterwards. Both can be true at once.',
        },
        afterAFew: {
          title: 'After a few records',
          body: 'After about five records you will see what you noticed, and you can pick one small thing to try differently.',
        },
      },
    },
    // “Add a behaviour to look at” (the client, on her own)
    own: {
      title: 'Add a behavior to look at',
      body: 'Something you do that you would like to understand. Your therapist sees it on your page.',
      name: 'What do you want to understand?',
      namePlaceholder: 'For example: scrolling in bed past midnight',
      description: 'What counts as one',
      descriptionPlaceholder: 'For example: phone in bed after 23:30',
      measure: 'Measure',
      function: 'What it does for me',
      add: 'Add',
      saved: 'Added to Functional analysis.',
    },
    // “Record: what happened” (assumption 6: the hints)
    record: {
      title: 'What happened',
      when: 'When',
      whenNow: 'Just now',
      whenEarlier: 'Earlier',
      before: {
        title: 'Before · what made me vulnerable',
        from: 'From before:',
        otherPlaceholder: 'In a few words',
      },
      trigger: {
        title: 'What set it off',
        placeholder: 'What happened just before?',
      },
      then: 'Then',
      linkPlaceholder: 'A few words',
      addLink: 'Add',
      didIt: 'I did it',
      onlyUrge: 'Only the urge',
      urge: 'Urge',
      amount: {
        frequency: 'How many times',
        duration: 'How many minutes',
        intensity: 'How strong (0–10)',
      },
      rightAway: { title: 'Right away' },
      later: { title: 'Later' },
      nextTime: { title: 'Next time I could change' },
      hint: {
        rightAway: 'What did it do for you in the first minutes?',
        later: 'And later, hours or days after. What did it cost?',
        nextTime: 'Which step could go differently, and what could help?',
      },
      tool: 'A tool that could help',
      offered: 'You chose this {{n}} times',
      anotherTool: 'Another tool…',
      noTool: 'No tool',
      openTool: 'Open',
      save: 'Save',
      saved: 'Saved.',
      queued: 'Saved on this phone — it will be sent when you are online.',
      failed:
        'This record could not be saved. Check what you wrote and try again.',
    },
    // “What I noticed” (assumption 5: the four plain lines)
    noticed: {
      title: 'What I noticed',
      records_one: '{{name}} · {{count}} record',
      records_other: '{{name}} · {{count}} records',
      notYet:
        '{{n}} of {{max}} records so far — a few more and the picture is clearer.',
      setOff: 'What set it off most often',
      thoughtFeltDid: 'What I thought, felt and did',
      thought: 'thought',
      feeling: 'felt',
      body: 'in my body',
      action: 'did',
      event: 'happened',
      rightAway: 'Right away',
      later: 'Later',
      ideas: 'My ideas for next time',
      times: '×{{n}}',
      why: 'Why a behavior can keep going — common possibilities',
      escape: 'Escape. It gets us out of something hard or scary. The relief is real, so it can repeat.',
      attention: 'Attention. It brings people closer: they notice, check in or help.',
      reward: 'Reward. It gets us something we want: a break, a treat, a good feeling.',
      relief: 'Relief. It calms a feeling or a body sensation right away.',
      plan: 'Plan a change',
    },
    // the sheets on the phone
    change: {
      own: {
        title: 'Plan a change',
        whatChanges: 'What I will try',
        fromIdeas: 'From your ideas: you wrote this {{n}} times. Change it if you like.',
        expected: 'What I expect',
        from: 'From',
        plan: 'Plan',
        saved: 'Planned. You can tap yes, partly or no each day.',
      },
      // the hub's Plan a change
      title: 'Plan a change',
      intro:
        'Change one thing — what comes before or after the behavior — from a date, and say what you expect. The summary then splits the records before and after it.',
      whatChanges: 'What changes',
      expected: 'What we expect',
      from: 'From',
      plan: 'Plan',
      saved: 'The change is planned.',
      fewRecords:
        'Fewer than {{max}} records so far ({{n}}). A change is easier to read after about {{max}} — you can plan it now.',
      prefill:
        "The client's most-marked idea ({{n}} times). Change it if you both prefer something else.",
      context: 'What comes before and after it',
      ideas: "The client's ideas",
      required: 'Write what changes and choose the date it starts.',
    },
    changeDay: {
      title: 'Today',
      trying: 'Trying from {{date}}',
      did: 'I did the planned change today',
      progress: '{{day}} · done on {{done}} of {{marked}} days so far',
      saved: 'Noted.',
    },
    retire: {
      own: {
        title: 'Stop tracking this behavior',
        why: 'Why am I stopping?',
        note: 'Your records stay. The behavior leaves your list.',
        done: 'Stop tracking',
        saved: 'It left your list. Your records stay.',
      },
      title: 'Retire',
      intro: 'Stop tracking this behavior when the work is done. Its records stay.',
      reason: 'Why',
      retire: 'Retire',
      saved: 'The behavior is retired. Its records stay.',
    },
    // the hub (portal): the order of work — set, assign, read, change, close
    hub: {
      title: 'Functional analysis',
      purpose:
        'What a behavior seems to do for the client, from their own records — a hypothesis to test, not a finding.',
      recordsTitle: 'Records',
      measureLine: 'Measure: {{measure}} · Baseline: {{weeks}}',
      baselineWeeks_one: '{{count}} week',
      baselineWeeks_other: '{{count}} weeks',
      planOpen: 'Plan a change',
      retireOpen: 'Retire',
      empty:
        'No behavior is set yet. Set one with the client: its name in their words, what counts as one, how to measure it, and what it seems to do for them.',
      pick: 'Behavior',
      closed: 'Closed',
      byClient: 'Added by the client',
      byClientChange: 'planned by the client',
      records: 'Records so far',
      recordsLine: '{{chains}} chains · {{urges}} urges only',
      function: 'Function (hypothesis)',
      functionNote: 'What it seems to do for the client — a hypothesis to test, not a finding.',
      set: {
        title: 'Target behavior',
        add: 'Set a behavior',
        edit: 'Edit',
      },
      before: 'Before the change',
      after: 'After (from {{date}})',
      perWeek: '{{n}} a week',
      meanUrge: 'urge {{n}}',
      did: 'did it',
      urgeOnly: 'urge only',
      weeks: 'By week',
      weekOf: 'Week of {{date}}',
      changeDays: 'change done on {{done}} of {{marked}} days (yes {{yes}} · partly {{partly}})',
      noChangeDays: 'no day marked yet',
      recurs: 'What recurs',
      count: 'Count',
      vulnerabilities: 'Before',
      promptingEvents: 'What set it off',
      rightAway: 'Right away',
      later: 'Later',
      nextTime: 'Next time I could change',
      link: {
        event: 'What happened',
        thought: 'What I thought',
        feeling: 'What I felt',
        body: 'What I noticed in my body',
        action: 'What I did',
      },
      suggestion: 'Suggestion for the next change',
      suggestionLine:
        "The client's most-marked idea: {{instead}} ({{times}} times)",
      noSuggestion: 'No idea marked yet.',
      fromDiaryCard: 'from the diary card',
      changes: 'Planned changes',
      sections: {
        set: 'Set',
        assign: 'Assign the records',
        formulation: 'Formulation',
        plan: 'Plan a change',
        retire: 'Retire',
      },
    },
    target: {
      title: 'Target behavior',
      intro:
        'Set the behavior to understand with the client: its name in their words, what counts as one, how to measure it, and the function you both think it serves. A week of records comes before any change.',
      nameRequired: "Name the behavior in the client's words.",
      name: "Behavior, in the client's words",
      description: 'What counts as one',
      measure: 'Measure',
      baseline: 'Baseline (weeks of records before a change)',
      function: 'What it seems to do for them (function)',
      save: 'Save',
      saved: 'The behavior is saved.',
    },
    assign: {
      title: 'Assign the records',
      intro:
        'Ask for a record each time it happens — also when only the urge comes. A baseline of records comes before any change.',
      assignTitle: 'Title',
      refRequired: 'Choose the behavior to record.',
      needsBehavior: 'Set a behavior first.',
      closed: 'This behavior is closed.',
      defaultTitle: 'Record each time it happens — or nearly happens: {{name}}',
      instructions: 'Instructions',
      defaultInstructions: 'Also when you only felt the urge.',
      weeks: 'Weeks',
      assign: 'Assign',
      saved: 'The records are assigned.',
    },
  },
  // ── E49 · Motivation (cc-tools-3 — the phone: "Motivation — My change: rulers, pros and cons, plan"; the hub: "Motivation — Before the
  // session"). The person's own numbers and words, reflected back: no advice, no verdict (MI's evocation). Errors per the decider codes.
  mi: {
    errors: {
      MI_GOAL_LABEL_REQUIRED: 'Write a few words for the change you are thinking about, then save.',
      MI_GOAL_TOO_MANY:
        'Three open changes at a time is the most. Close one you are done with, or decided against, then add the new one.',
      MI_NOT_YOUR_CLIENT:
        'This client is not connected with you at your practice, or they have switched off sharing with you. Check the client list, or ask the client to turn sharing with you back on in the app.',
      MI_RULER_RANGE: 'Each ruler goes from 0 to 10. Choose a number in that range and save again.',
      MI_GOAL_UNKNOWN: 'This change could not be found. Go back to Motivational interviewing and open it again.',
      MI_GOAL_CLOSED: 'This change is closed. Reopen it first, then add to it.',
      MI_GOAL_OPEN: 'This change is already open.',
      MI_BALANCE_EMPTY: 'Write at least one thing in any of the four boxes, then save.',
      MI_PLAN_CHANGE_REQUIRED: 'Write what you will change, then save the plan.',
      MI_TALK_EMPTY: 'Write a few words about what you noticed, then save.',
      MI_VALUE_INVALID: 'Something in this form could not be saved. Check your answers and try again.',
    },
    // the Tools entry
    tile: {
      title: 'Motivational interviewing',
      description: 'A change you are thinking about: how important it is, the pros and cons, and a plan when you are ready.',
    },
    screens: {
      list: 'Motivational interviewing',
      set: "A change I'm thinking about",
      change: 'My change',
      rulers: 'The rulers',
      balance: 'Pros and cons',
      plan: 'My change plan',
      talk: 'Change talk',
    },
    ruler: {
      importance: 'Importance',
      confidence: 'Confidence',
      readiness: 'Readiness',
    },
    status: {
      open: 'Open',
      closed: 'Closed',
    },
    outcome: {
      done: 'Done',
      decidedNotTo: 'Decided not to',
      other: 'Other',
    },
    stage: {
      precontemplation: 'Not yet considering a change',
      contemplation: 'Thinking about a change',
      action: 'Getting ready or making a change',
      maintenance: 'Keeping a change going',
    },
    // "Motivation — My changes" (MyChanges)
    list: {
      title: 'Motivational interviewing',
      intro: 'A change you are thinking about does not have to be a promise. Look at it from every side, at your own pace.',
      empty: 'Nothing here yet. Start with one change you are thinking about, in your own words.',
      add: "A change I'm thinking about",
      values: 'For: {{values}}',
      closedAs: 'Closed · {{outcome}}',
      loadError: 'Your changes could not be loaded. Check your connection and try again.',
    },
    // "Motivation — A change I'm thinking about" (SetChangeGoal)
    goal: {
      title: "A change I'm thinking about",
      intro: 'Put it in your own words. It is something to explore, not a commitment yet.',
      label: 'The change',
      labelPlaceholder: 'For example: Walk to work twice a week',
      values: 'What it matters for (optional)',
      valuesHint: 'Choose from your values, if you have sorted them.',
      noValues: 'Sort your values in Values to link them here.',
      save: 'Save',
      saved: 'Saved.',
      rename: 'Rename',
    },
    // "Motivation — The rulers" (RateChange)
    rulers: {
      title: 'The rulers',
      intro: 'Choose a number from 0 to 10 for each. There are no right numbers — they are your view today.',
      importanceQ: 'How important is this change to you right now?',
      confidenceQ: 'How confident are you that you could make it, if you decided to?',
      readinessQ: 'How ready are you to start now?',
      scaleLow: '0 · not at all',
      scaleHigh: '10 · completely',
      focus: 'Questions about:',
      focusHint: 'Tap another ruler to answer about that one instead.',
      whyNotLower: 'Why {{value}} and not 0?',
      whyNotLowerHint: 'What makes it this high already?',
      whatWouldRaise: 'What would take it to {{next}}?',
      noQuestions: 'With every ruler at the same end, there are no follow-up questions this time.',
      save: 'Save',
      saved: 'Your rulers are saved.',
    },
    // "Motivation — Pros and cons" (WriteDecisionalBalance) — the founder's box order (Q-rev-6 A)
    balance: {
      title: 'Pros and cons',
      intro: 'Be honest about both sides. Staying as you are has good sides too — writing them down helps.',
      prosOfStaying: 'Staying as I am · the good things',
      consOfStaying: 'Staying as I am · the not-so-good things',
      consOfChange: 'Changing · the not-so-good things',
      prosOfChange: 'Changing · the good things',
      linesHint: 'One per line',
      save: 'Save',
      saved: 'Your pros and cons are saved.',
    },
    // "Motivation — My change plan" (WriteChangePlan)
    plan: {
      title: 'My change plan',
      intro: 'When you feel ready, plan the change in small, concrete steps.',
      changes: 'What I will change',
      changesPlaceholder: 'For example: Walk to work on Tuesdays and Thursdays',
      reasons: 'My reasons',
      steps: 'The steps, and when',
      step: 'Step',
      when: 'When',
      addStep: '+ Add a step',
      helpers: 'Who can help',
      obstacles: 'What could get in the way, and what I will do then',
      obstacle: 'What could get in the way',
      response: 'What I will do then',
      addObstacle: '+ Add another',
      signsOfSuccess: 'How I will know it is working',
      toHomework: 'Add to my homework',
      remove: 'Remove',
      save: 'Save',
      saved: 'Your plan is saved.',
    },
    // "Motivation — Change talk (note)" (NoteChangeTalk)
    talk: {
      title: 'Change talk',
      intro: 'Noticed a reason to change, a wish, or a step you took? Write it down in your own words.',
      talk: 'What I noticed',
      placeholder: 'For example: I felt better on the morning I walked',
      kind: 'It was… (optional)',
      kinds: {
        desire: 'Something I want',
        ability: 'Something I can do',
        reason: 'A reason',
        need: 'Something I need',
        commitment: 'Something I will do',
        takingSteps: 'A step I took',
      },
      save: 'Save',
      saved: 'Saved to your journal.',
    },
    // "Motivation — My change" (ChangeJourney) with its Close and Reopen sections
    journey: {
      title: 'My change',
      values: 'For: {{values}}',
      rulers: 'The rulers over time',
      rulersEmpty: 'No ratings yet.',
      rulerLine: 'Importance {{importance}} · Confidence {{confidence}} · Readiness {{readiness}}',
      reasons: 'My reasons, in my words',
      reasonsEmpty: 'Your answers to "why not 0?" will appear here.',
      balance: 'Pros and cons',
      balanceEmpty: 'Not written yet.',
      plan: 'My change plan',
      planEmpty: 'No plan yet — make one when you feel ready.',
      journal: 'Change talk',
      journalEmpty: 'Lines you note will appear here.',
      urica: 'Stage of change: {{stage}} (readiness {{readiness}})',
      uricaTaken: 'Taken {{date}}, about change in general',
      uricaTake: 'How ready am I for change? (URICA questionnaire)',
      closedLine: 'Closed {{date}} · {{outcome}}',
      rate: 'Rate it',
      writeBalance: 'Pros and cons',
      writePlan: 'Change plan',
      noteTalk: 'Note change talk',
      loadError: 'This change could not be loaded. Go back and try again.',
    },
    close: {
      open: 'Close this change',
      title: 'Close this change',
      intro: 'Deciding not to change is a real answer too. It stays in your history, and you can reopen it at any time.',
      outcome: 'How it ended',
      note: 'A note (optional)',
      notePlaceholder: 'For example: Six weeks of walking to work',
      button: 'Close the change',
      cancel: 'Cancel',
      closed: 'The change is closed.',
    },
    reopen: {
      intro: 'Reopen it to carry on — the ratings, pros and cons, plan and notes stay with it.',
      button: 'Reopen',
      reopened: 'The change is open again.',
    },
    // the hub's Motivation section (portal — the E57 client page, Skills & exercises ▸ Motivation)
    hub: {
      title: 'Motivational interviewing',
      intro: 'The changes this client is thinking about, in their own words: the rulers over time, their reasons, the pros and cons and the plan.',
      empty: 'No change written down yet. You can write one down with the client in session.',
      notShared: 'This client does not share their own work with you.',
      loadError: 'The client’s changes could not be loaded. Refresh the page to try again.',
      setBy: 'Written down in session',
      rulers: 'The rulers',
      rulersEmpty: 'Not rated yet.',
      changeTalk: 'In their words',
      changeTalkEmpty: 'No answers yet.',
      journal: 'Change talk',
      balance: 'Pros and cons',
      plan: 'Change plan',
      closed: 'Closed {{date}} · {{outcome}}',
      urica: 'Stage of change (URICA): {{stage}}, readiness {{readiness}}',
      uricaTaken: 'Taken {{date}}, about change in general',
      date: 'Date',
      summary: 'Importance {{importance}} · Confidence {{confidence}} · Readiness {{readiness}} · {{date}}',
      goal: {
        title: 'Set a change with the client',
        intro: 'Write down the change the client is thinking about, in the client’s words.',
        label: 'The change',
        values: 'What it matters for (optional)',
        valuesHint: 'Choose from the client’s values.',
        save: 'Save',
        saved: 'The change is saved.',
      },
      assign: {
        title: 'Assign before the session',
        intro: 'Ask the client to rate a change, write the pros and cons, or make a plan before you meet.',
        what: 'What to do',
        changeRating: 'The three rulers',
        decisionalBalance: 'Pros and cons',
        changePlan: 'A change plan',
        goal: 'Which change',
        anyGoal: 'Any change',
        assignTitle: 'Title',
        defaultTitle: {
          changeRating: 'Before we meet: the three rulers',
          decisionalBalance: 'Before we meet: the pros and cons',
          changePlan: 'Before we meet: a change plan',
        },
        instructions: 'Instructions',
        defaultInstructions: {
          changeRating: 'Two minutes — and answer the "why not 0?" question.',
          decisionalBalance: 'Be honest about both sides: staying as you are and changing.',
          changePlan: 'Small, concrete steps, and what you will do if something gets in the way.',
        },
        due: 'Due',
        assign: 'Assign',
        saved: 'Assigned.',
      },
    },
  },
};
